
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2m4WS", function(module, exports) {

var $3hHGU = parcelRequire("3hHGU");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $jMyy4 = parcelRequire("jMyy4");


var $jpSPX = parcelRequire("jpSPX");


var $eiWUW = parcelRequire("eiWUW");

/* SmartSpaceOverview.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $I7hWB = parcelRequire("I7hWB");


var $kz1Yj = parcelRequire("kz1Yj");


var $5TGe2 = parcelRequire("5TGe2");


var $5UaUB = parcelRequire("5UaUB");


var $ep3mz = parcelRequire("ep3mz");


var $8rneB = parcelRequire("8rneB");


var $ixL26 = parcelRequire("ixL26");





var $dhfse = parcelRequire("dhfse");

/**
 * @generated SignedSource<<2f3628aec35e8ddf6d415b11e76e8b9b>>
 * @relayHash ec77e57f60aaa31511bd727f2f353f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f
const $74b7cbd9cf0b5f49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "ec77e57f60aaa31511bd727f2f353f97",
            "id": "fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f",
            "metadata": {},
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "operationKind": "query",
            "text": "query SmartSpaceOverviewCoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$74b7cbd9cf0b5f49$var$node.hash = "890c0d7ea56280006fd23fc1dd1199b3";
var $74b7cbd9cf0b5f49$export$2e2bcd8739ae039 = $74b7cbd9cf0b5f49$var$node;









var $jPACe = parcelRequire("jPACe");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $3oWMY = parcelRequire("3oWMY");




const $b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery = (0, $74b7cbd9cf0b5f49$export$2e2bcd8739ae039);
const $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT = 200;
const $b9c2fb682b28c513$export$4c3aaf664391b8c5 = ({ contentId: contentId, isAdmin: isAdmin, hasEmoji: hasEmoji })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)($b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "space-overview"
    });
    const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasPublishedCoverPicture } = (0, $3WPGR.getRendererCoverPictureInfo)(data, false);
    const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
    const draftCoverPicture = (0, $3WPGR.propertyToId)(properties.find((property)=>property?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT));
    const hasDraftCoverPicture = !!draftCoverPicture?.value?.id;
    const hasCoverPicture = hasDraftCoverPicture || hasPublishedCoverPicture;
    const hasRenderableCoverPicture = isAdmin ? hasCoverPicture : hasPublishedCoverPicture;
    const content = isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPACe.EditorPageCoverPictureEntry), {
        key: `${contentId}-${hasCoverPicture ? 'filled' : 'empty'}`,
        contentId: contentId,
        isPublishingContent: false,
        contentType: "page",
        userOffline: false,
        hasCoverPicture: hasCoverPicture,
        contentPropertyKey: hasDraftCoverPicture ? (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT : (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED,
        isSmartSpaceOverview: true,
        isUnpublishedDraft: false,
        isReadOnly: false,
        dynamicCoverImageHeight: $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT
    }) : hasPublishedCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        isSmartSpaceOverview: true,
        hasEmoji: hasEmoji
    }) : null;
    if (!hasRenderableCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false),
        className: (0, $hekY6.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-overview-cover-placeholder",
        className: (0, $hekY6.default)([
            $b9c2fb682b28c513$var$styles.placeholder
        ])
    }, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $b9c2fb682b28c513$var$styles.placeholderContent,
            isHovered && $b9c2fb682b28c513$var$styles.placeholderContentVisible
        ])
    }, content)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, content);
};
const $b9c2fb682b28c513$var$styles = {
    root: "_1mT5xdRAKS _0u2WMmrU95 _0jFU0VgZxp",
    placeholder: "_49OCfRdnbC _0bjKvDyzSk _1mT5xdWVPG _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _3CkH9oh8wg",
    placeholderContent: "_23rrnHTOoO _1YKVNsdnbC",
    placeholderContentVisible: "_1YKVNs7dHp"
};


/**
 * @generated SignedSource<<da327cc7727f78d9b8699df16d8996d2>>
 * @relayHash 7ed1e317e90fc777adf227a379521cab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7
const $97dc1b18f616085f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "body"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7ed1e317e90fc777adf227a379521cab",
            "id": "6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7",
            "metadata": {},
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation SmartSpaceOverviewSummaryUpdateMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{summary{body}}}}"
        }
    };
}();
$97dc1b18f616085f$var$node.hash = "c07da228d9ec183b11eb802e583c9e4e";
var $97dc1b18f616085f$export$2e2bcd8739ae039 = $97dc1b18f616085f$var$node;









var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $gC2EJ = parcelRequire("gC2EJ");


var $hz2oZ = parcelRequire("hz2oZ");


var $c8bBH = parcelRequire("c8bBH");


var $93fnf = parcelRequire("93fnf");


var $chu6R = parcelRequire("chu6R");


var $e3Wrf = parcelRequire("e3Wrf");


var $lpNn5 = parcelRequire("lpNn5");


var $7akNQ = parcelRequire("7akNQ");


var $4MnFz = parcelRequire("4MnFz");





var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");


var $86okN = parcelRequire("86okN");





var $2m4WS = parcelRequire("2m4WS");




function $75b7ce46cf4dcbf4$export$95779ae96ff09d4a({ durationMs: durationMs = 2000 } = {}) {
    const timeoutRef = (0, $cozmU.useRef)(null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        return function cleanup() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    function startLoading() {
        setIsLoading(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            setIsLoading(false);
        }, durationMs);
    }
    return [
        startLoading,
        isLoading
    ];
}


const $d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner = ({ body: body, spaceKey: spaceKey, isPinned: isPinned, onSave: onSave })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [editText, setEditText] = (0, $cozmU.useState)(body);
    const [vote, setVote] = (0, $cozmU.useState)(null);
    const [startRefresh, isRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>setIsHovered(false), []);
    const showFeedbackFlag = (0, $cozmU.useCallback)(()=>{
        showFlag({
            title: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagTitle),
            description: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const fireFeedbackEvent = (0, $cozmU.useCallback)((wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    wasHelpful: wasHelpful,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const fireEditedEvent = (0, $cozmU.useCallback)((previousBody, newBody)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'edited',
                actionSubject: 'text',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    previousSummaryLength: previousBody.length,
                    newSummaryLength: newBody.length,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const handleThumbsUp = (0, $cozmU.useCallback)(()=>{
        setVote('up');
        showFeedbackFlag();
        fireFeedbackEvent(true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleThumbsDown = (0, $cozmU.useCallback)(()=>{
        setVote('down');
        showFeedbackFlag();
        fireFeedbackEvent(false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleRefresh = (0, $cozmU.useCallback)(()=>{
        setVote(null);
        startRefresh();
    }, [
        startRefresh
    ]);
    const onEdit = (0, $cozmU.useCallback)(()=>{
        setEditText(body);
        setIsEditing(true);
    }, [
        body
    ]);
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        if (body !== editText) {
            fireEditedEvent(body, editText);
            onSave(editText);
        }
        setIsEditing(false);
    }, [
        body,
        editText,
        fireEditedEvent,
        onSave
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        setEditText(body);
        setIsEditing(false);
    }, [
        body
    ]);
    const onKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Escape') onCancel();
    }, [
        onCancel
    ]);
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "smart-space-overview-summary-edit",
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.editContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        value: editText,
        onChange: (e)=>setEditText(e.target.value),
        onKeyDown: onKeyDown,
        minimumRows: 3,
        resize: "vertical",
        testId: "smart-space-overview-summary-edit-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.editActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm),
        appearance: "default",
        onClick: onConfirm,
        testId: "smart-space-overview-summary-confirm-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel),
        appearance: "default",
        onClick: onCancel,
        testId: "smart-space-overview-summary-cancel-button"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "smart-space-overview-summary",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.summaryContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.summaryBody,
            "_26BoRwE2XL",
            isRefreshing && $d3f4a8c5a2c21120$var$styles.contentBlurred
        ])
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            opacity: isHovered ? 1 : 0,
            pointerEvents: isHovered ? 'auto' : 'none'
        },
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContainer,
            "_23rrnHTOoO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.edit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.edit),
        appearance: "subtle",
        spacing: "compact",
        onClick: onEdit,
        testId: "smart-space-overview-summary-edit-button"
    })), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshing,
        onClick: handleRefresh,
        testId: "smart-space-overview-summary-refresh-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsUp),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'up',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'up') handleThumbsUp();
        },
        testId: "smart-space-overview-summary-thumbs-up-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsDown),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'down',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'down') handleThumbsDown();
        },
        testId: "smart-space-overview-summary-thumbs-down-button"
    }))));
};
const $d3f4a8c5a2c21120$export$cb21a8674ed8fd22 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner, props));
const $d3f4a8c5a2c21120$export$54ca75a6425bb521 = ({ summaryData: summaryData, spaceKey: spaceKey })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const queryDocumentNode = (0, $86okN.toDocumentNode)((0, $2m4WS.SpaceOverviewSwitcherQuery));
    const [updateSummary] = (0, $308Wd.useMutationInterop)($d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation, {
        __callerPackage__: "space-overview"
    });
    const onSave = (0, $cozmU.useCallback)((newBody)=>{
        updateSummary({
            variables: {
                cloudId: cloudId,
                input: {
                    spaceKey: spaceKey,
                    summary: {
                        body: newBody
                    }
                }
            },
            optimisticResponse: {
                confluence_updateSmartSpaceOverview: {
                    success: true,
                    errors: null,
                    overview: {
                        summary: {
                            body: newBody
                        }
                    }
                }
            },
            update: (cache, { data: mutationData })=>{
                const updatedBody = mutationData?.confluence_updateSmartSpaceOverview?.overview?.summary?.body;
                if (updatedBody == null) return;
                cache.writeQuery({
                    query: queryDocumentNode,
                    variables: {
                        cloudId: cloudId,
                        spaceKey: spaceKey
                    },
                    data: {
                        confluence_smartSpaceOverview: {
                            __typename: 'ConfluenceSmartSpaceOverview',
                            summary: {
                                __typename: 'ConfluenceSmartSpaceOverviewSummary',
                                body: updatedBody
                            }
                        }
                    }
                });
            }
        });
    }, [
        cloudId,
        spaceKey,
        updateSummary,
        queryDocumentNode
    ]);
    const body = summaryData?.body;
    if (!body) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3f4a8c5a2c21120$export$cb21a8674ed8fd22, {
        body: body,
        spaceKey: spaceKey,
        isPinned: summaryData?.isPinned ?? false,
        onSave: onSave
    });
};
const $d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation = (0, $97dc1b18f616085f$export$2e2bcd8739ae039);
const $d3f4a8c5a2c21120$var$i18n = (0, $kSwu1.defineMessages)({
    edit: {
        id: "space-overview.smart-space-overview.summary.edit",
        defaultMessage: "Edit"
    },
    confirm: {
        id: "space-overview.smart-space-overview.summary.confirm",
        defaultMessage: "Confirm"
    },
    cancel: {
        id: "space-overview.smart-space-overview.summary.cancel",
        defaultMessage: "Cancel"
    },
    refresh: {
        id: "space-overview.smart-space-overview.summary.refresh",
        defaultMessage: "Refresh"
    },
    thumbsUp: {
        id: "space-overview.smart-space-overview.summary.thumbs-up",
        defaultMessage: "Good summary"
    },
    thumbsDown: {
        id: "space-overview.smart-space-overview.summary.thumbs-down",
        defaultMessage: "Bad summary"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
}); // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $d3f4a8c5a2c21120$var$summaryBodyLineHeightStyle = null;
const $d3f4a8c5a2c21120$var$actionsContainerTransitionStyle = null;
const $d3f4a8c5a2c21120$var$styles = {
    summaryContainer: "_1mT5xdRAKS",
    summaryBody: "_2sNsIgmnOE _1UtDYzy7kJ _1ANEUSlpBW",
    actionsContainer: "_3iDTPbQ4SZ _1mT5xdWVPG _2IhTondnbC _1OKFqYdnbC _0LQT5ENHnM _3CkH9oyaOy",
    actionsContent: "_3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7 _3YEZNOdnbC",
    editContainer: "_2mHwu81Y8M _0bjKvDKTcp _4FKVYE1Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0KLXru66of",
    editActions: "_2mHwu81Y8M _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT",
    contentBlurred: "_23rrnHOJ4z _1YKVNsVx3j _1pp6NdYbGa"
};


/* PopularQuestions.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $dinVW = parcelRequire("dinVW");


var $hdBxM = parcelRequire("hdBxM");


var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");





/* QuestionItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");








var $bLfHG = parcelRequire("bLfHG");














var $hBYtq = parcelRequire("hBYtq");





var $4aRua = parcelRequire("4aRua");




/* FollowUpQuestions.tsx generated by @compiled/babel-plugin v3.0.2 */ 














const $b8b7b04208de7a0b$var$FollowUpButton = ({ followUp: followUp, followUpPosition: followUpPosition, onFollowUp: onFollowUp })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onFollowUp(followUp, followUpPosition);
    }, [
        onFollowUp,
        followUp,
        followUpPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $b8b7b04208de7a0b$var$styles.followUpButton,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, followUp));
};
const $b8b7b04208de7a0b$export$9d9f2e3275d0d624 = ({ questions: questions, onFollowUp: onFollowUp })=>{
    if (questions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $b8b7b04208de7a0b$var$styles.followUpContainer
        ])
    }, questions.map((followUp, index)=>followUp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8b7b04208de7a0b$var$FollowUpButton, {
            key: followUp,
            followUp: followUp,
            followUpPosition: index,
            onFollowUp: onFollowUp
        }) : null));
};
const $b8b7b04208de7a0b$var$styles = {
    followUpContainer: "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNL7p2s",
    followUpButton: "_2mHwu82ADO _0bjKvD8fU6 _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _46hvQm2ADO _0xmtko2ADO _0LQT5E8HPE _03SyCP8HPE _0KLXrujOvk _0wOv4Q7zJH _2fwxA57p2s _1eOmH6o126"
};


/* RovoInput.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $etoPX = parcelRequire("etoPX");


var $f6cdQ = parcelRequire("f6cdQ");

const $bb5f5999bd84aada$export$995e9427a9b39595 = ({ onSend: onSend })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [value, setValue] = (0, $cozmU.useState)('');
    const handleSend = (0, $cozmU.useCallback)(()=>{
        if (value.trim()) {
            onSend(value.trim());
            setValue('');
        }
    }, [
        value,
        onSend
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
    }, [
        handleSend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $bb5f5999bd84aada$var$styles.rovoInputContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $bb5f5999bd84aada$var$styles.rovoIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        size: "xsmall",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "text",
        placeholder: formatMessage($bb5f5999bd84aada$var$i18n.askRovoPlaceholder),
        value: value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: handleKeyDown,
        className: (0, $hekY6.default)([
            $bb5f5999bd84aada$var$styles.rovoInput
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage($bb5f5999bd84aada$var$i18n.sendQuestion),
        appearance: "primary",
        shape: "circle",
        isDisabled: !value.trim(),
        onClick: handleSend
    }));
};
const $bb5f5999bd84aada$var$i18n = (0, $kSwu1.defineMessages)({
    askRovoPlaceholder: {
        id: "space-overview.smart-space-overview.popular-questions.ask-rovo-placeholder",
        defaultMessage: "Ask Rovo anything"
    },
    sendQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.send-question",
        defaultMessage: "Send question"
    }
});
const $bb5f5999bd84aada$var$styles = {
    rovoInputContainer: "_2mHwu82ADO _0bjKvDyzSk _4c065U8HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5E5zaO _03SyCP5zaO _0KLXrulfZc",
    rovoIcon: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoInput: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2xIroY98eZ _497WNwYbGa _2zndICT6kp _2sNsIgmnOE _2V7sgOdnbC _0KLXrujOvk _1UtDYzy7kJ _3AxjleKGUX"
};


/* SourcesSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $w6R6I = parcelRequire("w6R6I");








var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");











var $l8wPz = parcelRequire("l8wPz");


var $es2gJ = parcelRequire("es2gJ");


var $jdA6O = parcelRequire("jdA6O");





var $lsxnT = parcelRequire("lsxnT");





var $6M71K = parcelRequire("6M71K");


var $8V8zt = parcelRequire("8V8zt");

/* SourceItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $7vK9E = parcelRequire("7vK9E");














var $NlHoa = parcelRequire("NlHoa");


var $fxqZn = parcelRequire("fxqZn");

var $5lkNm = parcelRequire("5lkNm");

var $5k2zo = parcelRequire("5k2zo");

var $8OkvL = parcelRequire("8OkvL");

var $ldJ1U = parcelRequire("ldJ1U");

var $lb2PL = parcelRequire("lb2PL");

var $hQVHS = parcelRequire("hQVHS");

var $kKUMP = parcelRequire("kKUMP");

const $7781dafab97bcef1$var$iconOverrides = {
    Confluence: (0, $5lkNm.ConfluenceIcon),
    Jira: (0, $ldJ1U.JiraIcon),
    Loom: (0, $lb2PL.LoomIcon),
    Bitbucket: (0, $fxqZn.BitbucketIcon),
    Goals: (0, $5k2zo.GoalsIcon),
    Projects: (0, $hQVHS.ProjectsIcon),
    Teams: (0, $kKUMP.TeamsIcon),
    Home: (0, $8OkvL.HomeIcon)
};
const $7781dafab97bcef1$export$aa172d33ca929727 = ({ url: url, completeKey: completeKey })=>{
    if (completeKey) {
        const IconOverride = $7781dafab97bcef1$var$iconOverrides[completeKey];
        if (IconOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconOverride, {
            size: "xxsmall"
        });
    }
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        "data-testid": "app-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "16",
        height: "16",
        x: "0",
        y: "0",
        filter: $7781dafab97bcef1$var$isSvg(url) ? 'url(#changeFillColor)' : ''
    }));
};
const $7781dafab97bcef1$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};


const $d05f38054d846c18$export$64eb96c340cb75b = ({ source: source })=>{
    const { title: title, links: links, embeddedProduct: embeddedProduct, excerpt: excerpt } = source.content ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, (0, $7781dafab97bcef1$export$aa172d33ca929727)({
        url: links?.webui,
        completeKey: embeddedProduct
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "regular",
        maxLines: 1
    }, title)), excerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 2
    }, excerpt));
};
const $d05f38054d846c18$export$7432640a758da4b1 = ({ source: source })=>{
    const webui = source.content?.links?.webui;
    if (!webui) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: webui,
        rel: "noopener noreferrer",
        xcss: $d05f38054d846c18$var$styles.noUnderline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    }));
};
const $d05f38054d846c18$var$styles = {
    noUnderline: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};


const $1f92641a13bcc754$export$99bd007203d2166e = ({ sources: sources, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const validSources = (0, $cozmU.useMemo)(()=>sources.filter((source)=>source.content != null), [
        sources
    ]);
    const sourceUrls = (0, $cozmU.useMemo)(()=>validSources.flatMap((source)=>{
            const webui = source.content?.links?.webui;
            return webui ? [
                `${window.location.origin}${(0, $jlIaF.CONTEXT_PATH)}${webui}`
            ] : [];
        }), [
        validSources
    ]);
    const fireSourcesEvent = (0, $cozmU.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'popup',
                actionSubjectId: 'sources',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    sourceCount: validSources.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        questionPosition,
        validSources
    ]);
    const handleToggle = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        setIsOpen((prev)=>{
            fireSourcesEvent(prev ? 'collapsed' : 'expanded');
            return !prev;
        });
    }, [
        fireSourcesEvent
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        fireSourcesEvent('collapsed');
    }, [
        fireSourcesEvent
    ]);
    if (validSources.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1f92641a13bcc754$var$styles.triggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
                authFlow: "disabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1f92641a13bcc754$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.0",
                spread: "space-between",
                alignBlock: "center",
                xcss: $1f92641a13bcc754$var$styles.popupHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1f92641a13bcc754$var$styles.popupHeaderText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                weight: "medium"
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage($1f92641a13bcc754$var$i18n.closeSources),
                shape: "circle",
                onClick: handleClose
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                as: "ul",
                xcss: $1f92641a13bcc754$var$styles.sourcesList,
                space: "space.050"
            }, validSources.map((source, index)=>{
                const webui = source.content?.links?.webui;
                const absoluteUrl = webui ? `${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${webui}` : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                    key: source.content?.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    xcss: $1f92641a13bcc754$var$styles.sourceListItem,
                    onClick: (e)=>{
                        e.stopPropagation();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'link',
                                actionSubjectId: 'sourceLink',
                                source: 'smartSpaceOverview',
                                attributes: {
                                    moduleType: 'faq',
                                    spaceKey: spaceKey,
                                    questionPosition: questionPosition,
                                    sourceIndex: index,
                                    sourceProduct: source.content?.embeddedProduct ?? null
                                }
                            }
                        }).fire();
                        if (absoluteUrl) window.open(absoluteUrl, '_blank', 'noopener,noreferrer');
                    }
                }, absoluteUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
                    appearance: "block",
                    url: absoluteUrl,
                    showHoverPreview: false,
                    fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                            source: source
                        }),
                    ui: {
                        hideBackground: true,
                        hideElevation: true,
                        hidePadding: true
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.TitleBlock), {
                    maxLines: 1
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.SnippetBlock), {
                    maxLines: 2
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                    source: source
                })));
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                onClick: handleToggle,
                xcss: (0, $w6R6I.cx)($1f92641a13bcc754$var$styles.sourcesButton, isOpen && $1f92641a13bcc754$var$styles.sourcesButtonSelected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8V8zt.SourceLogoStack), {
                sources: sourceUrls
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium",
                weight: "medium",
                color: isOpen ? 'color.text.selected' : 'color.text.subtle'
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))))
    }));
};
const $1f92641a13bcc754$var$i18n = (0, $kSwu1.defineMessages)({
    sourcesCount: {
        id: "space-overview.smart-space-overview.popular-questions.sources-count",
        defaultMessage: "{count, plural, one {# Source} other {# Sources}}"
    },
    closeSources: {
        id: "space-overview.smart-space-overview.popular-questions.close-sources",
        defaultMessage: "Close sources"
    }
});
const $1f92641a13bcc754$var$styles = {
    sourcesButton: "_0bjKvD8fU6 _2mHwu81Y8M _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _2Zuz6Q2ADO _1Znuxb2ADO _0Of8r2Pgdg _1wydGWPgdg _0jFU0VuNcX _0KLXru66of _1UtDYzZpcK _1kk5Tkf7mX _0WKd3G4z3T _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT _1eOmH6o126",
    sourcesButtonSelected: "_3vBAKHrzt2 _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd",
    triggerWrapper: "_3iDTPbvbI6 _3YEZNOdnbC",
    popupContent: "_0bjKvDyzSk _0Of8r22ADO _1Znuxb8HPE _1wydGW5zaO _2Zuz6Q8HPE _39xV02BmSS _0NUa3rHakr _2WAcuGIZbP",
    popupHeader: "_1DCdHiFQfX",
    popupHeaderText: "_2Zuz6Q2ADO",
    sourcesList: "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2Zuz6QPgdg",
    sourceCard: "_30huDKYbGa _4bt5LAnQyn _2WAcuGnQyn _2fwxA5ecOK _39xV02N91d",
    sourceListItem: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _23rrnHo10F _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0wOv4Q7zJH _0KLXrujOvk _39xV02N91d _2fwxA5ecOK _1eOmH6o126"
};


/**
 * Tracks how long a user dwells on an expanded FAQ question.
 *
 * Measures two durations per expansion:
 *  - `dwellTimeMs`     — time the expanded content was visible in the viewport.
 *  - `expandDurationMs` — wall-clock time from expand to collapse.
 *
 * Both are capped at MAX_DWELL_DURATION_MS. A "dwelled" analytics event is
 * fired automatically when the expansion ends, tagged with an end reason:
 *  - `manualCollapse` — user clicked to close.
 *  - `switchQuestion` — another question was expanded.
 *  - `navigated`      — the component unmounted (e.g. page navigation).
 */ 





// Filter out stale expansions (e.g. user expanded a question and walked away).
const $20b6fea54848571f$var$MAX_DWELL_DURATION_MS = 300000;
const $20b6fea54848571f$export$d5c16baac6dcf544 = ({ isExpanded: isExpanded, expandedContentRef: expandedContentRef, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sessionRef = (0, $cozmU.useRef)(null);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isExpanded) return;
        const expandStart = Date.now();
        let accumulatedDwellMs = 0;
        let viewportEnteredAt = null;
        const computeMetrics = ()=>{
            let dwellTimeMs = accumulatedDwellMs;
            if (viewportEnteredAt != null) dwellTimeMs += Date.now() - viewportEnteredAt;
            return {
                dwellTimeMs: Math.min(dwellTimeMs, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS),
                expandDurationMs: Math.min(Date.now() - expandStart, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS)
            };
        };
        sessionRef.current = {
            manualCollapse: false,
            computeMetrics: computeMetrics
        };
        const node = expandedContentRef.current;
        let observer;
        let isInViewport = false;
        const pauseDwell = ()=>{
            if (viewportEnteredAt != null) accumulatedDwellMs += Date.now() - viewportEnteredAt;
            viewportEnteredAt = null;
        };
        const resumeDwell = ()=>{
            viewportEnteredAt = Date.now();
        };
        if (node) {
            observer = new IntersectionObserver(([entry])=>{
                isInViewport = entry.isIntersecting;
                if (entry.isIntersecting) // Only resume if the tab is currently visible
                {
                    if (document.visibilityState === 'visible') resumeDwell();
                } else pauseDwell();
            });
            observer.observe(node);
        }
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') pauseDwell();
            else if (isInViewport) resumeDwell();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            observer?.disconnect();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            const session = sessionRef.current;
            sessionRef.current = null;
            let endReason;
            if (!isMountedRef.current) endReason = 'navigated';
            else if (session?.manualCollapse) endReason = 'manualCollapse';
            else endReason = 'switchQuestion';
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'section',
                    actionSubjectId: 'expandedQuestion',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'faq',
                        spaceKey: spaceKey,
                        questionPosition: questionPosition,
                        dwellEndReason: endReason,
                        ...computeMetrics()
                    }
                }
            }).fire();
        };
    }, [
        isExpanded,
        expandedContentRef,
        spaceKey,
        questionPosition,
        createAnalyticsEvent
    ]);
    return {
        markManualCollapse: ()=>{
            if (!sessionRef.current) return null;
            sessionRef.current.manualCollapse = true;
            return sessionRef.current.computeMetrics();
        }
    };
};


const $01328549e0c14588$var$FeedbackButtons = ({ vote: vote, onVoteUp: onVoteUp, onVoteDown: onVoteDown, upLabel: upLabel, downLabel: downLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: upLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'up') onVoteUp();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'up'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: downLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'down') onVoteDown();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'down'
    }));
const $01328549e0c14588$var$QuestionHeader = ({ questionText: questionText, isExpanded: isExpanded, onToggle: onToggle, questionVote: questionVote, onVoteUp: onVoteUp, onVoteDown: onVoteDown })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.questionRow,
            isExpanded ? $01328549e0c14588$var$styles.questionRowExpanded : $01328549e0c14588$var$styles.questionRowCollapsed
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $01328549e0c14588$var$styles.questionTrigger,
        onClick: onToggle,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(isExpanded ? $01328549e0c14588$var$i18n.collapseQuestion : $01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.questionIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.questionText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, questionText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.questionFeedbackButtons,
            $01328549e0c14588$var$styles.hideQuestionActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: questionVote,
        onVoteUp: onVoteUp,
        onVoteDown: onVoteDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpQuestion),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownQuestion)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.chevron
        ])
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: formatMessage($01328549e0c14588$var$i18n.collapseQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage($01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    })));
};
const $01328549e0c14588$var$QuestionItemInner = ({ question: question, questionPosition: questionPosition, spaceKey: spaceKey, isExpanded: isExpanded, onToggle: onToggle, onFollowUp: onFollowUp, onAskRovo: onAskRovo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const [questionVote, setQuestionVote] = (0, $cozmU.useState)(null);
    const [answerVote, setAnswerVote] = (0, $cozmU.useState)(null);
    const expandedContentRef = (0, $cozmU.useRef)(null);
    const answerTextRef = (0, $cozmU.useRef)(null);
    const { markManualCollapse: markManualCollapse } = (0, $20b6fea54848571f$export$d5c16baac6dcf544)({
        isExpanded: isExpanded,
        expandedContentRef: answerTextRef,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    });
    const showFeedbackFlag = (0, $cozmU.useCallback)(()=>{
        showFlag({
            title: formatMessage($01328549e0c14588$var$i18n.feedbackFlagTitle),
            description: formatMessage($01328549e0c14588$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        const dwellMetrics = markManualCollapse();
        onToggle(question.question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: isExpanded ? 'questionCollapse' : 'questionExpand',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    ...dwellMetrics ?? {}
                }
            }
        }).fire();
    }, [
        onToggle,
        question.question,
        isExpanded,
        createAnalyticsEvent,
        questionPosition,
        spaceKey,
        markManualCollapse
    ]);
    const handleFollowUp = (0, $cozmU.useCallback)((followUpQuestion, followUpPosition)=>{
        onFollowUp?.(followUpQuestion, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'followUpQuestion',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    followUpPosition: followUpPosition
                }
            }
        }).fire();
    }, [
        onFollowUp,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleAskRovo = (0, $cozmU.useCallback)((message)=>{
        onAskRovo?.(message, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'askRovoSubmit',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    queryLength: message.length
                }
            }
        }).fire();
    }, [
        onAskRovo,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const fireFeedbackEvent = (0, $cozmU.useCallback)((actionSubjectId, wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: actionSubjectId,
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    wasHelpful: wasHelpful
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleQuestionThumbsUp = (0, $cozmU.useCallback)(()=>{
        setQuestionVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('question', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleQuestionThumbsDown = (0, $cozmU.useCallback)(()=>{
        setQuestionVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('question', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsUp = (0, $cozmU.useCallback)(()=>{
        setAnswerVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('answer', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsDown = (0, $cozmU.useCallback)(()=>{
        setAnswerVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('answer', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.cardWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($01328549e0c14588$var$QuestionHeader, {
        questionText: question.question,
        isExpanded: isExpanded,
        onToggle: handleToggle,
        questionVote: questionVote,
        onVoteUp: handleQuestionThumbsUp,
        onVoteDown: handleQuestionThumbsDown
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: expandedContentRef,
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.expandedContent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.sectionLabel
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage($01328549e0c14588$var$i18n.answerLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.answerActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $01328549e0c14588$var$styles.answerFeedbackButtons,
            $01328549e0c14588$var$styles.hideAnswerActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: answerVote,
        onVoteUp: handleAnswerThumbsUp,
        onVoteDown: handleAnswerThumbsDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpAnswer),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownAnswer)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1f92641a13bcc754$export$99bd007203d2166e), {
        sources: question.sources,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: answerTextRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, question.answer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8b7b04208de7a0b$export$9d9f2e3275d0d624), {
        questions: question.followUpQuestions,
        onFollowUp: handleFollowUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb5f5999bd84aada$export$995e9427a9b39595), {
        onSend: handleAskRovo
    }))));
};
const $01328549e0c14588$export$2f31fc0a7a44451 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($01328549e0c14588$var$QuestionItemInner, props));
const $01328549e0c14588$var$i18n = (0, $kSwu1.defineMessages)({
    expandQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.expand",
        defaultMessage: "Expand question: {question}"
    },
    collapseQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.collapse",
        defaultMessage: "Collapse question: {question}"
    },
    answerLabel: {
        id: "space-overview.smart-space-overview.popular-questions.answer-label",
        defaultMessage: "Answer"
    },
    thumbsUpQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up",
        defaultMessage: "Good question"
    },
    thumbsDownQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down",
        defaultMessage: "Bad question"
    },
    thumbsUpAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up-answer",
        defaultMessage: "Good answer"
    },
    thumbsDownAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down-answer",
        defaultMessage: "Bad answer"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
});
const $01328549e0c14588$var$styles = {
    cardWrapper: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _0KLXrunmFW",
    questionRow: "_2sNsIgmnOE _2V7sgOdnbC _1mT5xdRAKS _3iDTPbgBM8 _2iEGP2EeR8 _3NN0tO2YeA _0hPCNLDIqT _17lj8pFQfX _0wOv4Q7zJH _0KLXrunmFW _39xV02N91d _1UtDYzy7kJ _2fwxA57p2s _16J0vzdnbC _1eOmH6o126 _1P5Bli7dHp",
    questionRowExpanded: "_0bjKvDdnbC",
    questionRowCollapsed: "_0bjKvDyzSk",
    questionTrigger: "_49OCfRPgdg _1mT5xdWVPG _0KLXrujOvk",
    questionIcon: "_1xC2CJOskG _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0LQT5EkG2W _1pp6NdYbGa",
    questionText: "_1xC2CJJxkL _2Y7lL42ADO _4c065U5zaO _1mT5xdRAKS _4ouGXIdnbC _1pp6NdYbGa",
    questionFeedbackButtons: "_1xC2CJF3ls _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7 _3YEZNOdnbC",
    chevron: "_1xC2CJloBo _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _03SyCPkG2W _1pp6NdYbGa",
    expandedContent: "_4c065U5zaO _2Y7lL4kG2W _0KLXrunmFW _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _4m9mYidnbC _1VuOW07dHp",
    sectionLabel: "_0xmtko1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    answerActions: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _3TGfC9LRg7 _17lj8p1Y8M _3YEZNOdnbC",
    answerFeedbackButtons: "_3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7 _3YEZNOdnbC",
    hideQuestionActions: "_23rrnHOJ4z _1YKVNswieH",
    hideAnswerActions: "_23rrnHOJ4z _1YKVNsUIHg"
};








const $747111b28549b837$var$THRESHOLDS = [
    0,
    0.5,
    1.0
];
const $747111b28549b837$var$getThresholdLabel = (ratio)=>{
    if (ratio >= 1.0) return 'full';
    if (ratio >= 0.5) return 'half';
    return 'partial';
};
const $747111b28549b837$export$7fe9c12e9689f54b = ({ spaceKey: spaceKey, questionCount: questionCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sectionRef = (0, $cozmU.useRef)(null);
    const firedThresholdsRef = (0, $cozmU.useRef)(new Set());
    // questionCount may change when refetching data, but we only need the latest value
    // when the intersection fires — not as a trigger to re-observe.
    const questionCountRef = (0, $cozmU.useRef)(questionCount);
    questionCountRef.current = questionCount;
    (0, $cozmU.useEffect)(()=>{
        const node = sectionRef.current;
        if (!node) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry.isIntersecting) return;
            const label = $747111b28549b837$var$getThresholdLabel(entry.intersectionRatio);
            const thresholdLabels = [
                'partial',
                'half',
                'full'
            ];
            const currentIndex = thresholdLabels.indexOf(label);
            for(let i = 0; i <= currentIndex; i++){
                const threshold = thresholdLabels[i];
                if (!firedThresholdsRef.current.has(threshold)) {
                    firedThresholdsRef.current.add(threshold);
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'viewed',
                            actionSubject: 'module',
                            actionSubjectId: 'faq',
                            source: 'smartSpaceOverview',
                            attributes: {
                                moduleType: 'faq',
                                spaceKey: spaceKey,
                                questionCount: questionCountRef.current,
                                threshold: threshold
                            }
                        }
                    }).fire();
                }
            }
            if (firedThresholdsRef.current.size === thresholdLabels.length) observer.disconnect();
        }, {
            threshold: [
                ...$747111b28549b837$var$THRESHOLDS
            ]
        });
        observer.observe(node);
        return ()=>{
            observer.disconnect();
        };
    }, [
        spaceKey,
        createAnalyticsEvent
    ]);
    return {
        sectionRef: sectionRef
    };
};


const $b940e14642ad4976$export$5f1dbecc17d9b4ee = ({ faqData: faqData, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [expandedId, setExpandedId] = (0, $cozmU.useState)(null);
    const [startRefreshAll, isRefreshingAll] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const questionCount = faqData?.entries?.length ?? 0;
    const { sectionRef: sectionRef } = (0, $747111b28549b837$export$7fe9c12e9689f54b)({
        spaceKey: spaceKey,
        questionCount: questionCount
    });
    const handleToggle = (0, $cozmU.useCallback)((id)=>{
        setExpandedId((prev)=>prev === id ? null : id);
    }, []);
    const formatSourcesContext = (0, $cozmU.useCallback)((sources)=>{
        if (sources.length === 0) return '';
        const sourceLines = sources.map((source)=>`- [${source?.content?.title}](${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${source?.content?.links?.webui})`);
        return `\n\n${formatMessage($b940e14642ad4976$var$i18n.sourcesLabel)}\n${sourceLines.join('\n')}`;
    }, [
        formatMessage
    ]);
    const createSpaceContext = (0, $cozmU.useCallback)((parentQuestion)=>{
        const spaceOverviewUrl = `${window.location.origin}${(0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        })}`;
        const humanMessageContent = formatMessage($b940e14642ad4976$var$i18n.humanMessagePrompt, {
            link: spaceOverviewUrl,
            question: parentQuestion.question
        });
        const agentMessageContent = `${parentQuestion.answer}${formatSourcesContext(parentQuestion.sources)}`;
        return {
            human_message: {
                content: humanMessageContent
            },
            agent_message: {
                content: agentMessageContent
            }
        };
    }, [
        spaceKey,
        formatSourcesContext,
        formatMessage
    ]);
    const publishRovoChat = (0, $cozmU.useCallback)((questionText, parentQuestion)=>{
        const context = createSpaceContext(parentQuestion);
        publish({
            type: 'chat-new',
            source: 'space-overview-popular-questions',
            data: {
                name: questionText.substring(0, 30),
                dialogues: [
                    context
                ],
                prompt: questionText
            }
        });
    }, [
        publish,
        createSpaceContext
    ]);
    const handleFollowUp = (0, $cozmU.useCallback)((followUpQuestion, parentQuestion)=>publishRovoChat(followUpQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleAskRovo = (0, $cozmU.useCallback)((customQuestion, parentQuestion)=>publishRovoChat(customQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleRefreshAll = (0, $cozmU.useCallback)(()=>{
        // TODO: Implement refresh all questions
        setExpandedId(null);
        startRefreshAll();
    }, [
        startRefreshAll
    ]);
    if ((faqData?.entries?.length ?? 0) > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("section", {
        ref: sectionRef,
        "aria-label": formatMessage($b940e14642ad4976$var$i18n.heading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $b940e14642ad4976$var$styles.headingRow
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, formatMessage($b940e14642ad4976$var$i18n.heading)), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $b940e14642ad4976$var$styles.refreshAllButton,
            isRefreshingAll && $b940e14642ad4976$var$styles.refreshAllButtonVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
        label: formatMessage($b940e14642ad4976$var$i18n.refreshAll),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshingAll,
        onClick: handleRefreshAll,
        isTooltipDisabled: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isRefreshingAll && $b940e14642ad4976$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, faqData?.entries?.map((question, index)=>{
        const questionKey = question.question;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01328549e0c14588$export$2f31fc0a7a44451), {
            key: questionKey,
            question: question,
            isExpanded: expandedId === questionKey,
            onToggle: handleToggle,
            onFollowUp: handleFollowUp,
            onAskRovo: handleAskRovo,
            spaceKey: spaceKey,
            questionPosition: index
        });
    })))));
    return null;
};
const $b940e14642ad4976$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "space-overview.smart-space-overview.popular-questions.heading",
        defaultMessage: "Popular questions"
    },
    humanMessagePrompt: {
        id: "space-overview.smart-space-overview.popular-questions.human-message-prompt",
        defaultMessage: "Question about space {link}: {question}"
    },
    sourcesLabel: {
        id: "space-overview.smart-space-overview.popular-questions.sources-label",
        defaultMessage: "Sources:"
    },
    refreshAll: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-all",
        defaultMessage: "Refresh all questions"
    }
});
const $b940e14642ad4976$var$styles = {
    headingRow: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _2ZNnFJdnbC _0m7hE27dHp",
    refreshAllButton: "_23rrnHOJ4z _1YKVNsuss2",
    refreshAllButtonVisible: "_1YKVNs7dHp",
    contentBlurred: "_23rrnHOJ4z _1YKVNsVx3j _1pp6NdYbGa"
};


/* SmartSpaceOverviewHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $2eX69 = parcelRequire("2eX69");


var $gVrmv = parcelRequire("gVrmv");








var $ad7Ou = parcelRequire("ad7Ou");








var $4n1IT = parcelRequire("4n1IT");


var $k22Xw = parcelRequire("k22Xw");


var $6mKj3 = parcelRequire("6mKj3");





var $17wUi = parcelRequire("17wUi");

const $e1b54ae933da37d5$var$i18n = (0, $kSwu1.defineMessages)({
    feedbackButtonLabel: {
        id: "space-overview.smart-space-overview.feedback-button-label",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "space-overview.smart-space-overview.feedback-title",
        defaultMessage: "What do you think of the new Spaces overview?"
    },
    feedbackPreamble: {
        id: "space-overview.smart-space-overview.feedback-preamble",
        defaultMessage: "Help make it even better with your feedback."
    },
    organizedByRovo: {
        id: "space-overview.smart-space-overview.organized-by-rovo",
        defaultMessage: "Organized by Rovo"
    },
    popupDismissLabel: {
        id: "space-overview.smart-space-overview.popup-dismiss-label",
        defaultMessage: "Dismiss"
    },
    popupDescription: {
        id: "space-overview.smart-space-overview.popup-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "This is where your team's work comes together."
    },
    popupBullet1: {
        id: "space-overview.smart-space-overview.popup-bullet-1",
        defaultMessage: "See the summary of the space"
    },
    popupBullet2: {
        id: "space-overview.smart-space-overview.popup-bullet-2",
        defaultMessage: "Pin key documents"
    },
    popupBullet3: {
        id: "space-overview.smart-space-overview.popup-bullet-3",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Get answers to your team's most important questions"
    }
});
const $e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY = 'smart-space-overview-feedback-opened';
const $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID = '6b7a459d-eab0-4b18-b825-481b90b7a262';
const $e1b54ae933da37d5$var$FEEDBACK_SOURCE = 'smartSpaceOverviewHeader';
const $e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance).getItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY) === 'true';
    } catch  {
        return false;
    }
};
const $e1b54ae933da37d5$var$persistFeedbackCollectorOpened = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY, 'true');
    } catch  {}
};
const $e1b54ae933da37d5$export$2359131f9fa9ca50 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { displayName: displayName, userId: userId } = (0, $bQm3c.useSessionData)();
    const autoOpenTimeoutRef = (0, $cozmU.useRef)(null);
    const [isFeedbackCollectorOpen, setIsFeedbackCollectorOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const togglePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen((prev)=>!prev);
    }, []);
    const closePopup = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen(false);
    }, []);
    const openFeedbackCollector = (0, $cozmU.useCallback)(()=>{
        $e1b54ae933da37d5$var$persistFeedbackCollectorOpened();
        if (autoOpenTimeoutRef.current !== null) {
            window.clearTimeout(autoOpenTimeoutRef.current);
            autoOpenTimeoutRef.current = null;
        }
        setIsFeedbackCollectorOpen(true);
    }, []);
    const closeFeedbackCollector = (0, $cozmU.useCallback)(()=>{
        setIsFeedbackCollectorOpen(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0) <= 0) return;
        autoOpenTimeoutRef.current = window.setTimeout(()=>{
            autoOpenTimeoutRef.current = null;
            if (!$e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened()) openFeedbackCollector();
        }, (0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0));
        return ()=>{
            if (autoOpenTimeoutRef.current !== null) {
                window.clearTimeout(autoOpenTimeoutRef.current);
                autoOpenTimeoutRef.current = null;
            }
        };
    }, [
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $e1b54ae933da37d5$var$styles.overviewHeaderActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isPopupOpen,
        onClose: closePopup,
        placement: "bottom-start",
        offset: [
            0,
            -32
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                ...triggerProps,
                type: "button",
                onClick: togglePopup,
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                onFocus: ()=>setIsHovered(true),
                onBlur: ()=>setIsHovered(false),
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.organizedByRovo
                ])
            }, isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k22Xw.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                size: "xsmall",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.preload
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k22Xw.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.popupContent
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.popupHeader
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.popupHeaderLeft
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                size: "xsmall",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: formatMessage($e1b54ae933da37d5$var$i18n.popupDismissLabel),
                onClick: closePopup
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.popupBody
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
                className: (0, $hekY6.default)([
                    $e1b54ae933da37d5$var$styles.popupList
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet3))))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: openFeedbackCollector,
        testId: "smart-space-overview-feedback-button",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
                ...iconProps,
                spacing: "spacious",
                label: ""
            }),
        className: (0, $hekY6.default)([
            $e1b54ae933da37d5$var$styles.feedbackButton
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e1b54ae933da37d5$var$i18n.feedbackButtonLabel))), isFeedbackCollectorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        locale: locale,
        onClose: closeFeedbackCollector,
        onSubmit: closeFeedbackCollector,
        atlassianAccountId: userId || '',
        name: displayName || '',
        entrypointId: $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID,
        feedbackTitle: formatMessage($e1b54ae933da37d5$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($e1b54ae933da37d5$var$i18n.feedbackPreamble),
        additionalFields: [
            {
                id: $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID,
                value: $e1b54ae933da37d5$var$FEEDBACK_SOURCE
            }
        ]
    }));
};
const $e1b54ae933da37d5$var$styles = {
    overviewHeaderActions: "_2mHwu8kG2W _4c065U1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _4kiQYAp0Oa",
    organizedByRovo: "_2mHwu81Y8M _2sNsIgmnOE _2uo31fYbGa _30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbccYA _0hPCNLDIqT _1UtDYzKGUX _0wOv4Q7zJH _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    preload: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _39xV02HZdu _0jFU0VHZdu _1YKVNsdnbC _1pp6NdYbGa",
    feedbackButton: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065U1Y8M _2Y7lL42ADO _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc _1UtDYzy7kJ _0wOv4Q7zJH",
    popupContent: "_4FKVYE5zaO _1EqgXlsz7G",
    popupHeader: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0rIjyk2ADO",
    popupHeaderLeft: "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _1kk5Tkf7mX _1UtDYzy7kJ",
    popupBody: "_0rIjyk1Y8M",
    popupList: "_2sNsIg7NXe _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1UtDYzZpcK _0LQT5EkG2W"
};


/* SmartSpaceOverviewLogo.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $di8q4 = parcelRequire("di8q4");


var $Qlykt = parcelRequire("Qlykt");


var $eWwvy = parcelRequire("eWwvy");

const $c0f874fe2d27e0c7$var$i18n = (0, $kSwu1.defineMessages)({
    editSpaceLogoTooltip: {
        id: "space-overview.smart-space-overview.logo.edit-space-logo-tooltip",
        defaultMessage: "Edit space logo"
    }
});
const $c0f874fe2d27e0c7$export$36f67a5ef9dc0044 = ({ spaceKey: spaceKey, spaceId: spaceId, isAdmin: isAdmin, isPersonalSpace: isPersonalSpace, emoji: emoji, spaceIconPath: spaceIconPath })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [shouldRenderEditSpaceLogoDialog, setShouldRenderEditSpaceLogoDialog] = (0, $cozmU.useState)(false);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const onOpen = (0, $cozmU.useCallback)(()=>setIsOpen(true), []);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const handleIconClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'editSpaceDetails',
                source: 'smartSpaceOverview',
                containerType: 'space',
                containerId: spaceId,
                attributes: {
                    entryPoint: 'smartSpaceOverview',
                    spaceKey: spaceKey
                }
            }
        }).fire();
        setShouldRenderEditSpaceLogoDialog(true);
        onOpen();
    }, [
        createAnalyticsEvent,
        onOpen,
        spaceId,
        spaceKey
    ]);
    const renderEditSpaceLogoDialog = (0, $cozmU.useCallback)(()=>{
        setShouldRenderEditSpaceLogoDialog(true);
    }, []);
    const hasEmoji = Boolean(emoji);
    const hasIcon = hasEmoji || Boolean(spaceIconPath);
    if (!hasIcon) return null;
    const iconContent = hasEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        context: "spaceHeader",
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        renderResourcedEmoji: true,
        isPageTitleComponent: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        width: (0, $Qlykt.EMOJI_SIZE_LARGE),
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        src: `${(0, $jlIaF.CONTEXT_PATH)}${spaceIconPath}`,
        alt: "",
        "data-testid": "smart-space-overview-logo-icon",
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIcon
        ])
    });
    if (!isAdmin || isPersonalSpace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, iconContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        onClick: handleIconClick,
        onMouseEnter: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onBlur: ()=>setIsHovered(false),
        "aria-label": intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip),
        "data-testid": "smart-space-overview-logo-edit-button",
        type: "button",
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIconContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.iconWrapper
        ])
    }, iconContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $c0f874fe2d27e0c7$var$styles.editIconOverlay,
            isHovered && $c0f874fe2d27e0c7$var$styles.editIconOverlayVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }))))), shouldRenderEditSpaceLogoDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eWwvy.EditSpaceLogo), {
        spaceKey: spaceKey,
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        showSpaceNameField: false,
        entryPoint: "smartSpaceOverview"
    }));
};
const $c0f874fe2d27e0c7$var$styles = {
    spaceIcon: "_0bjKvDxpxF _3iDTPbvLZJ",
    editIconOverlay: "_23rrnH0bPn _0bjKvDxpxF _1mT5xdWVPG _0jFU0VN91d _39xV02N91d _2IhTonPgdg _3OE6xYPgdg _1YKVNsdnbC _0KLXruA5lS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    editIconOverlayVisible: "_1YKVNs7dHp",
    spaceIconContainer: "_4FKVYEPgdg _30huDKYbGa _2uo31fYbGa _0wOv4Q7zJH _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT",
    iconWrapper: "_1mT5xdRAKS _3iDTPbccYA",
    logoRoot: "_30huDKU8vT _0bjKvD70UD _3iDTPbccYA"
};


/**
 * @generated SignedSource<<88310f22e31f024870884e0ad937b0f4>>
 * @relayHash 028bc8cd44ccfe555825b862cac7175f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9
const $096db6ea15398f90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_refreshSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "028bc8cd44ccfe555825b862cac7175f",
            "id": "2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9",
            "metadata": {},
            "name": "TopLinksCardRefreshTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardRefreshTopLinksMutation($cloudId:ID!,$input:ConfluenceRefreshSmartSpaceOverviewInput!){confluence_refreshSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$096db6ea15398f90$var$node.hash = "8e825f319472bd53e49e1decd81de040";
var $096db6ea15398f90$export$2e2bcd8739ae039 = $096db6ea15398f90$var$node;


/**
 * @generated SignedSource<<2e70fc9c92e85942fa2ba0b08bee4eef>>
 * @relayHash c2729e34ecfb9542d89cbc2054efd8fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850
const $71c53debaf0f9345$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c2729e34ecfb9542d89cbc2054efd8fb",
            "id": "92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850",
            "metadata": {},
            "name": "TopLinksCardUpdateTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardUpdateTopLinksMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$71c53debaf0f9345$var$node.hash = "7c3c5220e6a36be3e1b0a3a57c4f0e9b";
var $71c53debaf0f9345$export$2e2bcd8739ae039 = $71c53debaf0f9345$var$node;















var $bI14T = parcelRequire("bI14T");





var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");







/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $gFEZF = parcelRequire("gFEZF");




const $fe608f906a4fdf3e$var$i18n = (0, $kSwu1.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.card.add",
        defaultMessage: "Add"
    }
});
const $fe608f906a4fdf3e$var$styles = {
    card: "_0bjKvDyzSk _4FKVYEkG2W _0KLXrunmFW",
    header: "_3iDTPbQ4SZ _0hPCNLDIqT _1DCdHi8HPE",
    titleGroup: "_2mHwu8gVvo _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0hPCNLDIqT",
    itemsRow: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE",
    itemWrapper: "_4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $fe608f906a4fdf3e$export$60332b2344f7fe41 = ({ title: title, count: count, maxCount: maxCount, onAdd: onAdd, actionButton: actionButton, children: children, renderItemWrapper: renderItemWrapper })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isAtCapacity = maxCount !== undefined && count !== undefined && count >= maxCount; // Use actionButton if provided, otherwise fall back to onAdd for backward compatibility
    const renderActionButton = ()=>{
        if (actionButton) return actionButton;
        if (onAdd) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
            label: formatMessage($fe608f906a4fdf3e$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isAtCapacity,
            onClick: onAdd
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fe608f906a4fdf3e$var$styles.card
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fe608f906a4fdf3e$var$styles.header
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fe608f906a4fdf3e$var$styles.titleGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "small"
    }, formatMessage(title))), renderActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $fe608f906a4fdf3e$var$styles.itemsRow
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return child;
        if (renderItemWrapper) return renderItemWrapper(child, index);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: child.key ?? index,
            className: (0, $hekY6.default)([
                $fe608f906a4fdf3e$var$styles.itemWrapper
            ])
        }, child);
    })));
};


function $708b3e73f2b8fa2a$export$c42d680a28a18ad7(links, linkId) {
    const idx = links.findIndex((l)=>l.id === linkId);
    if (idx === -1) return {
        nextLinks: links,
        didReorder: false
    };
    const link = links[idx];
    // When unpinning the last pinned item (nothing pinned after it), toggle in place.
    if (link.isPinned && !links.slice(idx + 1).some((l)=>l.isPinned)) return {
        nextLinks: links.map((l, i)=>i === idx ? {
                ...l,
                isPinned: false
            } : l),
        didReorder: false
    };
    // Both pin and unpin place the link right after the last pinned item.
    const newPinned = !link.isPinned;
    const without = links.filter((_, i)=>i !== idx);
    let insertAt = 0;
    for(let i = without.length - 1; i >= 0; i--)if (without[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    const updatedLink = {
        ...link,
        isPinned: newPinned
    };
    const nextLinks = [
        ...without.slice(0, insertAt),
        updatedLink,
        ...without.slice(insertAt)
    ];
    return {
        nextLinks: nextLinks,
        didReorder: insertAt !== idx
    };
}
function $708b3e73f2b8fa2a$export$9b320488069db95e(links, newLink, maxCount) {
    let insertAt = 0;
    for(let i = links.length - 1; i >= 0; i--)if (links[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    return [
        ...links.slice(0, insertAt),
        newLink,
        ...links.slice(insertAt)
    ].slice(0, maxCount);
}









var $fuSOM = parcelRequire("fuSOM");

















var $eJXnW = parcelRequire("eJXnW");


var $3W9OD = parcelRequire("3W9OD");

const $2d6c8d1397947730$var$i18n = (0, $kSwu1.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.link-picker.add",
        defaultMessage: "Add link"
    },
    disabledTooltip: {
        id: "space-overview.smart-space-overview.link-picker.disabled-tooltip",
        defaultMessage: "Max of 4 links. Remove one to add another."
    }
});
const $2d6c8d1397947730$var$POPUP_OFFSET = [
    0,
    8
];
const $2d6c8d1397947730$export$b665e181ecd1797 = ({ showPicker: showPicker = false, disabled: disabled = false, onLinkSubmit: onLinkSubmit, existingLinks: existingLinks = [], ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPickerOpen, setIsPickerOpen] = (0, $cozmU.useState)(showPicker);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const plugins = (0, $cozmU.useMemo)(()=>[
            new (0, $eJXnW.default)({
                searchProvider: searchProvider,
                activityClientEndpoint: `${window.location.origin}/gateway/api/graphql`
            })
        ], [
        searchProvider
    ]);
    const handleAddClick = (0, $cozmU.useCallback)(()=>{
        if (disabled) return;
        setIsPickerOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openLinkPicker',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        disabled
    ]);
    const handlePickerClose = (0, $cozmU.useCallback)(()=>{
        setIsPickerOpen(false);
        props.onCancel?.();
    }, [
        props
    ]);
    const handleSubmit = (0, $cozmU.useCallback)((payload)=>{
        const isDuplicate = existingLinks.some((link)=>link.url === payload.url);
        if (isDuplicate) {
            setIsPickerOpen(false);
            return;
        }
        let inputMethod = 'manual';
        if (payload.meta.inputMethod === 'manual') inputMethod = 'manual';
        else if (payload.data?.prefetch === true) inputMethod = 'suggestion';
        else inputMethod = 'search';
        onLinkSubmit?.({
            url: payload.url,
            title: payload.title ?? payload.displayText ?? payload.url,
            inputMethod: inputMethod
        });
        setIsPickerOpen(false);
        props.onSubmit?.(payload);
    }, [
        existingLinks,
        onLinkSubmit,
        props
    ]);
    const renderContent = (0, $cozmU.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuSOM.default), {
            ...props,
            plugins: plugins,
            onCancel: handlePickerClose,
            onSubmit: handleSubmit,
            onContentResize: update
        }), [
        props,
        plugins,
        handlePickerClose,
        handleSubmit
    ]);
    const renderTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
            label: formatMessage($2d6c8d1397947730$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: disabled,
            onClick: handleAddClick
        });
        if (disabled && formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)
        }, button);
        return button;
    }, [
        formatMessage,
        disabled,
        handleAddClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isPickerOpen,
        onClose: handlePickerClose,
        content: renderContent,
        trigger: renderTrigger,
        placement: "bottom-start",
        offset: $2d6c8d1397947730$var$POPUP_OFFSET,
        autoFocus: false
    });
};


/* LinkItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $4yYAm = parcelRequire("4yYAm");





var $4ez2K = parcelRequire("4ez2K");





var $lSQgn = parcelRequire("lSQgn");


var $i1t43 = parcelRequire("i1t43");


var $6jfBG = parcelRequire("6jfBG");


var $lW3nu = parcelRequire("lW3nu");


var $5P5VV = parcelRequire("5P5VV");





var $gBjHb = parcelRequire("gBjHb");







const $2a4c4438bdd7c14c$var$i18n = (0, $kSwu1.defineMessages)({
    pin: {
        id: "space-overview.smart-space-overview.link-item.pin",
        defaultMessage: "Pin"
    },
    unpin: {
        id: "space-overview.smart-space-overview.link-item.unpin",
        defaultMessage: "Unpin"
    },
    remove: {
        id: "space-overview.smart-space-overview.link-item.remove",
        defaultMessage: "Remove"
    }
});
/* Compiled css for the SmartCard wrapper — allows child selectors for internal element overrides */ const $2a4c4438bdd7c14c$var$smartCardWrapperStyle = null; /* Variant used when an IconTile is provided — hides SmartCard's own icon element */ 
const $2a4c4438bdd7c14c$var$smartCardWrapperStyleWithTile = null; /* Icon column: Smart Card’s layered link only covers the Card; DS Link opens the URL in a new tab */ 
const $2a4c4438bdd7c14c$var$iconColumnWrapperStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardContainerStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardTriggerStyles = null;
const $2a4c4438bdd7c14c$var$itemStyles = {
    outerWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w",
    row: "_0bjKvD8fU6 _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4c065UgVvo _2Y7lL42ADO _0wOv4Q7zJH _2puWMNo126 _1eOmH6o126",
    actions: "_2mHwu8FQfX _23rrnHrIJq _3YEZNOdnbC _3iDTPbYbGa _0hPCNLDIqT _1YKVNsdnbC",
    actionsVisible: "_2mHwu8FQfX _23rrnHrIJq _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _1YKVNs7dHp"
};
const $2a4c4438bdd7c14c$var$cardUiProps = {
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    /* TitleBlock anchorTarget is applied to the full-area LayeredLink <a> when this is true */ clickableContainer: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    hideActions: true
};
const $2a4c4438bdd7c14c$var$titleBlockSubtitle = [
    {
        name: (0, $4yYAm.ElementName).CreatedBy
    }
];
const $2a4c4438bdd7c14c$var$hoverCardActionOptions = {
    hide: false,
    exclude: [
        (0, $4yYAm.CardAction).AutomationAction,
        (0, $4yYAm.CardAction).ChangeStatusAction,
        (0, $4yYAm.CardAction).CopyLinkAction,
        (0, $4yYAm.CardAction).DownloadAction,
        (0, $4yYAm.CardAction).FollowAction,
        (0, $4yYAm.CardAction).PreviewAction,
        (0, $4yYAm.CardAction).RovoChatAction,
        (0, $4yYAm.CardAction).ViewAction
    ]
};
const $2a4c4438bdd7c14c$export$532cb6865ebe8946 = ({ link: link, onRemove: onRemove, onPin: onPin, isPinned: isPinned = false, docPosition: docPosition, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const pinnedAtRef = (0, $cozmU.useRef)(null); // Provide Top Docs attribution context to analytics events fired inside the
    // HoverCard popup (e.g. `smartLink clicked titleGoToLink`). Events fired
    // inside will carry this data in their context array, making hover preview
    // clicks attributable to the SmartSpaceOverview Top Docs module.
    const hoverCardAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            attributes: {
                originSpaceKey: spaceKey,
                originSpaceId: spaceId,
                spaceOverviewTopDocsPosition: docPosition
            }
        }), [
        docPosition,
        spaceKey,
        spaceId
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>setIsHovered(false), []);
    const handleFocus = (0, $cozmU.useCallback)(()=>setIsHovered(true), []);
    const handleBlur = (0, $cozmU.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) setIsHovered(false);
    }, []);
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const getContentType = (0, $cozmU.useCallback)(()=>{
        const cardState = store.getState()[link.url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    }, [
        store,
        link.url
    ]);
    const handlePin = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (isPinned) {
            const pinnedDurationMs = pinnedAtRef.current !== null ? Date.now() - pinnedAtRef.current : undefined;
            pinnedAtRef.current = null;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'unpinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        pinnedDurationMs: pinnedDurationMs,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        } else {
            pinnedAtRef.current = Date.now();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        previousPosition: docPosition,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        }
        onPin?.(link.id);
    }, [
        createAnalyticsEvent,
        getContentType,
        onPin,
        isPinned,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleRemove = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onRemove?.(link.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'removeDocButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        onRemove,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleLinkClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'topDoc',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        link.id,
        docPosition,
        spaceKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "link-item",
        xcss: $2a4c4438bdd7c14c$var$itemStyles.outerWrapper,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $2a4c4438bdd7c14c$var$itemStyles.row,
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: hoverCardAnalyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6jfBG.HoverCard), {
        url: link.url,
        actionOptions: $2a4c4438bdd7c14c$var$hoverCardActionOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _4ouGXIdnbC"
        ])
    }, link.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: link.icon,
        label: link.title,
        appearance: link.iconAppearance ?? 'gray',
        size: "large"
    }))), link.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC _11xLtQdnbC _1k1WZcdnbC _4bEMDQdnbC _1voHZBdnbC _3v8Xfm2ADO _1LQKoXdnbC _18eDQ1mnOE _3EPZd498eZ _0Q7yJGYbGa _29GtTt6wH8 _1fd8cBy7kJ _3lAI68f7mX _0Q0aYmYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.TitleBlock), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC _11xLtQdnbC _1k1WZcdnbC _4bEMDQdnbC _1voHZBdnbC _3v8Xfm2ADO _1LQKoXdnbC _2oxzi18fU6 _3aNPYOnQyn _26x1eNnQyn _3vwcMdDMqu _2AWMXjUF4f _39mK1CUF4f _0Q0aYmQ4SZ _4vNzJjDIqT _31kCwSDIqT _15FSPLdnbC _18eDQ1mnOE _3EPZd498eZ _0Q7yJGYbGa _29GtTt6wH8 _1fd8cBy7kJ _3lAI68f7mX"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.TitleBlock), {
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isPinned || isHovered ? $2a4c4438bdd7c14c$var$itemStyles.actionsVisible : $2a4c4438bdd7c14c$var$itemStyles.actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: isPinned ? (0, (/*@__PURE__*/$parcel$interopDefault($5P5VV))) : (0, (/*@__PURE__*/$parcel$interopDefault($lW3nu))),
        label: isPinned ? formatMessage($2a4c4438bdd7c14c$var$i18n.unpin) : formatMessage($2a4c4438bdd7c14c$var$i18n.pin),
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePin
    }), !isPinned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($2a4c4438bdd7c14c$var$i18n.remove),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleRemove
    }))));
};


/* TopLinksEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $9kaAZ = parcelRequire("9kaAZ");




const $b5b2252444058be7$export$d16cbb23892d5ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "58",
        height: "60",
        viewBox: "0 0 58 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5.37109 50.0781C5.37109 50.0781 30.9568 53.1209 44.1256 49.9399V3.60754C44.1256 3.60754 23.2435 8.72303 5.37109 3.33118C5.37109 3.33118 5.65298 50.2881 5.37109 50.0809V50.0781Z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 16.4585H10.8535V14.5239H38.6446V16.4585Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 23.2653H10.8535V21.3308H38.6446V23.2653Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 30.0749H10.8535V28.1404H38.6446V30.0749Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 36.8818H10.8535V34.9472H38.6446V36.8818Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M52.3777 50.0975C52.4883 49.4784 52.5463 48.8207 52.5463 48.1242C52.5463 47.4278 52.4883 46.7507 52.375 46.1261C51.7062 42.398 49.1139 40.0986 45.4825 39.5072C44.8634 39.4077 44.214 39.3552 43.5369 39.3552C42.8321 39.3552 42.155 39.4105 41.5111 39.5183C37.8769 40.1263 35.2902 42.4173 34.6186 46.1261C34.5053 46.7535 34.4473 47.4195 34.4473 48.1242C34.4473 48.829 34.5053 49.4784 34.6158 50.0975C35.2819 53.8008 37.8686 56.0973 41.5111 56.7053C42.155 56.8131 42.8321 56.8684 43.5369 56.8684C44.214 56.8684 44.8634 56.8159 45.4825 56.7164C49.1194 56.125 51.7145 53.8229 52.3777 50.0975Z",
        fill: "var(--ds-chart-blue-bolder-hovered, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M44.1254 39.3718C43.9319 39.3635 43.7357 39.358 43.5339 39.358C42.8292 39.358 42.1521 39.4132 41.5082 39.521C37.874 40.1263 35.2872 42.4201 34.6157 46.1289C34.5024 46.7562 34.4443 47.4223 34.4443 48.127C34.4443 48.8234 34.5024 49.4812 34.6129 50.1002C34.682 50.4788 34.7732 50.8381 34.881 51.1891C38.2609 50.9791 41.4474 50.5894 44.1226 49.9427V39.3718H44.1254Z",
        fill: "var(--ds-text-accent-blue-bolder, #123263)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.5754 49.2905H37.8438V47.3559H49.5754V49.2905Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.7432 54.1876V42.4588H44.6777V54.1876H42.7432Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }));


const $a0273ad7ea242640$export$9aefb52db43407b5 = ({ onSuggestDocs: onSuggestDocs, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $a0273ad7ea242640$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5b2252444058be7$export$d16cbb23892d5ea), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "medium",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a0273ad7ea242640$var$i18n.pinImportantDocs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $a0273ad7ea242640$var$styles.buttonWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: onSuggestDocs,
        isLoading: isLoading,
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9kaAZ))), {
                ...iconProps,
                label: ""
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a0273ad7ea242640$var$i18n.suggestDocs))));
const $a0273ad7ea242640$var$styles = {
    container: "_2Y7lL4kG2W _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02N91d",
    buttonWrapper: "_46hvQm2ADO"
};
const $a0273ad7ea242640$var$i18n = (0, $kSwu1.defineMessages)({
    pinImportantDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.pin-docs",
        defaultMessage: "Pin important docs here"
    },
    suggestDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.suggest-docs",
        defaultMessage: "Suggest docs"
    }
});


const $33f02f0950ddab6e$var$i18n = (0, $kSwu1.defineMessages)({
    topDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.title",
        defaultMessage: "Top docs"
    }
});
const $33f02f0950ddab6e$var$topLinksItemWrapperStyles = {
    itemWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC _1mT5xdRAKS _0yKXXaP6LB",
    itemWrapperHalf: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEiLlu _4ouGXIdnbC _1mT5xdRAKS _0yKXXaP6LB"
};
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS = 200;
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING = 'cubic-bezier(0.2, 0.85, 0.3, 1)';
const $33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE = 0.86;
const $33f02f0950ddab6e$var$maxCount = 4; /** Same URLs (multiset) as `next`, but row order follows `prev`. Refreshes `title` / `isPinned` from `next`. */ 
function $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, next) {
    if (prev.length === 0 || next.length === 0 || prev.length !== next.length) return next;
    const nextByUrl = new Map(next.map((l)=>[
            l.url,
            l
        ]));
    const prevSig = [
        ...prev.map((l)=>l.url)
    ].sort().join('\0');
    const nextSig = [
        ...next.map((l)=>l.url)
    ].sort().join('\0');
    if (prevSig !== nextSig) return next;
    return prev.map((p)=>{
        const n = nextByUrl.get(p.url);
        if (!n) return p;
        return {
            ...p,
            title: n.title,
            isPinned: n.isPinned
        };
    });
} /**
   * Builds update input with `topLinks.add` (see `topLinksUpdateMutationInput.types.ts` — Relay artifact
   * input type lags the schema for `topLinks`).
   */ 
function $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            add: {
                url: link.url,
                title: link.title,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `edit` → `ConfluenceEditTopLinkInput` (`url`, `isPinned` only — no `title`).
   */ 
function $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            edit: {
                url: link.url,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `remove` → `ConfluenceRemoveTopLinkInput`.
   */ 
function $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, url) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            remove: {
                url: url
            }
        }
    };
}
const $33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation = (0, $71c53debaf0f9345$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation = (0, $096db6ea15398f90$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$export$61bde326403f45f = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [commitUpdateTopLinks] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation, {
        __callerPackage__: "space-overview"
    });
    const [commitRefreshTopLinks, { loading: isRefreshLoading }] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation, {
        __callerPackage__: "space-overview"
    });
    const queryLinks = (0, $cozmU.useMemo)(()=>{
        const rawLinks = topLinks?.links;
        if (!rawLinks) return [];
        const mapped = rawLinks.reduce((acc, link)=>{
            if (link?.url && link?.title) acc.push({
                id: link.url,
                url: link.url,
                title: link.title,
                isPinned: link.isPinned ?? false
            });
            return acc;
        }, []);
        return mapped.slice(0, $33f02f0950ddab6e$var$maxCount);
    }, [
        topLinks
    ]);
    const [links, setLinks] = (0, $cozmU.useState)(queryLinks);
    const applyPayload = (0, $cozmU.useCallback)((payload, rollback, orderHint)=>{
        if (payload?.success) {
            const serverTopLinks = payload.overview?.topLinks;
            const list = serverTopLinks?.links?.filter((link)=>link != null && link.url != null && link.url !== '' && link.title != null);
            if (list != null && list.length > 0) {
                const fromServer = list.map((link)=>({
                        id: link.url,
                        url: link.url,
                        title: link.title,
                        subtitle: new URL(link.url).hostname,
                        isPinned: link.isPinned ?? false
                    }));
                const merged = orderHint != null ? $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(orderHint, fromServer) : fromServer;
                setLinks(merged);
            }
            return;
        }
        rollback();
    }, [
        setLinks
    ]);
    const applyTopLinksMutationResponse = (0, $cozmU.useCallback)((data, rollback, orderHint)=>{
        applyPayload(data?.confluence_updateSmartSpaceOverview, rollback, orderHint);
    }, [
        applyPayload
    ]);
    const linksRef = (0, $cozmU.useRef)(links);
    linksRef.current = links;
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const getContentType = (url)=>{
        const cardState = store.getState()[url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    };
    const isModuleHoveredRef = (0, $cozmU.useRef)(false);
    const handleModuleMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (isModuleHoveredRef.current) return;
        isModuleHoveredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                actionSubject: 'module',
                actionSubjectId: 'topDocsModule',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey
    ]);
    const handleModuleMouseLeave = (0, $cozmU.useCallback)(()=>{
        isModuleHoveredRef.current = false;
    }, []);
    const itemWrapperRefs = (0, $cozmU.useRef)(new Map());
    const prevItemRectsRef = (0, $cozmU.useRef)(new Map());
    const runTabReorderFlipRef = (0, $cozmU.useRef)(false);
    const primaryMotionLinkIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        setLinks((prev)=>$33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, queryLinks));
    }, [
        queryLinks
    ]);
    const isAtCapacity = links.length >= $33f02f0950ddab6e$var$maxCount;
    const handleAddLink = (linkData)=>{
        const newLink = {
            id: `${linkData.url}-${linkData.title}`,
            url: linkData.url,
            title: linkData.title,
            subtitle: new URL(linkData.url).hostname,
            isPinned: true
        };
        const nextLinks = (0, $708b3e73f2b8fa2a$export$9b320488069db95e)(links, newLink, $33f02f0950ddab6e$var$maxCount);
        runTabReorderFlipRef.current = true;
        primaryMotionLinkIdRef.current = newLink.id;
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, newLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id)), nextLinks)).catch(()=>{
            setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id));
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'submitLinkButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: newLink.id,
                    contentType: getContentType(linkData.url),
                    inputMethod: linkData.inputMethod,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleRemoveLink = (linkId)=>{
        const link = links.find((l)=>l.id === linkId);
        if (!link) return;
        const previousLinks = links;
        const afterRemove = previousLinks.filter((l)=>l.id !== linkId);
        setLinks(afterRemove);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, link.url)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), afterRemove)).catch(()=>{
            setLinks(previousLinks);
        });
    }; /** Pin and unpin both persist with `topLinks.edit` (`isPinned` true/false). */ 
    const handlePinLink = (linkId)=>{
        const previousLinks = links;
        const { nextLinks: nextLinks, didReorder: didReorder } = (0, $708b3e73f2b8fa2a$export$c42d680a28a18ad7)(previousLinks, linkId);
        const updatedLink = nextLinks.find((l)=>l.id === linkId);
        if (!updatedLink) return;
        if (didReorder) {
            runTabReorderFlipRef.current = true;
            primaryMotionLinkIdRef.current = linkId;
        }
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, updatedLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), nextLinks)).catch(()=>{
            setLinks(previousLinks);
        });
    };
    const handleSuggestDocs = (0, $cozmU.useCallback)(()=>{
        const variables = {
            cloudId: cloudId,
            input: {
                spaceKey: spaceKey,
                topLinks: {
                    overridePinned: false
                }
            }
        };
        commitRefreshTopLinks({
            variables: variables
        }).then(({ data: data })=>{
            applyPayload(data?.confluence_refreshSmartSpaceOverview, ()=>{});
        }).catch(()=>{});
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'suggestDocsButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        cloudId,
        spaceKey,
        commitRefreshTopLinks,
        applyPayload,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const currentRects = new Map();
        for (const link of links){
            const el = itemWrapperRefs.current.get(link.id);
            if (el) currentRects.set(link.id, el.getBoundingClientRect());
        }
        if (runTabReorderFlipRef.current) {
            runTabReorderFlipRef.current = false;
            const primaryMotionId = primaryMotionLinkIdRef.current;
            const elementsToAnimate = new Set();
            for (const link of links){
                const el = itemWrapperRefs.current.get(link.id);
                const prev = prevItemRectsRef.current.get(link.id);
                const curr = currentRects.get(link.id);
                if (!el || !prev || !curr) continue;
                const dx = prev.left - curr.left;
                const dy = prev.top - curr.top;
                if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
                    const isPrimaryMotionTile = primaryMotionId !== null && link.id === primaryMotionId;
                    const compress = isPrimaryMotionTile ? ` scale(${$33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE})` : '';
                    el.style.transition = 'none';
                    el.style.willChange = 'transform';
                    el.style.zIndex = isPrimaryMotionTile ? '3' : '2';
                    el.style.transform = `translate(${dx}px, ${dy}px)${compress}`;
                    elementsToAnimate.add(el);
                }
            }
            if (elementsToAnimate.size > 0) requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    for (const el of elementsToAnimate){
                        el.style.transition = `transform ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_MS}ms ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING}`;
                        el.style.transform = '';
                    }
                    window.setTimeout(()=>{
                        for (const el of elementsToAnimate){
                            el.style.transition = '';
                            el.style.transform = '';
                            el.style.willChange = '';
                            el.style.zIndex = '';
                        }
                        primaryMotionLinkIdRef.current = null;
                    }, $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS + 50);
                });
            });
            else primaryMotionLinkIdRef.current = null;
        }
        prevItemRectsRef.current = currentRects;
    }, [
        links
    ]);
    const renderTopLinkItemWrapperFull = (0, $cozmU.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $hekY6.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapper
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapperHalf = (0, $cozmU.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $hekY6.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapperHalf
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapper = isAtCapacity ? renderTopLinkItemWrapperHalf : renderTopLinkItemWrapperFull;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "top-links-module",
        onMouseEnter: handleModuleMouseEnter,
        onMouseLeave: handleModuleMouseLeave,
        onFocus: handleModuleMouseEnter,
        onBlur: handleModuleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe608f906a4fdf3e$export$60332b2344f7fe41), {
        title: $33f02f0950ddab6e$var$i18n.topDocs,
        count: links.length,
        maxCount: $33f02f0950ddab6e$var$maxCount,
        renderItemWrapper: renderTopLinkItemWrapper,
        actionButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d6c8d1397947730$export$b665e181ecd1797), {
            onLinkSubmit: handleAddLink,
            disabled: isAtCapacity,
            existingLinks: links
        })
    }, links.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0273ad7ea242640$export$9aefb52db43407b5), {
        onSuggestDocs: handleSuggestDocs,
        isLoading: isRefreshLoading
    }) : links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a4c4438bdd7c14c$export$532cb6865ebe8946), {
            key: link.id,
            link: link,
            onRemove: handleRemoveLink,
            onPin: handlePinLink,
            isPinned: link.isPinned,
            docPosition: index,
            spaceKey: spaceKey,
            spaceId: spaceId
        }))));
};
const $33f02f0950ddab6e$export$3e180c03b339583e = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const initialState = window['__SSR_TOP_DOCS__'];
    const storeData = (0, $btIEy.useStoreOptions)(initialState, (0, $i6Ps3.isPageSSRd)());
    const storeOptions = (0, $i6Ps3.isPageSSRd)() ? storeData : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        authFlow: "disabled",
        ...storeOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33f02f0950ddab6e$export$61bde326403f45f, {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }));
};


const $ca3580c7763f9e9f$export$56d49a1a95eb0a18 = ({ spaceKey: spaceKey, smartSpaceOverviewData: smartSpaceOverviewData, cloudId: cloudId })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const spaceOverviewQueryResult = (0, $jMyy4.useQueryInterop)((0, $ixL26.default), {
        variables: {
            spaceKey: spaceKey,
            excludeOperations: true
        },
        __callerPackage__: "space-overview"
    });
    const spaceData = spaceOverviewQueryResult.data;
    const isAdminLoading = spaceOverviewQueryResult.loading;
    const isAdmin = spaceData?.space?.currentUser?.isAdmin ?? false;
    const isPersonalSpace = spaceData?.space?.type === 'personal';
    const spaceId = spaceData?.space?.id ?? '';
    const spaceName = spaceData?.space?.name ?? '';
    const emoji = (0, $8rneB.getEmojiFromPublishedPageProperties)(spaceData?.space?.homepage ?? null);
    const spaceIconPath = spaceData?.space?.icon?.path;
    const hasEmoji = !!emoji || !!spaceIconPath;
    const topLinks = smartSpaceOverviewData.topLinks;
    if (!contentId || !spaceKey || isAdminLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $ca3580c7763f9e9f$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1b54ae933da37d5$export$2359131f9fa9ca50), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dhfse.RecommendedSpaceBannerLoader), {
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $ca3580c7763f9e9f$var$styles.coverWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9c2fb682b28c513$export$4c3aaf664391b8c5), {
        contentId: contentId,
        isAdmin: isAdmin,
        hasEmoji: hasEmoji
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $ca3580c7763f9e9f$var$styles.logoPositioner
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0f874fe2d27e0c7$export$36f67a5ef9dc0044), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        isAdmin: isAdmin,
        isPersonalSpace: isPersonalSpace,
        emoji: emoji,
        spaceIconPath: spaceIconPath
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $ca3580c7763f9e9f$var$styles.contentContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $ca3580c7763f9e9f$var$styles.titleSummarySection
        ])
    }, spaceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "xxlarge"
    }, spaceName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5UaUB.ConfluenceTeamButton), {
        containerId: (0, $5TGe2.ConfluenceSpaceAri).create({
            siteId: cloudId,
            spaceId: spaceId
        }).toString(),
        numberOfTeams: 1,
        orgId: cloudId
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3f4a8c5a2c21120$export$54ca75a6425bb521), {
        summaryData: smartSpaceOverviewData.summary,
        spaceKey: spaceKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33f02f0950ddab6e$export$3e180c03b339583e), {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b940e14642ad4976$export$5f1dbecc17d9b4ee), {
        faqData: smartSpaceOverviewData.faq,
        spaceKey: spaceKey
    })));
};
const $ca3580c7763f9e9f$var$styles = {
    container: "_4FKVYEp0Oa _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _2mHwu8Pgdg _0KLXrulfZc _0Of8r2dnbC _1EqgXlNy1d _3iDTPbQ4SZ _0aFT5vbt8w",
    coverWrapper: "_1mT5xdRAKS",
    logoPositioner: "_1mT5xdWVPG _0Bm75GPgdg _3OE6xYVa5s _1VJPcak9S3 _42Yu6B7dHp",
    contentContainer: "_2mHwu8Va5s _2Y7lL4Va5s _46hvQmmdCj _3iDTPbQ4SZ _0aFT5vbt8w",
    titleSummarySection: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w"
};


const $3bd39c5a85a3f0c2$export$d9d632754278a62e = (0, $3hHGU.default);
const $3bd39c5a85a3f0c2$export$145c4eaf64607c26 = ({ spaceKey: spaceKey, children: children, onExperienceResolved: onExperienceResolved })=>{
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const trackedResolvedExperienceRef = (0, $cozmU.useRef)(null);
    const smartSpaceOverviewEnabled = (0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        isRovoEnabled: isRovoEnabled,
        cloudId: cloudId
    });
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3bd39c5a85a3f0c2$export$d9d632754278a62e, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        skip: !smartSpaceOverviewEnabled,
        __callerPackage__: "space-overview"
    });
    const smartSpaceOverviewData = data?.confluence_smartSpaceOverview;
    const hasSummary = smartSpaceOverviewData?.summary?.body !== null && smartSpaceOverviewData?.summary?.body !== undefined;
    const resolvedExperience = smartSpaceOverviewEnabled ? loading ? null : hasSummary ? 'smart' : 'regular' : 'regular';
    (0, $cozmU.useEffect)(()=>{
        if (resolvedExperience) {
            onExperienceResolved?.(resolvedExperience);
            if (spaceId && trackedResolvedExperienceRef.current !== resolvedExperience) {
                trackedResolvedExperienceRef.current = resolvedExperience;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'resolved',
                        actionSubject: 'spaceOverviewExperience',
                        source: 'spaceOverviewScreen',
                        containerId: spaceId,
                        attributes: {
                            spaceOverviewExperience: resolvedExperience,
                            spaceKey: spaceKey
                        }
                    }
                }).fire();
            }
        }
    }, [
        createAnalyticsEvent,
        resolvedExperience,
        onExperienceResolved,
        spaceId,
        spaceKey
    ]);
    if (smartSpaceOverviewEnabled) {
        if (loading) return null;
        if (hasSummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca3580c7763f9e9f$export$56d49a1a95eb0a18), {
            spaceKey: spaceKey,
            smartSpaceOverviewData: smartSpaceOverviewData,
            cloudId: cloudId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiWUW.SpaceOverview), {
        spaceKey: spaceKey
    }, children);
};
module.exports["SpaceOverviewSwitcherQuery"] = $3bd39c5a85a3f0c2$export$d9d632754278a62e;
module.exports["SpaceOverviewSwitcher"] = $3bd39c5a85a3f0c2$export$145c4eaf64607c26;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<97883e4f3341dc8eee867b0d2022b8b6>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("jPACe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("ia6TK"));
        return EditorPageCoverPictureEntry;
    }
});
module.exports["EditorPageCoverPictureEntry"] = $4ff4f509ac781670$export$e8a47c72fec9e984;

});

parcelRegister("ia6TK", function(module, exports) {

let $d38e82f9cdcf7ed5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d38e82f9cdcf7ed5$var$load("dZulV"),
    $d38e82f9cdcf7ed5$var$load("dVM1q")
]).then(()=>parcelRequire('5tKh7'));

});

parcelRegister("8V8zt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $ivSJV = parcelRequire("ivSJV");

const $9f4445173e17ab12$export$bbe9fefbd7814f35 = 3;
const $9f4445173e17ab12$var$styles = {
    outerContainer: "_3iDTPbccYA _0hPCNLDIqT",
    overflowCount: "_2xTnZx1Y8M",
    container: "_3iDTPbccYA _0hPCNLDIqT _1mT5xdRAKS",
    logoWrapper: "_1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _0GTcwR4F84",
    firstLogo: "_0GTcwRLl21",
    logo: "_0bjKvDKTcp _2V7sgO2M4S _3hxITi6wH8 _3vBAKHxCOs _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02SPN1 _0jFU0VSPN1"
};
const $9f4445173e17ab12$export$3b2450ab8d88608 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { sources: sources, hideOverflowCount: t1 } = t0;
    const hideOverflowCount = t1 === undefined ? false : t1;
    if (sources.length === 0) return null;
    let T0;
    let T1;
    let overflowCount;
    let t2;
    let t3;
    let t4;
    if ($[0] !== sources) {
        const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $ivSJV.getSourceType))));
        const visibleSourceTypes = allUniqueSourceTypes.slice(0, $9f4445173e17ab12$export$bbe9fefbd7814f35);
        overflowCount = sources.length - visibleSourceTypes.length;
        T1 = (0, $iMnC5.Box);
        t4 = $9f4445173e17ab12$var$styles.outerContainer;
        T0 = (0, $iMnC5.Box);
        t2 = $9f4445173e17ab12$var$styles.container;
        t3 = visibleSourceTypes.map((sourceType, index)=>{
            const Logo = (0, $ivSJV.getLogoForSourceType)(sourceType);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: sourceType,
                xcss: (0, $w6R6I.cx)($9f4445173e17ab12$var$styles.logoWrapper, index === 0 && $9f4445173e17ab12$var$styles.firstLogo),
                style: {
                    zIndex: visibleSourceTypes.length - index
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $9f4445173e17ab12$var$styles.logo
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
                size: "xxsmall"
            })));
        });
        $[0] = sources;
        $[1] = T0;
        $[2] = T1;
        $[3] = overflowCount;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[1];
        T1 = $[2];
        overflowCount = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t2 || $[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t2
        }, t3);
        $[7] = T0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== hideOverflowCount || $[12] !== overflowCount) {
        t6 = !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9f4445173e17ab12$var$styles.overflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, "+", overflowCount));
        $[11] = hideOverflowCount;
        $[12] = overflowCount;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== T1 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            xcss: t4
        }, t5, t6);
        $[14] = T1;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ sources: sources, hideOverflowCount: hideOverflowCount = false })=>{
    if (sources.length === 0) return null;
    const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $ivSJV.getSourceType))));
    const visibleSourceTypes = allUniqueSourceTypes.slice(0, $9f4445173e17ab12$export$bbe9fefbd7814f35);
    const overflowCount = sources.length - visibleSourceTypes.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.outerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.container
    }, visibleSourceTypes.map((sourceType, index)=>{
        const Logo = (0, $ivSJV.getLogoForSourceType)(sourceType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: sourceType,
            xcss: (0, $w6R6I.cx)($9f4445173e17ab12$var$styles.logoWrapper, index === 0 && $9f4445173e17ab12$var$styles.firstLogo),
            style: {
                zIndex: visibleSourceTypes.length - index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9f4445173e17ab12$var$styles.logo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
            size: "xxsmall"
        })));
    })), !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9f4445173e17ab12$var$styles.overflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, "+", overflowCount)));
};
module.exports["MAX_VISIBLE_LOGOS"] = $9f4445173e17ab12$export$bbe9fefbd7814f35;
module.exports["SourceLogoStack"] = $9f4445173e17ab12$export$3b2450ab8d88608;

});

parcelRegister("ivSJV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $NlHoa = parcelRequire("NlHoa");


var $fxqZn = parcelRequire("fxqZn");


var $5lkNm = parcelRequire("5lkNm");


var $5k2zo = parcelRequire("5k2zo");


var $8OkvL = parcelRequire("8OkvL");


var $ldJ1U = parcelRequire("ldJ1U");


var $lb2PL = parcelRequire("lb2PL");


var $hQVHS = parcelRequire("hQVHS");


var $kKUMP = parcelRequire("kKUMP");


var $eaD9b = parcelRequire("eaD9b");

/** Fallback icon for unrecognized source URLs. */ const $96c73bee20ad6a6c$var$UnknownIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
            appearance: "neutral",
            label: "",
            size: "xxsmall"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
const $96c73bee20ad6a6c$var$SlackSourceIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaD9b.SlackIcon), {
            label: label,
            size: size,
            testId: testId
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ label: label = '', size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaD9b.SlackIcon), {
        label: label,
        size: size,
        testId: testId
    });
const $96c73bee20ad6a6c$var$LogoMap = {
    jira: (0, $ldJ1U.JiraIcon),
    confluence: (0, $5lkNm.ConfluenceIcon),
    bitbucket: (0, $fxqZn.BitbucketIcon),
    loom: (0, $lb2PL.LoomIcon),
    goals: (0, $5k2zo.GoalsIcon),
    projects: (0, $hQVHS.ProjectsIcon),
    teams: (0, $kKUMP.TeamsIcon),
    home: (0, $8OkvL.HomeIcon),
    slack: $96c73bee20ad6a6c$var$SlackSourceIcon,
    unknown: $96c73bee20ad6a6c$var$UnknownIcon
};
function $96c73bee20ad6a6c$export$369d94b7632e2acd(source) {
    const lowerSource = source.toLowerCase();
    if (lowerSource.includes('/browse/') || lowerSource.includes('/jira/')) return 'jira';
    if (lowerSource.includes('/wiki/')) return 'confluence';
    if (lowerSource.includes('bitbucket')) return 'bitbucket';
    if (lowerSource.includes('loom.com')) return 'loom';
    if (lowerSource.includes('slack.com')) return 'slack';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/goal/')) return 'goals';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/project/')) return 'projects';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/people/')) return 'teams';
    if (lowerSource.includes('home.atlassian.com')) return 'home';
    return 'unknown';
}
function $96c73bee20ad6a6c$export$70ffc3122e8f5e93(sourceType) {
    return $96c73bee20ad6a6c$var$LogoMap[sourceType];
}
module.exports["getSourceType"] = $96c73bee20ad6a6c$export$369d94b7632e2acd;
module.exports["getLogoForSourceType"] = $96c73bee20ad6a6c$export$70ffc3122e8f5e93;

});

parcelRegister("5k2zo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Goals" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GoalsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GoalsIcon"] = $ad20b5467f7f9ada$export$9eb74917ea768ed4;

});

parcelRegister("8OkvL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $9255a8fd6323cfc1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
const $9255a8fd6323cfc1$export$92c8767b874048d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HomeIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Home" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $9255a8fd6323cfc1$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function HomeIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $9255a8fd6323cfc1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["HomeIcon"] = $9255a8fd6323cfc1$export$92c8767b874048d;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("kKUMP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $1576217052e14df9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
const $1576217052e14df9$export$1bcbc9c337da86da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Teams" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $1576217052e14df9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function TeamsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $1576217052e14df9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TeamsIcon"] = $1576217052e14df9$export$1bcbc9c337da86da;

});

parcelRegister("eaD9b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f1e3e940f48d4af1e2408b9fcc279f6>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $c603a4426daa4a03$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#e01e5a" fill-rule="evenodd" d="M15.327 27.97a3.151 3.151 0 1 1-6.303 0 3.15 3.15 0 0 1 3.152-3.154h3.151zm1.574 0a3.15 3.15 0 0 1 3.151-3.154 3.15 3.15 0 0 1 3.152 3.154v7.881a3.15 3.15 0 0 1-3.152 3.154 3.15 3.15 0 0 1-3.151-3.154z" clip-rule="evenodd"/><path fill="#36c5f0" fill-rule="evenodd" d="M20.052 15.307a3.15 3.15 0 0 1-3.151-3.154A3.15 3.15 0 0 1 20.052 9a3.15 3.15 0 0 1 3.152 3.153v3.154zm0 1.598a3.15 3.15 0 0 1 3.152 3.153 3.15 3.15 0 0 1-3.152 3.154h-7.9A3.15 3.15 0 0 1 9 20.058a3.15 3.15 0 0 1 3.152-3.153z" clip-rule="evenodd"/><path fill="#2eb67d" fill-rule="evenodd" d="M32.679 20.058a3.15 3.15 0 0 1 3.151-3.153 3.15 3.15 0 0 1 3.152 3.153 3.15 3.15 0 0 1-3.152 3.154h-3.15zm-1.574 0a3.15 3.15 0 0 1-3.151 3.154 3.15 3.15 0 0 1-3.152-3.154v-7.905A3.15 3.15 0 0 1 27.954 9a3.15 3.15 0 0 1 3.151 3.153z" clip-rule="evenodd"/><path fill="#ecb22e" fill-rule="evenodd" d="M27.954 32.698a3.15 3.15 0 0 1 3.151 3.153 3.15 3.15 0 0 1-3.151 3.154 3.15 3.15 0 0 1-3.152-3.154v-3.153zm0-1.575a3.15 3.15 0 0 1-3.152-3.153 3.15 3.15 0 0 1 3.152-3.154h7.9a3.15 3.15 0 0 1 3.152 3.154 3.15 3.15 0 0 1-3.152 3.153z" clip-rule="evenodd"/></svg>';
function $c603a4426daa4a03$export$b33fb54b08bb6422({ size: size, label: label = 'Slack', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $c603a4426daa4a03$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["SlackIcon"] = $c603a4426daa4a03$export$b33fb54b08bb6422;

});

parcelRegister("bD1F5", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $4c67a4021f7bef2b$var$glyphStyles = null;
const $4c67a4021f7bef2b$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $4c67a4021f7bef2b$var$updatedHexagonSizeStyles = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    xsmall: "_39xV029oBa _0jFU0VDwJf",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV026W6Q _0jFU0VoFHQ"
};
const $4c67a4021f7bef2b$var$updatedHexagonClipPath = null;
const $4c67a4021f7bef2b$var$hexagonRootStyles = null;
const $4c67a4021f7bef2b$var$hexagonStyles = null;
const $4c67a4021f7bef2b$var$hexagonBorderStyles = null;
const $4c67a4021f7bef2b$var$hexagonContentStyles = null;
const $4c67a4021f7bef2b$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $4c67a4021f7bef2b$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $4c67a4021f7bef2b$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($4c67a4021f7bef2b$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $4c67a4021f7bef2b$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $4c67a4021f7bef2b$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $4c67a4021f7bef2b$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$4c67a4021f7bef2b$var$namespaceSvgIds(markup, $4c67a4021f7bef2b$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            !UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$hexagonSizeStyles[size],
            UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$updatedHexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8",
                UNSAFE_isUpdatedGeometry && "_1uo2ZfEXe0"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrut28M _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $4c67a4021f7bef2b$export$96b07167eb29fb14;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("lXV4d"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("lXV4d", function(module, exports) {

let $ffdb5ffe164d52e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffdb5ffe164d52e8$var$load("hhss7"),
    $ffdb5ffe164d52e8$var$load("kyxdN")
]).then(()=>parcelRequire('asonV'));

});

parcelRegister("fuSOM", function(module, exports) {

var $eRn3r = parcelRequire("eRn3r");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("40bvE")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02oEu0"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02oEu0"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRn3r.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $03RpJ.default)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8ad800c149f887c26cf6e1c701c20ed0>>
 * @codegenCommand afm workspace @atlaskit/link-picker codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
    whiteSpaceNormal: "_1ANEUSzUZr"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("cocSb")),
    da: ()=>(parcelRequire("8hHUq")),
    de: ()=>(parcelRequire("6xY5a")),
    en_GB: ()=>(parcelRequire("9S69a")),
    en_ZZ: ()=>(parcelRequire("7p3RA")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("1ijPU")),
    fi: ()=>(parcelRequire("hgktU")),
    fr: ()=>(parcelRequire("2X88N")),
    hu: ()=>(parcelRequire("gVpg0")),
    it: ()=>(parcelRequire("iDF1E")),
    ja: ()=>(parcelRequire("94sol")),
    ko: ()=>(parcelRequire("kaacA")),
    nb: ()=>(parcelRequire("6fz2I")),
    nl: ()=>(parcelRequire("jA2SL")),
    pl: ()=>(parcelRequire("hzJqW")),
    pt_BR: ()=>(parcelRequire("hoKfB")),
    ru: ()=>(parcelRequire("imEOn")),
    sv: ()=>(parcelRequire("cGIqm")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("5ZmT8")),
    zh: ()=>(parcelRequire("iDdpg"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("cocSb", function(module, exports) {

let $9051b633a19cf27b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9051b633a19cf27b$var$load("1JYrd"),
    $9051b633a19cf27b$var$load("cip6w"),
    $9051b633a19cf27b$var$load("gAG2n"),
    $9051b633a19cf27b$var$load("3feYV"),
    $9051b633a19cf27b$var$load("cwjU2"),
    $9051b633a19cf27b$var$load("7rL7C"),
    $9051b633a19cf27b$var$load("3Ff1R"),
    $9051b633a19cf27b$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("8hHUq", function(module, exports) {

let $6081f8b0ed39508c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6081f8b0ed39508c$var$load("30242"),
    $6081f8b0ed39508c$var$load("3qBwQ"),
    $6081f8b0ed39508c$var$load("cYGDU"),
    $6081f8b0ed39508c$var$load("7Q1SM"),
    $6081f8b0ed39508c$var$load("33Iaa"),
    $6081f8b0ed39508c$var$load("1RSxn"),
    $6081f8b0ed39508c$var$load("blA7x"),
    $6081f8b0ed39508c$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("6xY5a", function(module, exports) {

let $4c446e418128a786$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c446e418128a786$var$load("15aAJ"),
    $4c446e418128a786$var$load("8rREG"),
    $4c446e418128a786$var$load("dgXJL"),
    $4c446e418128a786$var$load("7JdzX"),
    $4c446e418128a786$var$load("6681T"),
    $4c446e418128a786$var$load("ghT31"),
    $4c446e418128a786$var$load("3dn3H"),
    $4c446e418128a786$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("9S69a", function(module, exports) {

let $72fdecd9dd738c1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $72fdecd9dd738c1c$var$load("l5BBd"),
    $72fdecd9dd738c1c$var$load("93ASN"),
    $72fdecd9dd738c1c$var$load("htu5t"),
    $72fdecd9dd738c1c$var$load("24LNf"),
    $72fdecd9dd738c1c$var$load("lM2G0"),
    $72fdecd9dd738c1c$var$load("iYQCc"),
    $72fdecd9dd738c1c$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("7p3RA", function(module, exports) {

let $563ddd59fb0fa745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $563ddd59fb0fa745$var$load("bbv9t"),
    $563ddd59fb0fa745$var$load("9fQoJ"),
    $563ddd59fb0fa745$var$load("lTboH"),
    $563ddd59fb0fa745$var$load("cnlNg"),
    $563ddd59fb0fa745$var$load("d3Phe"),
    $563ddd59fb0fa745$var$load("lTP5S"),
    $563ddd59fb0fa745$var$load("lASLx"),
    $563ddd59fb0fa745$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("1ijPU", function(module, exports) {

let $0f16dbf23003f2e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f16dbf23003f2e3$var$load("7p4je"),
    $0f16dbf23003f2e3$var$load("8SZbD"),
    $0f16dbf23003f2e3$var$load("iE05k"),
    $0f16dbf23003f2e3$var$load("9Uf61"),
    $0f16dbf23003f2e3$var$load("3Yk1e"),
    $0f16dbf23003f2e3$var$load("jZqyp"),
    $0f16dbf23003f2e3$var$load("5lJyy"),
    $0f16dbf23003f2e3$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("hgktU", function(module, exports) {

let $c913d17b53ae571b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c913d17b53ae571b$var$load("1jQRQ"),
    $c913d17b53ae571b$var$load("5pOQA"),
    $c913d17b53ae571b$var$load("5GSny"),
    $c913d17b53ae571b$var$load("fJSEb"),
    $c913d17b53ae571b$var$load("ajzkj"),
    $c913d17b53ae571b$var$load("kIcDP"),
    $c913d17b53ae571b$var$load("eyysG"),
    $c913d17b53ae571b$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("2X88N", function(module, exports) {

let $2267680e8ed7bae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2267680e8ed7bae6$var$load("km37l"),
    $2267680e8ed7bae6$var$load("gbksI"),
    $2267680e8ed7bae6$var$load("j2X7f"),
    $2267680e8ed7bae6$var$load("9TeWr"),
    $2267680e8ed7bae6$var$load("kUZ7k"),
    $2267680e8ed7bae6$var$load("8e8NT"),
    $2267680e8ed7bae6$var$load("dJQL7"),
    $2267680e8ed7bae6$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("gVpg0", function(module, exports) {

let $c5258fc18afd6137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5258fc18afd6137$var$load("lTbXI"),
    $c5258fc18afd6137$var$load("a98cw"),
    $c5258fc18afd6137$var$load("e40mE"),
    $c5258fc18afd6137$var$load("fOGnR"),
    $c5258fc18afd6137$var$load("cDQOq"),
    $c5258fc18afd6137$var$load("gznax"),
    $c5258fc18afd6137$var$load("8upye"),
    $c5258fc18afd6137$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("iDF1E", function(module, exports) {

let $038072583318b171$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $038072583318b171$var$load("iUyZj"),
    $038072583318b171$var$load("4PDaO"),
    $038072583318b171$var$load("lMhbw"),
    $038072583318b171$var$load("8nEeY"),
    $038072583318b171$var$load("kLZKK"),
    $038072583318b171$var$load("2gIpG"),
    $038072583318b171$var$load("c7GMc"),
    $038072583318b171$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("94sol", function(module, exports) {

let $69aa82c635856cdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69aa82c635856cdf$var$load("kPlMQ"),
    $69aa82c635856cdf$var$load("ervs7"),
    $69aa82c635856cdf$var$load("8CX31"),
    $69aa82c635856cdf$var$load("fzzMQ"),
    $69aa82c635856cdf$var$load("33S6H"),
    $69aa82c635856cdf$var$load("iZiNp"),
    $69aa82c635856cdf$var$load("kFae4"),
    $69aa82c635856cdf$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("kaacA", function(module, exports) {

let $eadca7b8b0c7e43e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eadca7b8b0c7e43e$var$load("iT2sv"),
    $eadca7b8b0c7e43e$var$load("iMMtn"),
    $eadca7b8b0c7e43e$var$load("23VWs"),
    $eadca7b8b0c7e43e$var$load("3gNEO"),
    $eadca7b8b0c7e43e$var$load("93obY"),
    $eadca7b8b0c7e43e$var$load("6Bgnb"),
    $eadca7b8b0c7e43e$var$load("6Y9jE"),
    $eadca7b8b0c7e43e$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("6fz2I", function(module, exports) {

let $48cf538efc08928f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $48cf538efc08928f$var$load("lyPpF"),
    $48cf538efc08928f$var$load("eX5n7"),
    $48cf538efc08928f$var$load("aiYuN"),
    $48cf538efc08928f$var$load("gvylW"),
    $48cf538efc08928f$var$load("bxfRe"),
    $48cf538efc08928f$var$load("43PKJ"),
    $48cf538efc08928f$var$load("ed6s8"),
    $48cf538efc08928f$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("jA2SL", function(module, exports) {

let $e4139d7ff7455fb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4139d7ff7455fb3$var$load("iN3cj"),
    $e4139d7ff7455fb3$var$load("3nHdy"),
    $e4139d7ff7455fb3$var$load("gDEvm"),
    $e4139d7ff7455fb3$var$load("80OLx"),
    $e4139d7ff7455fb3$var$load("1EVcg"),
    $e4139d7ff7455fb3$var$load("fqoiV"),
    $e4139d7ff7455fb3$var$load("96q1k"),
    $e4139d7ff7455fb3$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("hzJqW", function(module, exports) {

let $ccb8f2b7f0b31592$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ccb8f2b7f0b31592$var$load("eC1OL"),
    $ccb8f2b7f0b31592$var$load("ilL9c"),
    $ccb8f2b7f0b31592$var$load("64nco"),
    $ccb8f2b7f0b31592$var$load("e4s0V"),
    $ccb8f2b7f0b31592$var$load("28EXy"),
    $ccb8f2b7f0b31592$var$load("dHzvE"),
    $ccb8f2b7f0b31592$var$load("7RZp5"),
    $ccb8f2b7f0b31592$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("hoKfB", function(module, exports) {

let $caa88dfb824256c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $caa88dfb824256c7$var$load("4NJ49"),
    $caa88dfb824256c7$var$load("bfOZL"),
    $caa88dfb824256c7$var$load("jLbRX"),
    $caa88dfb824256c7$var$load("4dPO1"),
    $caa88dfb824256c7$var$load("gg8tK"),
    $caa88dfb824256c7$var$load("1SbqQ"),
    $caa88dfb824256c7$var$load("eF54W"),
    $caa88dfb824256c7$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("imEOn", function(module, exports) {

let $d5e9f05f0f1966b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5e9f05f0f1966b0$var$load("g9gkE"),
    $d5e9f05f0f1966b0$var$load("jYdbS"),
    $d5e9f05f0f1966b0$var$load("6ncWv"),
    $d5e9f05f0f1966b0$var$load("ltrgi"),
    $d5e9f05f0f1966b0$var$load("fu25G"),
    $d5e9f05f0f1966b0$var$load("di9bz"),
    $d5e9f05f0f1966b0$var$load("iQGcz"),
    $d5e9f05f0f1966b0$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("cGIqm", function(module, exports) {

let $93cbddf8b86b3fc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $93cbddf8b86b3fc5$var$load("jhikU"),
    $93cbddf8b86b3fc5$var$load("f0i3H"),
    $93cbddf8b86b3fc5$var$load("bvBAp"),
    $93cbddf8b86b3fc5$var$load("69YlM"),
    $93cbddf8b86b3fc5$var$load("cyTsc"),
    $93cbddf8b86b3fc5$var$load("iL6r3"),
    $93cbddf8b86b3fc5$var$load("kXCsp"),
    $93cbddf8b86b3fc5$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("5ZmT8", function(module, exports) {

let $45c4675def33c250$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45c4675def33c250$var$load("d91RK"),
    $45c4675def33c250$var$load("f7hfJ"),
    $45c4675def33c250$var$load("QI1kr"),
    $45c4675def33c250$var$load("brdRT"),
    $45c4675def33c250$var$load("lWBlc"),
    $45c4675def33c250$var$load("ZkI53"),
    $45c4675def33c250$var$load("s2EmI"),
    $45c4675def33c250$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("iDdpg", function(module, exports) {

let $d90644c3b275ca0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d90644c3b275ca0d$var$load("708J7"),
    $d90644c3b275ca0d$var$load("kVqUf"),
    $d90644c3b275ca0d$var$load("2IMxh"),
    $d90644c3b275ca0d$var$load("j03Pa"),
    $d90644c3b275ca0d$var$load("kke1I"),
    $d90644c3b275ca0d$var$load("dJQNS"),
    $d90644c3b275ca0d$var$load("gOwMq"),
    $d90644c3b275ca0d$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("40bvE", function(module, exports) {

let $2ea0170d9d4f12e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ea0170d9d4f12e8$var$load("7J1PC"),
    $2ea0170d9d4f12e8$var$load("446Ip"),
    $2ea0170d9d4f12e8$var$load("45r7q"),
    $2ea0170d9d4f12e8$var$load("6wr18"),
    $2ea0170d9d4f12e8$var$load("ffEVr"),
    $2ea0170d9d4f12e8$var$load("7EorR"),
    $2ea0170d9d4f12e8$var$load("9TOep"),
    $2ea0170d9d4f12e8$var$load("hhss7"),
    $2ea0170d9d4f12e8$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("eJXnW", function(module, exports) {

var $94kzl = parcelRequire("94kzl");


var $fL4p7 = parcelRequire("fL4p7");


var $iDrrr = parcelRequire("iDrrr");


var $DdJXy = parcelRequire("DdJXy");


var $b4vCW = parcelRequire("b4vCW");


var $4NuaM = parcelRequire("4NuaM");


var $4eTDd = parcelRequire("4eTDd");


var $402Va = parcelRequire("402Va");


var $g6P2L = parcelRequire("g6P2L");


var $jKzTq = parcelRequire("jKzTq");

const $b2d61b552ef6cf58$export$452f1062ecf44be7 = 5;
const $b2d61b552ef6cf58$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $b2d61b552ef6cf58$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $402Va.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $jKzTq.getArisForProducts)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $jKzTq.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $jKzTq.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $4NuaM.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $b4vCW.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $4eTDd.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $94kzl.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $b2d61b552ef6cf58$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $iDrrr.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $g6P2L.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        const shouldSkipActivityClient = (0, $iDrrr.fg)('link_picker_atlassian_plugin_activity_client_skip') && !(this.allowMultiSiteRecents || cloudId && !this.isMultisiteSearch);
        if (!disableActivityClient && !shouldSkipActivityClient) this.activityClient = (0, $DdJXy.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $fL4p7.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $b2d61b552ef6cf58$export$452f1062ecf44be7);
        }, $b2d61b552ef6cf58$var$DEBOUNCE_MS);
    }
}
var $b2d61b552ef6cf58$export$2e2bcd8739ae039 = $b2d61b552ef6cf58$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $b2d61b552ef6cf58$export$2e2bcd8739ae039;

});

parcelRegister("94kzl", function(module, exports) {
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $36f0454c86964c15$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
module.exports["filterUniqueItems"] = $36f0454c86964c15$export$8437fc55448c6e05;

});

parcelRegister("fL4p7", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $154a91127dc95ca2$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $154a91127dc95ca2$export$390f1673aa3d5232;

});

parcelRegister("b4vCW", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $6BYyi = parcelRequire("6BYyi");


var $6Zvcd = parcelRequire("6Zvcd");


var $fJfKO = parcelRequire("fJfKO");


var $7Cfp7 = parcelRequire("7Cfp7");

var $2103cf628600479a$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $2103cf628600479a$export$775b6bb06e53a214 = {
    ...(0, $6BYyi.Scope),
    ...(0, $6Zvcd.Scope),
    ...(0, $7Cfp7.TownsquareScope),
    ...(0, $fJfKO.Scope)
};
module.exports["Scope"] = $2103cf628600479a$export$775b6bb06e53a214;

});

parcelRegister("6BYyi", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $14f7537098ab5b98$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $14f7537098ab5b98$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $14f7537098ab5b98$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $14f7537098ab5b98$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $14f7537098ab5b98$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $14f7537098ab5b98$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $14f7537098ab5b98$export$80a5be864676016b = 'confluence.space';
const $14f7537098ab5b98$export$70542451ad6057d2 = 'urs.user-confluence';
const $14f7537098ab5b98$export$6ec00f56b27cdc1d = 'generic-container-result';
const $14f7537098ab5b98$export$ca1a50bc869949e = 'person-result';
const $14f7537098ab5b98$export$a99961038e9d5471 = 'confluence-object-result';
const $14f7537098ab5b98$export$18c69de2b4aa679c = 'recent-confluence';
const $14f7537098ab5b98$export$dc31f0db54ab1a30 = 'result-confluence';
const $14f7537098ab5b98$export$cb8b6c470492bee8 = 'recent-person';
const $14f7537098ab5b98$export$ebb42dafe7a39a20 = 'result-person';
const $14f7537098ab5b98$export$602b44a55c824e30 = 'advanced-search-confluence';
const $14f7537098ab5b98$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $14f7537098ab5b98$export$bbd1709e62826142 = 'confluence-page';
const $14f7537098ab5b98$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $14f7537098ab5b98$export$b441f0c13fd510b9 = 'confluence-attachment';
const $14f7537098ab5b98$export$8ee8726ca4e2f8bd = 'confluence-space';
const $14f7537098ab5b98$export$d0e824889e01c751 = 'person';
const $14f7537098ab5b98$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $14f7537098ab5b98$export$775b6bb06e53a214;

});

parcelRegister("6Zvcd", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $2f98cc823dddcacd$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $2f98cc823dddcacd$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $2f98cc823dddcacd$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $2f98cc823dddcacd$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $2f98cc823dddcacd$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $2f98cc823dddcacd$export$775b6bb06e53a214;

});

parcelRegister("fJfKO", function(module, exports) {
var $1d3fb901b1492caa$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $1d3fb901b1492caa$export$775b6bb06e53a214;

});

parcelRegister("7Cfp7", function(module, exports) {
var $7ab467722a6086d5$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $7ab467722a6086d5$export$fca43c5c12a4e3fa;

});

parcelRegister("4NuaM", function(module, exports) {
const $db5eae801f82341d$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
module.exports["filterItems"] = $db5eae801f82341d$export$16c4c0987c894b8c;

});

parcelRegister("4eTDd", function(module, exports) {

var $g6P2L = parcelRequire("g6P2L");

const $f6487c9b6ab4b005$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// Use the icon url from the quick search result if it exists but still resolve the altText,
        // which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $g6P2L.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $g6P2L.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
module.exports["mapSearchProviderResultToLinkSearchItemData"] = $f6487c9b6ab4b005$export$b76efb0c656bea6e;

});

parcelRegister("g6P2L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kWSTb = parcelRequire("kWSTb");


var $cSGyR = parcelRequire("cSGyR");


var $ldJ1U = parcelRequire("ldJ1U");


var $lb2PL = parcelRequire("lb2PL");


var $iW3KC = parcelRequire("iW3KC");


var $fHe6f = parcelRequire("fHe6f");


var $hkAs2 = parcelRequire("hkAs2");


var $6MsAF = parcelRequire("6MsAF");


var $2qJQZ = parcelRequire("2qJQZ");


var $7pJjg = parcelRequire("7pJjg");


var $bvjEB = parcelRequire("bvjEB");


var $a5G9M = parcelRequire("a5G9M");


var $dt415 = parcelRequire("dt415");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $izhqE = parcelRequire("izhqE");


var $lghDo = parcelRequire("lghDo");

var $6505997651b2e5f7$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    LinkContentType[LinkContentType["confluence.slide"] = 15] = "confluence.slide";
    return LinkContentType;
}($6505997651b2e5f7$var$LinkContentType || {});
const $6505997651b2e5f7$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $izhqE.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $6505997651b2e5f7$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($6505997651b2e5f7$var$LinkContentType).includes(contentType));
};
const $6505997651b2e5f7$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iW3KC.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dt415.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lb2PL.LoomIcon), {
                label: alt,
                size: "xxsmall"
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkAs2.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconEmbedLabel
    },
    // Rendered directly from icon-lab with the object styling as @atlaskit/object has no slide object yet
    'confluence.slide': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
                color: "var(--ds-icon-accent-green, #22A06B)",
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconSlideLabel
    }
};
const $6505997651b2e5f7$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$6505997651b2e5f7$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $iDrrr.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7pJjg.default), {
                label: alt
            }),
        iconAlt: (0, $lghDo.messages).hyperlinkIconLiveDocLabel
    };
    return $6505997651b2e5f7$export$80e948449ec854a9[contentType];
};
const $6505997651b2e5f7$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $lghDo.messages).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $lghDo.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $lghDo.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $lghDo.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $lghDo.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $lghDo.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $lghDo.messages).improvement;
    return alt;
};
const $6505997651b2e5f7$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $6505997651b2e5f7$export$ac1fda7301622804(iconUrl)
    };
};
module.exports["renderEmptyStateNoResults"] = $6505997651b2e5f7$export$74b0c6644317c84d;
module.exports["getIconFromContentType"] = $6505997651b2e5f7$export$d71678bb4eba5b81;
module.exports["getIconFromIconUrl"] = $6505997651b2e5f7$export$fd251dec3e575ea1;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("hkAs2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lBKFk = parcelRequire("lBKFk");


var $4hmAW = parcelRequire("4hmAW");

const $a395f01d1124dfc4$var$DatabaseObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DatabaseObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Database" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function DatabaseObject({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $a395f01d1124dfc4$export$2e2bcd8739ae039 = $a395f01d1124dfc4$var$DatabaseObject;
module.exports["default"] = $a395f01d1124dfc4$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("dt415", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bDjVc = parcelRequire("bDjVc");


var $4hmAW = parcelRequire("4hmAW");

const $a250350db8bca8ef$var$WhiteboardObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WhiteboardObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Whiteboard" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
            color: "var(--ds-icon-accent-teal, #2898BD)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WhiteboardObject({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
};
var $a250350db8bca8ef$export$2e2bcd8739ae039 = $a250350db8bca8ef$var$WhiteboardObject;
module.exports["default"] = $a250350db8bca8ef$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("izhqE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $i1t43 = parcelRequire("i1t43");


var $ddF74 = parcelRequire("ddF74");


var $78PmR = parcelRequire("78PmR");


var $iDrrr = parcelRequire("iDrrr");


var $6FvMC = parcelRequire("6FvMC");

const $5baa30569a0602bd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $5baa30569a0602bd$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $5baa30569a0602bd$var$emptyStateWrapperStyles = null;
const $5baa30569a0602bd$export$e661eeb828fb7b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { product: product, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { data: data } = (0, $78PmR.useAvailableSites)();
    const isConfluence = product === "confluence";
    let t1;
    if ($[0] !== cloudId || $[1] !== data || $[2] !== intl || $[3] !== isConfluence || $[4] !== isMultisiteSearch || $[5] !== product) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const productDetails = $5baa30569a0602bd$export$dc8a6c8f6bc81cdd(product);
            if (!productDetails) {
                t1 = null;
                break bb0;
            }
            const firstMatchingSite = data.find($5baa30569a0602bd$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
            if (firstMatchingSite) {
                let baseUrl = firstMatchingSite.url;
                if (isConfluence) {
                    baseUrl = baseUrl + "/wiki";
                    baseUrl;
                }
                const intlDescription = intl.formatMessage(productDetails.description, {
                    productName: productDetails.productName,
                    link: (str)=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                            href: baseUrl
                        }, str)
                });
                let t2;
                if ($[7] !== intl || $[8] !== isConfluence) {
                    t2 = isConfluence ? intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceCreateOption) : "";
                    $[7] = intl;
                    $[8] = isConfluence;
                    $[9] = t2;
                } else t2 = $[9];
                const intlConfCreate = t2;
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = (0, $hekY6.default)([
                        "_1DCdHiUgYP _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC"
                    ]);
                    $[10] = t3;
                } else t3 = $[10];
                let t4;
                if ($[11] !== intlConfCreate || $[12] !== intlDescription) {
                    t4 = /*#__PURE__*/ $cozmU.createElement("span", null, intlDescription, " ", intlConfCreate);
                    $[11] = intlConfCreate;
                    $[12] = intlDescription;
                    $[13] = t4;
                } else t4 = $[13];
                const t5 = /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
                    testId: $5baa30569a0602bd$export$800daf5fbbe96aff.emptyStateNoResults,
                    header: intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResults, {
                        productName: productDetails.productName
                    }),
                    description: t4,
                    renderImage: $5baa30569a0602bd$var$_temp
                });
                let t6;
                if ($[14] !== t3 || $[15] !== t5) {
                    t6 = /*#__PURE__*/ $cozmU.createElement("div", {
                        className: t3
                    }, t5);
                    $[14] = t3;
                    $[15] = t5;
                    $[16] = t6;
                } else t6 = $[16];
                t1 = t6;
                break bb0;
            }
        }
        $[0] = cloudId;
        $[1] = data;
        $[2] = intl;
        $[3] = isConfluence;
        $[4] = isMultisiteSearch;
        $[5] = product;
        $[6] = t1;
    } else t1 = $[6];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    return null;
} : ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { data: data } = (0, $78PmR.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $5baa30569a0602bd$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($5baa30569a0602bd$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: baseUrl
                }, str)
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1DCdHiUgYP _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
            testId: $5baa30569a0602bd$export$800daf5fbbe96aff.emptyStateNoResults,
            header: intl.formatMessage($5baa30569a0602bd$export$defe85febe8b728c.noResults, {
                productName: productDetails.productName
            }),
            description: /*#__PURE__*/ $cozmU.createElement("span", null, intlDescription, " ", intlConfCreate),
            renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $6FvMC.EmptyStateNoResultsSVG), null)
        }));
    }
    return null;
};
const $5baa30569a0602bd$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $5baa30569a0602bd$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $iDrrr.fg)('jira-issue-terminology-update-m4') ? $5baa30569a0602bd$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $5baa30569a0602bd$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $ddF74.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $5baa30569a0602bd$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $5baa30569a0602bd$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};
function $5baa30569a0602bd$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $6FvMC.EmptyStateNoResultsSVG), null);
}
module.exports["EmptyStateNoResults"] = $5baa30569a0602bd$export$e661eeb828fb7b2;

});

parcelRegister("ddF74", function(module, exports) {
var $7db9c4a56f6bda5d$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $7db9c4a56f6bda5d$export$16bdf84263b17cf0;

});

parcelRegister("78PmR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $jRVxN = parcelRequire("jRVxN");


var $bwuOg = parcelRequire("bwuOg");


var $kpg4X = parcelRequire("kpg4X");


var $7ImOT = parcelRequire("7ImOT");


var $itxfh = parcelRequire("itxfh");

async function $f9b075f8c4af52a9$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    // Organisations with units isolation in effect must be served the unit compliant endpoint,
    // which filters the sites down to the unit the user belongs to. The gate is passed as a
    // callback so it is only evaluated - and only records exposure - once the units GA killswitch
    // has already let the check through.
    const isUnitCompliant = await (0, $kpg4X.shouldUseUnitCompliantApi)(()=>(0, $iDrrr.fg)('linking_platform_site_picker_api_unit_compliant'));
    const availableSitesPath = isUnitCompliant ? (0, $itxfh.AVAILABLE_SITES_UNIT_COMPLIANT_PATH) : (0, $itxfh.AVAILABLE_SITES_PATH);
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $f9b075f8c4af52a9$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $cozmU.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $f9b075f8c4af52a9$var$getAvailableSites({
                    products: (0, $itxfh.defaultProducts),
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $jRVxN.default)('operational.getAvailableSitesResolve.failed', (0, $7ImOT.getOperationFailedAttributes)(err))).fire((0, $bwuOg.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
module.exports["useAvailableSites"] = $f9b075f8c4af52a9$export$3738ff0cbe469211;

});

parcelRegister("jRVxN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $62998fd154a225d3$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $62998fd154a225d3$export$2e2bcd8739ae039 = $62998fd154a225d3$var$createEventPayload;
module.exports["default"] = $62998fd154a225d3$export$2e2bcd8739ae039;

});

parcelRegister("bwuOg", function(module, exports) {
const $74d2fe053a191110$export$85183a312807388d = 'media';
const $74d2fe053a191110$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $74d2fe053a191110$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $74d2fe053a191110$export$60efea3f80310017;

});

parcelRegister("7ImOT", function(module, exports) {

var $6F8bK = parcelRequire("6F8bK");

const $81fd4f8e9eaaa33e$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...(0, $6F8bK.getNetworkFields)(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $81fd4f8e9eaaa33e$export$b2d107ab31565d0b;

});

parcelRegister("6F8bK", function(module, exports) {

var $lOgJi = parcelRequire("lOgJi");

const $39cbe7f687b7bac3$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $39cbe7f687b7bac3$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $lOgJi.getTraceId)(error),
        status: error.status,
        path: $39cbe7f687b7bac3$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getNetworkFields"] = $39cbe7f687b7bac3$export$294520aca64d4e59;

});

parcelRegister("lOgJi", function(module, exports) {
function $e9f99b887d228dab$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $e9f99b887d228dab$export$e88cb5bfb57ce9c4;

});

parcelRegister("itxfh", function(module, exports) {

var $ddF74 = parcelRequire("ddF74");

const $466b025cd737fb7d$export$3852baab4b1aed0 = '/gateway/api/available-sites';
const $466b025cd737fb7d$export$a186f5bf9088e0c8 = '/gateway/api/experimental/available-sites';
const $466b025cd737fb7d$export$dfe0ecd37ba5eb09 = '/gateway/api/v2/accessible-products';
const $466b025cd737fb7d$export$4fc28a91be209205 = '/gateway/api/experimental/v2/accessible-products';
const $466b025cd737fb7d$export$6122de50dad8755d = [
    (0, $ddF74.AvailableSitesProductType).WHITEBOARD,
    (0, $ddF74.AvailableSitesProductType).BEACON,
    (0, $ddF74.AvailableSitesProductType).COMPASS,
    (0, $ddF74.AvailableSitesProductType).CONFLUENCE,
    (0, $ddF74.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $ddF74.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $ddF74.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $ddF74.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $ddF74.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $ddF74.AvailableSitesProductType).MERCURY,
    (0, $ddF74.AvailableSitesProductType).OPSGENIE,
    (0, $ddF74.AvailableSitesProductType).STATUS_PAGE,
    (0, $ddF74.AvailableSitesProductType).ATLAS,
    (0, $ddF74.AvailableSitesProductType).LOOM
];
module.exports["AVAILABLE_SITES_PATH"] = $466b025cd737fb7d$export$3852baab4b1aed0;
module.exports["AVAILABLE_SITES_UNIT_COMPLIANT_PATH"] = $466b025cd737fb7d$export$a186f5bf9088e0c8;
module.exports["ACCESSIBLE_PRODUCTS_PATH"] = $466b025cd737fb7d$export$dfe0ecd37ba5eb09;
module.exports["ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH"] = $466b025cd737fb7d$export$4fc28a91be209205;
module.exports["defaultProducts"] = $466b025cd737fb7d$export$6122de50dad8755d;

});

parcelRegister("6FvMC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $de8ab48fa30d5146$var$noResultsSVGStyles = null;
const $de8ab48fa30d5146$export$88f98178b806da03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 96 96",
            className: (0, $hekY6.default)([
                "_39xV02JgOI _0jFU0VJgOI _313842dnbC _0adFHsIZbP _1DCdHi5zaO _2XsHFMIZbP _3iDTPbvLZJ"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#FCA700",
            d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#1868DB",
            d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#101214",
            d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#09326C",
            d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _313842dnbC _0adFHsIZbP _1DCdHi5zaO _2XsHFMIZbP _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#FCA700",
        d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#1868DB",
        d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#101214",
        d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#09326C",
        d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
    }));
};
module.exports["EmptyStateNoResultsSVG"] = $de8ab48fa30d5146$export$88f98178b806da03;

});

parcelRegister("lghDo", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f755c04d07f13e9f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconSlideLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconSlideLabel",
        defaultMessage: "Slides"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});
module.exports["messages"] = $f755c04d07f13e9f$export$defe85febe8b728c;

});

parcelRegister("402Va", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");


var $fCd3b = parcelRequire("fCd3b");


var $b4vCW = parcelRequire("b4vCW");

const $805b90bae39ab0c7$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $805b90bae39ab0c7$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $805b90bae39ab0c7$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $9cGsb.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $805b90bae39ab0c7$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'slide':
                return 'confluence.slide';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $b4vCW.Scope).ConfluencePageBlog || this.scope === (0, $b4vCW.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $b4vCW.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).JiraIssue || this.scope === (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $b4vCW.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $805b90bae39ab0c7$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
            case (0, $b4vCW.Scope).ConfluencePageBlogWhiteboard:
            case (0, $b4vCW.Scope).ConfluenceContentType:
            case (0, $b4vCW.Scope).JiraIssue:
            case (0, $b4vCW.Scope).JiraDashboard:
            case (0, $b4vCW.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $b4vCW.Scope).TownsquareProject:
            case (0, $b4vCW.Scope).TownsquareGoal:
            case (0, $b4vCW.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $fCd3b.createClient)(config);
    }
}
module.exports["default"] = $805b90bae39ab0c7$export$2e2bcd8739ae039;

});

parcelRegister("fCd3b", function(module, exports) {

var $fExfj = parcelRequire("fExfj");


var $iVNH5 = parcelRequire("iVNH5");

const $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY = 3;
const $a663f43e8e7364a7$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY);
};
class $a663f43e8e7364a7$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $a663f43e8e7364a7$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $iVNH5.timed)(this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $fExfj.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $a663f43e8e7364a7$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $a663f43e8e7364a7$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $a663f43e8e7364a7$export$5d730b7aed1a3eb0;

});

parcelRegister("iVNH5", function(module, exports) {
const $7a547b1e741af2d7$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $7a547b1e741af2d7$export$d35186a762cd39c8;

});

parcelRegister("jKzTq", function(module, exports) {

var $g6P2L = parcelRequire("g6P2L");

const $b9531dc073aa2fb5$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $g6P2L.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $g6P2L.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $b9531dc073aa2fb5$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $b9531dc073aa2fb5$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $b9531dc073aa2fb5$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
     * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
     */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $b9531dc073aa2fb5$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$b9531dc073aa2fb5$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}
module.exports["mapActivityClientResultToLinkSearchItemData"] = $b9531dc073aa2fb5$export$d82137ca931458ca;
module.exports["getArisForProducts"] = $b9531dc073aa2fb5$export$4b7ffcf66d37c47b;

});

parcelRegister("3W9OD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b4vCW = parcelRequire("b4vCW");


var $aXmxE = parcelRequire("aXmxE");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $cozmU.useMemo)(()=>Promise.resolve((0, $aXmxE.createSearchProvider)(cloudId, (0, $b4vCW.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("aXmxE", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $b15ln = parcelRequire("b15ln");

const $9ab0949045688fbc$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $b15ln.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $9ab0949045688fbc$export$31a7d81156fc4fa1;

});

parcelRegister("b15ln", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");


var $fCd3b = parcelRequire("fCd3b");


var $b4vCW = parcelRequire("b4vCW");

const $1dc83b808cb1c829$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $1dc83b808cb1c829$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $9cGsb.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $b4vCW.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $1dc83b808cb1c829$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
            case (0, $b4vCW.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $fCd3b.createClient)(config);
    }
}
module.exports["default"] = $1dc83b808cb1c829$export$2e2bcd8739ae039;

});

parcelRegister("6jfBG", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $jLxvy = parcelRequire("jLxvy");

const $efb52f82a553eed8$export$57a077cc9fbe653e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), props);
const $efb52f82a553eed8$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), props);
module.exports["HoverCard"] = $efb52f82a553eed8$export$57a077cc9fbe653e;
module.exports["StandaloneHoverCard"] = $efb52f82a553eed8$export$f1f63acbe6ed8fb0;

});

parcelRegister("9kaAZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0474244f47a462a454178fef95978b34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c9e33679fb3ef29$var$_react = $6c9e33679fb3ef29$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6c9e33679fb3ef29$var$_iconNew = $6c9e33679fb3ef29$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $6c9e33679fb3ef29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/suggested-edit
 * Usage guidance:
 * Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c9e33679fb3ef29$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $6c9e33679fb3ef29$var$_react.default.createElement($6c9e33679fb3ef29$var$_iconNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$6c9e33679fb3ef29$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $6c9e33679fb3ef29$var$_default = module.exports.default = $6c9e33679fb3ef29$var$SuggestedEditIcon;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("kmvdJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d41dcdce6cad96086bdeda5999432f37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2e1473028ddf28$var$_react = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ed2e1473028ddf28$var$_iconNew = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ed2e1473028ddf28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/audio
 * Usage guidance:
 * 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2e1473028ddf28$var$AudioIcon = (props)=>/*#__PURE__*/ $ed2e1473028ddf28$var$_react.default.createElement($ed2e1473028ddf28$var$_iconNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$ed2e1473028ddf28$var$AudioIcon.displayName = 'AudioIcon';
var $ed2e1473028ddf28$var$_default = module.exports.default = $ed2e1473028ddf28$var$AudioIcon;

});

parcelRegister("iqehY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d695bd348a8c5b11$var$_react = $d695bd348a8c5b11$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $d695bd348a8c5b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d695bd348a8c5b11$var$Archive16Icon = (props)=>/*#__PURE__*/ $d695bd348a8c5b11$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d695bd348a8c5b11$var$Archive16Icon.displayName = 'Archive16Icon';
var $d695bd348a8c5b11$var$_default = module.exports.default = $d695bd348a8c5b11$var$Archive16Icon;

});

parcelRegister("adk2f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3cb2d8c9faefdb0f$var$iconStyles = null;
const $3cb2d8c9faefdb0f$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _0mcUfEey7F _2kxbLJey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg _0mcUfEoWWg _2kxbLJoWWg",
    large: "_39xV02Uofl _0jFU0VUofl _0mcUfEUofl _2kxbLJUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _0mcUfEpJKa _2kxbLJpJKa"
}; /**
    * For windows high contrast mode
    */ 
const $3cb2d8c9faefdb0f$var$baseHcmStyles = null;
const $3cb2d8c9faefdb0f$var$primaryEqualsSecondaryHcmStyles = null;
const $3cb2d8c9faefdb0f$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $3cb2d8c9faefdb0f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: t0, secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const primaryColor = t0 === undefined ? "currentColor" : t0;
    let t1;
    if ($[0] !== Glyph || $[1] !== dangerouslySetGlyph) {
        t1 = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
                role: "presentation"
            }) : null
        };
        $[0] = Glyph;
        $[1] = dangerouslySetGlyph;
        $[2] = t1;
    } else t1 = $[2];
    const glyphProps = t1;
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = width && height ? {
            width: width + "px",
            height: height + "px"
        } : null;
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    const customDimensions = t2;
    const t3 = `icon-${testId}`;
    const t4 = label ? "img" : undefined;
    const t5 = label ? label : undefined;
    const t6 = label ? undefined : true;
    let t7;
    if ($[6] !== UNSAFE_margin || $[7] !== customDimensions || $[8] !== primaryColor || $[9] !== secondaryColor) {
        t7 = {
            ...customDimensions,
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor,
            margin: UNSAFE_margin
        };
        $[6] = UNSAFE_margin;
        $[7] = customDimensions;
        $[8] = primaryColor;
        $[9] = secondaryColor;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    const t9 = primaryColor === secondaryColor && "_2W1hK9k5Cz";
    const t10 = secondaryColor === "transparent" && "_0ibj0wjOvk";
    const t11 = size && $3cb2d8c9faefdb0f$var$sizeStyles[size];
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t9) {
        t12 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            t9,
            t10,
            t11
        ]);
        $[11] = t10;
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== glyphProps || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-vc": t3,
            role: t4,
            "aria-label": t5,
            "aria-hidden": t6,
            style: t8,
            ...glyphProps,
            className: t12
        });
        $[15] = glyphProps;
        $[16] = t12;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = testId;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _03DdiXlfZc _26BoRw7dHp _4hYdNbnQyn _4ktURhnQyn _1QzFdLN91d _2S9CkHN91d _3Krhx8bMfJ _0fvd5AdkvI _1O5n5yYbGa _4rPVFiUWqv _3J08zt98eZ",
            "_1hdADdMFyn _16qGwyTxK4 _4l7oXfk5Cz",
            primaryColor === secondaryColor && "_2W1hK9k5Cz",
            secondaryColor === 'transparent' && "_0ibj0wjOvk",
            size && $3cb2d8c9faefdb0f$var$sizeStyles[size]
        ])
    });
});
var $3cb2d8c9faefdb0f$export$2e2bcd8739ae039 = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;
module.exports["Icon"] = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;

});

parcelRegister("3OVVx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c82f9b957a0dd41$var$_react = $2c82f9b957a0dd41$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2c82f9b957a0dd41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2c82f9b957a0dd41$var$Executable16Icon = (props)=>/*#__PURE__*/ $2c82f9b957a0dd41$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$2c82f9b957a0dd41$var$Executable16Icon.displayName = 'Executable16Icon';
var $2c82f9b957a0dd41$var$_default = module.exports.default = $2c82f9b957a0dd41$var$Executable16Icon;

});

parcelRegister("EhIdb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $079179cb50a24843$var$_react = $079179cb50a24843$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $079179cb50a24843$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $079179cb50a24843$var$Gif16Icon = (props)=>/*#__PURE__*/ $079179cb50a24843$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$079179cb50a24843$var$Gif16Icon.displayName = 'Gif16Icon';
var $079179cb50a24843$var$_default = module.exports.default = $079179cb50a24843$var$Gif16Icon;

});

parcelRegister("hmd8r", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ca2eae1e9270fd6e$var$_react = $ca2eae1e9270fd6e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $ca2eae1e9270fd6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca2eae1e9270fd6e$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $ca2eae1e9270fd6e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$ca2eae1e9270fd6e$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $ca2eae1e9270fd6e$var$_default = module.exports.default = $ca2eae1e9270fd6e$var$GoogleDoc16Icon;

});

parcelRegister("lLxTI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fd88481d2a5e9c77$var$_react = $fd88481d2a5e9c77$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $fd88481d2a5e9c77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd88481d2a5e9c77$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $fd88481d2a5e9c77$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fd88481d2a5e9c77$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $fd88481d2a5e9c77$var$_default = module.exports.default = $fd88481d2a5e9c77$var$GoogleForm16Icon;

});

parcelRegister("kUQwC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f3a1c7fef4d4d082$var$_react = $f3a1c7fef4d4d082$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f3a1c7fef4d4d082$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f3a1c7fef4d4d082$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f3a1c7fef4d4d082$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f3a1c7fef4d4d082$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f3a1c7fef4d4d082$var$_default = module.exports.default = $f3a1c7fef4d4d082$var$GoogleSheet16Icon;

});

parcelRegister("1G3Dq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $138c887dc5ea0961$var$_react = $138c887dc5ea0961$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $138c887dc5ea0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $138c887dc5ea0961$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $138c887dc5ea0961$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$138c887dc5ea0961$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $138c887dc5ea0961$var$_default = module.exports.default = $138c887dc5ea0961$var$GoogleSlide16Icon;

});

parcelRegister("1kVaD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0f9401986b2d6c49$var$_react = $0f9401986b2d6c49$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $0f9401986b2d6c49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $0f9401986b2d6c49$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$0f9401986b2d6c49$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $0f9401986b2d6c49$var$_default = module.exports.default = $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon;

});

parcelRegister("aeJll", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $773e626dd1065814$var$_react = $773e626dd1065814$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $773e626dd1065814$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $773e626dd1065814$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $773e626dd1065814$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$773e626dd1065814$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $773e626dd1065814$var$_default = module.exports.default = $773e626dd1065814$var$PowerpointPresentation16Icon;

});

parcelRegister("8If3N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $657e1d6efd6121d9$var$_react = $657e1d6efd6121d9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $657e1d6efd6121d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657e1d6efd6121d9$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $657e1d6efd6121d9$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$657e1d6efd6121d9$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $657e1d6efd6121d9$var$_default = module.exports.default = $657e1d6efd6121d9$var$WordDocument16Icon;

});

parcelRegister("8B1YK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6423506162d1ed28$var$_react = $6423506162d1ed28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $6423506162d1ed28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6423506162d1ed28$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $6423506162d1ed28$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$6423506162d1ed28$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $6423506162d1ed28$var$_default = module.exports.default = $6423506162d1ed28$var$PdfDocument16Icon;

});

parcelRegister("AzmWu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $06decc763d5ed155$var$_react = $06decc763d5ed155$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $06decc763d5ed155$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $06decc763d5ed155$var$Sketch16Icon = (props)=>/*#__PURE__*/ $06decc763d5ed155$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$06decc763d5ed155$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $06decc763d5ed155$var$_default = module.exports.default = $06decc763d5ed155$var$Sketch16Icon;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("ipkS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3GQl6 = parcelRequire("3GQl6");

const $689b0be44fd5c2f8$var$logger = (0, $7W8i8.getLogger)('trackReactLazy');
// Marks a subtree whose code only loads when a render-time lazy component renders. The client
// cannot load it before hydration, so lazy components inside it must not hold hydration.
const $689b0be44fd5c2f8$var$RenderTimeLazyAncestor = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $689b0be44fd5c2f8$var$warnedRenderTimeIds = new Set();
// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $689b0be44fd5c2f8$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $689b0be44fd5c2f8$var$withServerTracking(id, module, { renderTime: renderTime, source: source }) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        const hasRenderTimeAncestor = (0, $cozmU.useContext)($689b0be44fd5c2f8$var$RenderTimeLazyAncestor);
        const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
        if (renderTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689b0be44fd5c2f8$var$RenderTimeLazyAncestor.Provider, {
            value: true
        }, element);
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if (!hasRenderTimeAncestor && (0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload', 'isEnabled', true)) (0, $3GQl6.addLoadableId)(id);
        return element;
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $689b0be44fd5c2f8$export$fb5c897fe5d03fec(id, loader, options = {}) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    if (options.renderTime) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return loader;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // preloadIfNeeded can start loading at once. Waiting a microtask lets the defining module
    // finish evaluating before the loader reads any of its bindings.
    (0, $3GQl6.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $689b0be44fd5c2f8$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $689b0be44fd5c2f8$export$fb5c897fe5d03fec;

});

parcelRegister("4zc1o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac338e9874c603146412047b69e4afeb>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0245abe18739bd2c$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $0245abe18739bd2c$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0245abe18739bd2c$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["GoogleDriveIcon"] = $0245abe18739bd2c$export$e16bd899bb4eebf9;

});

parcelRegister("8RTwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2aa8c41b28ad95f2edc4a75dfe3a27>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $9a3d60b77ddc3f21$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $9a3d60b77ddc3f21$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $9a3d60b77ddc3f21$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftSharePointIcon"] = $9a3d60b77ddc3f21$export$18737550276ca4ad;

});

parcelRegister("5TdBT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::352a2d656f28112e2ef3d91735e599d7>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $f87149460128dc3a$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_radial_118280_5819)" d="M16.396 15.797c-5.198 0-9.083 4.255-9.376 8.995.181 1.021.776 3.038 1.708 2.935 1.165-.13 4.1 0 6.602-4.531 1.828-3.31 5.589-7.4 1.066-7.4"/><path fill="url(#paint1_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint2_radial_118280_5819)" fill-opacity=".4" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint3_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint4_radial_118280_5819)" fill-opacity=".6" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint5_radial_118280_5819)" fill-opacity=".9" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint6_linear_118280_5819)" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint7_radial_118280_5819)" fill-opacity=".4" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint8_radial_118280_5819)" fill-opacity=".9" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><defs><radialGradient id="paint0_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(50.153 -14.375 16.71)scale(10.7161 17.7747)" gradientUnits="userSpaceOnUse"><stop stop-color="#4894fe"/><stop offset=".695" stop-color="#0934b3"/></radialGradient><radialGradient id="paint1_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(130.923 17.143 10.667)scale(46.0803 34.1459)" gradientUnits="userSpaceOnUse"><stop offset=".165" stop-color="#23c0fe"/><stop offset=".534" stop-color="#1c91ff"/></radialGradient><radialGradient id="paint2_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.014 10.522 6.163)scale(9.36856 21.4466)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".661" stop-color="#adc0ff" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.236 17.663 9.818)scale(10.5597 16.0372)" gradientUnits="userSpaceOnUse"><stop stop-color="#033acc"/><stop offset="1" stop-color="#368eff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(66.571 -1.855 16.474)scale(23.1705 25.0138)" gradientUnits="userSpaceOnUse"><stop offset=".593" stop-color="#3464e3" stop-opacity="0"/><stop offset="1" stop-color="#033acc"/></radialGradient><radialGradient id="paint5_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(135 16.558 11.022)scale(34.0831 53.3967)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".544" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(21.632 -45.065 64.673)scale(15.4444 29.2464)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".785" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="paint8_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(139.243 16.894 16.587)scale(21.1738 21.2455)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".585" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><linearGradient id="paint6_linear_118280_5819" x1="28.722" x2="28.722" y1="34.931" y2="19.517" gradientUnits="userSpaceOnUse"><stop stop-color="#0086ff"/><stop offset=".49" stop-color="#0bf"/></linearGradient></defs></svg>';
function $f87149460128dc3a$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $f87149460128dc3a$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftOneDriveIcon"] = $f87149460128dc3a$export$adf3a43722623322;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("6OpMl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $l4yrE = parcelRequire("l4yrE");


var $9ncZd = parcelRequire("9ncZd");


var $9Jo6P = parcelRequire("9Jo6P");

const $8996823a89ed3e69$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
        experiences: [
            (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ncZd.ResourcedEmojiComponent), props));
};
var $8996823a89ed3e69$export$2e2bcd8739ae039 = $8996823a89ed3e69$var$ResourcedEmoji;
module.exports["default"] = $8996823a89ed3e69$export$2e2bcd8739ae039;

});

parcelRegister("d8DK7", function(module, exports) {

var $e4Q12 = parcelRequire("e4Q12");


var $53TEx = parcelRequire("53TEx");

const $37720bf73e14576a$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $53TEx.withSampling)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
module.exports["sampledUfoRenderedEmoji"] = $37720bf73e14576a$export$71c8cba6f1251ea9;

});

parcelRegister("9ncZd", function(module, exports) {
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $gxxZD = parcelRequire("gxxZD");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $l4yrE = parcelRequire("l4yrE");


var $2p7KE = parcelRequire("2p7KE");


var $72OmS = parcelRequire("72OmS");


var $1Vdnd = parcelRequire("1Vdnd");


var $1FzXO = parcelRequire("1FzXO");


var $iKpb2 = parcelRequire("iKpb2");

const $af933464a9c9fdc1$var$ignoreWrapperStyles = null;
var $af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $af933464a9c9fdc1$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, emojiProviderLookupOrder: emojiProviderLookupOrder, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $l4yrE.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $cozmU.useState)();
    const [loaded, setLoaded] = (0, $cozmU.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $cozmU.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $cozmU.useState)();
    const fetchOrGetEmoji = (0, $cozmU.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch, (0, $iDrrr.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_START);
        if ((0, $1Vdnd.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason); // emoji is undefined
                    (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
        }
    }, [
        emojiProviderLookupOrder,
        onEmojiLoadFail
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $1GEKi.hasUfoMarked)((0, $d8DK7.sampledUfoRenderedEmoji)(emojiId), (0, $9tfSW.UfoEmojiTimings).FMP_END)) (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]); // Fetching during render means a render React later discards (for example a pass that suspends)
    // still creates a promise whose callbacks set state and schedule yet another render. This layout
    // effect only runs for committed renders, and being pre-paint it keeps the synchronous cache-hit
    // path from flashing the placeholder.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]); /**
                                                                      * Setting resolved emoji provider for optimistic rendering
                                                                      */ 
    (0, $cozmU.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $cozmU.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $cozmU.useMemo)(()=>{
        // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $iDrrr.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
         // extend prevention to all surfaces
        if (optimisticImageURL && (0, $iDrrr.fg)('platform_emoji_prevent_img_src_changing_all')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if (optimisticImageURL) {
            if (emoji && ((0, $2p7KE.isImageRepresentation)(emoji.representation) || (0, $72OmS.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                    width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji
    ]);
    const handleOnLoadError = (0, $cozmU.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $cozmU.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]); // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gxxZD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
        className: (0, $hekY6.default)([
            ignoreWrapper && "_3iDTPbcK7c"
        ])
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji
    })));
};
var $af933464a9c9fdc1$export$2e2bcd8739ae039 = $af933464a9c9fdc1$export$7bfde52eceb3e2f6;
module.exports["ResourcedEmojiComponent"] = $af933464a9c9fdc1$export$7bfde52eceb3e2f6;

});

parcelRegister("gxxZD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cr9f7 = parcelRequire("cr9f7");

const $d0b501ffb123d2f7$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $cozmU.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cr9f7.EmojiContextProvider), {
        emojiContextValue: emojiContextValue
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
};
module.exports["EmojiCommonProvider"] = $d0b501ffb123d2f7$export$1120e666998e21b5;

});

parcelRegister("cr9f7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l3Ofr = parcelRequire("l3Ofr");


var $aGLvf = parcelRequire("aGLvf");

const $47b6237c4d0cf4ed$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $cozmU.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $cozmU.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $l3Ofr.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGLvf.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};
module.exports["EmojiContextProvider"] = $47b6237c4d0cf4ed$export$f4a09143833145ed;

});

parcelRegister("aGLvf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e656e5d7e8d89d36$export$9fab6c37a453c65e = (0, $cozmU.createContext)(null);
module.exports["EmojiContext"] = $e656e5d7e8d89d36$export$9fab6c37a453c65e;

});

parcelRegister("1GEKi", function(module, exports) {
const $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
module.exports["hasUfoMarked"] = $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0;

});

parcelRegister("1FzXO", function(module, exports) {
/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $7gsaD = parcelRequire("7gsaD");


var $l4yrE = parcelRequire("l4yrE");


var $ie2rI = parcelRequire("ie2rI");


var $bvr9K = parcelRequire("bvr9K");


var $ldPoq = parcelRequire("ldPoq");


var $1kRhf = parcelRequire("1kRhf");


var $3cA9y = parcelRequire("3cA9y");


var $2u6sV = parcelRequire("2u6sV");


var $1UHRU = parcelRequire("1UHRU");

const $9b741b87d47c6c28$var$emojiSpriteContainer = null;
const $9b741b87d47c6c28$var$emojiImageContainer = null;
const $9b741b87d47c6c28$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $l4yrE.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $bvr9K.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    }
};
const $9b741b87d47c6c28$var$handleKeyDown = (props, event)=>{
    if (!(0, $l4yrE.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $l4yrE.KeyboardKeys).Enter || event.key === (0, $l4yrE.KeyboardKeys).Space)) onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $l4yrE.KeyboardKeys).Backspace) (0, $3cA9y.handleDelete)(props, event);
};
const $9b741b87d47c6c28$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, isDecorative: isDecorative, ...other } = props;
    const intl = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    const isAriaLabelEmpty = editorEmoji || isDecorative;
    let ariaLabel;
    if (isAriaLabelEmpty) ariaLabel = undefined;
    else if (intl) ariaLabel = intl.formatMessage((0, $1kRhf.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    });
    else ariaLabel = emoji.shortName;
    const tooltipContent = showTooltip && (0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        className: (0, $hekY6.default)([
            type === 'sprite' ? "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _3iDTPbvbI6 _1iPKDrNZfY _2hB4kovbI6 _1GBPVvSPN1 _3woHNtSPN1 _2oqNm2t2nV _1XjlOoo126 _0eVgdoo126 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg" : "_0bjKvDzXzM _313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0KLXrujOvk _3iDTPbvbI6 _1RrJLit2nV _23odCivLZJ _1XjlOoo126 _0eVgdoo126 _2LVIB7YvD1 _4jXNFKYvD1 _3JWaHCRAKS _1MkY46YvD1 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg",
            className
        ]),
        onKeyDown: (event)=>$9b741b87d47c6c28$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $9b741b87d47c6c28$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $9b741b87d47c6c28$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $9b741b87d47c6c28$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other
    }, children);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span"
    }, emojiSpan);
    return emojiSpan;
});
const $9b741b87d47c6c28$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props; // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $7gsaD.useSampledUFOComponentExperience)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $cozmU.useEffect)(()=>{
        const ufoExp = (0, $d8DK7.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).MOUNTED_END);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $ie2rI.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1UHRU.SpriteEmoji), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2u6sV.ImageEmoji), props);
};
var $9b741b87d47c6c28$export$2e2bcd8739ae039 = $9b741b87d47c6c28$export$56cc48506ff790a;
module.exports["EmojiNodeWrapper"] = $9b741b87d47c6c28$export$ce5eef59d8e46687;
module.exports["default"] = $9b741b87d47c6c28$export$2e2bcd8739ae039;

});

parcelRegister("7gsaD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $53TEx = parcelRequire("53TEx");

const $76dc57e6fa0afa99$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $cozmU.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $76dc57e6fa0afa99$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            (0, $53TEx.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $76dc57e6fa0afa99$var$useConstructor(()=>{
        (0, $53TEx.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};
module.exports["useSampledUFOComponentExperience"] = $76dc57e6fa0afa99$export$f959821a7419dee1;

});

parcelRegister("ie2rI", function(module, exports) {
const $74d8240b08e598d0$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
module.exports["isSpriteRepresentation"] = $74d8240b08e598d0$export$a194199d673d75de;

});

parcelRegister("bvr9K", function(module, exports) {
function $72087d0c7cb66425$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}
module.exports["leftClick"] = $72087d0c7cb66425$export$34ebdaf2c517ae75;

});

parcelRegister("1kRhf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $68215d7718b9da32$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    deleteEmojiTooltip: {
        id: "fabric.emoji.delete.tooltip",
        defaultMessage: "Delete"
    },
    deleteEmojiTooltipForScreenreader: {
        id: "fabric.emoji.delete.screenreader.tooltip",
        defaultMessage: "To delete {shortName} emoji, press Backspace"
    },
    deleteEmojiTitle: {
        id: "fabric.emoji.delete.title",
        defaultMessage: "Remove emoji"
    },
    deleteEmojiDescription: {
        id: "fabric.emoji.delete.description",
        defaultMessage: "All existing instances of this emoji will be replaced with {emojiShortName}"
    },
    deleteEmojiLabel: {
        id: "fabric.emoji.delete.label",
        defaultMessage: "Remove"
    },
    addCustomEmojiLabel: {
        id: "fabric.emoji.add.custom.emoji.label",
        defaultMessage: "Add your own emoji"
    },
    emojiPlaceholder: {
        id: "fabric.emoji.placeholder",
        defaultMessage: "e.g. hello"
    },
    emojiNameAriaLabel: {
        id: "fabric.emoji.name.ariaLabel",
        defaultMessage: "Enter a name for the new emoji"
    },
    emojiNameLabel: {
        id: "fabric.emoji.name.label",
        defaultMessage: "Emoji name"
    },
    emojiChooseFileTitle: {
        id: "fabric.emoji.choose.file.title",
        defaultMessage: "Choose file"
    },
    emojiChooseFileDndTitle: {
        id: "fabric.emoji.choose.file.dnd.title",
        defaultMessage: "Select or drop an image"
    },
    emojiChooseFileScreenReaderDescription: {
        id: "fabric.emoji.choose.file.screenReaderDescription",
        defaultMessage: "Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB"
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: "fabric.emoji.select.skin.tone.ariaLabel",
        defaultMessage: "Choose your skin tone, {selectedTone} selected"
    },
    emojiSelectColorButtonAriaLabelText: {
        id: "fabric.emoji.select.color.ariaLabel",
        defaultMessage: "Productivity emoji color selector"
    },
    emojiSelectColorListAriaLabelText: {
        id: "fabric.emoji.select.color.list.ariaLabel",
        defaultMessage: "Productivity emoji colour selector"
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: "fabric.emoji.select.skin.list.ariaLabel",
        defaultMessage: "Skin tone selector"
    },
    emojiImageRequirements: {
        id: "fabric.emoji.image.requirements",
        defaultMessage: "JPG, PNG or GIF. Max size 1 MB."
    },
    emojiPreviewTitle: {
        id: "fabric.emoji.preview.title",
        defaultMessage: "Preview"
    },
    emojiPreview: {
        id: "fabric.emoji.preview",
        defaultMessage: "Your new emoji {emoji} looks great"
    },
    addEmojiLabel: {
        id: "fabric.emoji.add.label",
        defaultMessage: "Add emoji"
    },
    createEmojiWithRovoTitle: {
        id: "fabric.emoji.ai.create.title",
        defaultMessage: "Create an emoji with Rovo"
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: "fabric.emoji.ai.prompt.placeholder",
        defaultMessage: "Describe your emoji..."
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: "fabric.emoji.ai.prompt.ariaLabel",
        defaultMessage: "Describe the emoji you want to generate"
    },
    createEmojiWithRovoGenerateLabel: {
        id: "fabric.emoji.ai.generate.label",
        defaultMessage: "Generate"
    },
    createEmojiWithRovoError: {
        id: "fabric.emoji.ai.error",
        defaultMessage: "Something went wrong. Try a different description."
    },
    retryLabel: {
        id: "fabric.emoji.retry.label",
        defaultMessage: "Retry"
    },
    cancelLabel: {
        id: "fabric.emoji.cancel.label",
        defaultMessage: "Cancel"
    },
    searchPlaceholder: {
        id: "fabric.emoji.search.placeholder",
        defaultMessage: "Search"
    },
    searchLabel: {
        id: "fabric.emoji.search.label",
        defaultMessage: "Emoji name"
    },
    searchResultsStatus: {
        id: "fabric.emoji.search.status.count",
        defaultMessage: "Found {count} emojis"
    },
    searchResultsStatusSeeAll: {
        id: "fabric.emoji.search.status",
        defaultMessage: "Seeing all emojis"
    },
    categoriesSelectorLabel: {
        id: "fabric.emoji.categories.label",
        defaultMessage: "Choose an emoji category"
    },
    categoriesSearchResults: {
        id: "fabric.emoji.categories.search.results",
        defaultMessage: "Search results"
    },
    frequentCategory: {
        id: "fabric.emoji.category.frequent",
        defaultMessage: "Frequent"
    },
    peopleCategory: {
        id: "fabric.emoji.category.people",
        defaultMessage: "People"
    },
    natureCategory: {
        id: "fabric.emoji.category.nature",
        defaultMessage: "Nature"
    },
    foodsCategory: {
        id: "fabric.emoji.category.foods",
        defaultMessage: "Food & Drink"
    },
    activityCategory: {
        id: "fabric.emoji.category.activity",
        defaultMessage: "Activity"
    },
    placesCategory: {
        id: "fabric.emoji.category.places",
        defaultMessage: "Travel & Places"
    },
    objectsCategory: {
        id: "fabric.emoji.category.objects",
        defaultMessage: "Objects"
    },
    symbolsCategory: {
        id: "fabric.emoji.category.symbols",
        defaultMessage: "Symbols"
    },
    flagsCategory: {
        id: "fabric.emoji.category.flags",
        defaultMessage: "Flags"
    },
    productivityCategory: {
        id: "fabric.emoji.category.productivity",
        defaultMessage: "Atlassian & productivity"
    },
    userUploadsCustomCategory: {
        id: "fabric.emoji.category.user.uploads",
        defaultMessage: "Your uploads"
    },
    allUploadsCustomCategory: {
        id: "fabric.emoji.category.all.uploads",
        defaultMessage: "All uploads"
    },
    deleteEmojiFailed: {
        id: "fabric.emoji.error.delete.failed",
        defaultMessage: "Remove failed"
    },
    emojiInvalidImage: {
        id: "fabric.emoji.error.invalid.image",
        defaultMessage: "Selected image is invalid"
    },
    emojiUploadFailed: {
        id: "fabric.emoji.error.upload.failed",
        defaultMessage: "Upload failed"
    },
    emojiUploadTimeout: {
        id: "fabric.emoji.error.upload.timeout",
        defaultMessage: "Upload timed out"
    },
    emojiImageTooBig: {
        id: "fabric.emoji.error.image.too.big",
        defaultMessage: "Selected image is more than 1 MB"
    },
    emojiUnsupportedFileType: {
        id: "fabric.emoji.error.unsupported.file.type",
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji."
    },
    emojiDuplicateName: {
        id: "fabric.emoji.error.duplicate.name",
        defaultMessage: "An emoji with this name exists already"
    },
    emojiPickerNoResults: {
        id: "fabric.emoji.picker.no.results",
        defaultMessage: "No results"
    },
    emojiPickerAddCustomEmoji: {
        id: "fabric.emoji.picker.add.custom.emoji",
        defaultMessage: "Add custom emoji"
    },
    emojiPickerTitle: {
        id: "fabric.emoji.picker",
        defaultMessage: "Emoji picker"
    },
    emojiPickerListPanel: {
        id: "fabric.emoji.pickerlist.tabpanel",
        defaultMessage: "Emojis actions and list panel"
    },
    emojiPickerGrid: {
        id: "fabric.emoji.pickerlist.grid",
        defaultMessage: "{showSearchResults, select, true{Search results} other{Emojis}}"
    },
    emojiButtonRoleDescription: {
        id: "fabric.emoji.emojipicker.emoi.roledescription",
        defaultMessage: "emoji button"
    },
    changeEmojiShortnameButtonLabel: {
        id: "fabric.emoji.change.shortname.button.label",
        defaultMessage: "Change emoji, currently {shortName}"
    },
    error: {
        id: "fabric.emoji.emojipicker.error",
        defaultMessage: "Error!"
    }
});
module.exports["messages"] = $68215d7718b9da32$export$defe85febe8b728c;

});

parcelRegister("3cA9y", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldPoq = parcelRequire("ldPoq");

const $05233230a42f662c$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
module.exports["handleDelete"] = $05233230a42f662c$export$471c4c6c1d1a0512;

});

parcelRegister("2u6sV", function(module, exports) {
/* ImageEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");


var $lpNn5 = parcelRequire("lpNn5");


var $c66dg = parcelRequire("c66dg");


var $kLQGL = parcelRequire("kLQGL");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $6Y7Xc = parcelRequire("6Y7Xc");


var $2p7KE = parcelRequire("2p7KE");


var $72OmS = parcelRequire("72OmS");


var $ldPoq = parcelRequire("ldPoq");


var $kpf8v = parcelRequire("kpf8v");


var $9qxV9 = parcelRequire("9qxV9");


var $7Ya31 = parcelRequire("7Ya31");


var $1FzXO = parcelRequire("1FzXO");


var $3cA9y = parcelRequire("3cA9y");


var $a5rDX = parcelRequire("a5rDX");

const $7cbdfa334838272a$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props; // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $7cbdfa334838272a$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, isDecorative: isDecorative } = props;
    const [ref, inView] = (0, $kLQGL.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $cozmU.useMemo)(()=>(0, $d8DK7.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $a5rDX.emojiMainStyle)} ${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${(0, $a5rDX.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $a5rDX.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $c66dg.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $2p7KE.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $72OmS.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width; // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $cozmU.useCallback)((event)=>{
        $7cbdfa334838272a$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $cozmU.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).MOUNTED_END); // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
         // onload_start
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $6Y7Xc.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $cozmU.useCallback)(()=>{
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $cozmU.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!(0, $1hQ0e.getDocument)()?.activeElement?.contains(e.target)) e.stopPropagation();
    }, []); // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $cozmU.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const imgAlt = isDecorative ? '' : emoji.name || emoji.shortName || '';
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: imgAlt,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        className: "emoji",
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }); // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpf8v.DeletableEmojiTooltipContent), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Ya31.default), {
        onClick: (event)=>(0, $3cA9y.handleDelete)(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qxV9.DeletableEmojiTooltipContentForScreenReader), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};
module.exports["ImageEmoji"] = $7cbdfa334838272a$export$99dfeb9d71c11788;

});

parcelRegister("c66dg", function(module, exports) {

var $d96oP = parcelRequire("d96oP");

const $c6cbfe5640e3365a$var$getHeight = (fitToHeight)=>(0, $d96oP.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $c6cbfe5640e3365a$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $c6cbfe5640e3365a$var$getHeight(fitToHeight) > emoji.representation.height);
module.exports["shouldUseAltRepresentation"] = $c6cbfe5640e3365a$export$b7e9058f156d8d19;

});

parcelRegister("kLQGL", function(module, exports) {

var $5sUij = parcelRequire("5sUij");


var $6Y7Xc = parcelRequire("6Y7Xc");

const $195e4aff720550fa$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $5sUij.useInView)(options);
    if (!(0, $6Y7Xc.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};
module.exports["useInView"] = $195e4aff720550fa$export$2f62ee6831462844;

});

parcelRegister("5sUij", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

"use client";
var $3fab3c301f36e350$var$__defProp = Object.defineProperty;
var $3fab3c301f36e350$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fab3c301f36e350$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fab3c301f36e350$var$__publicField = (obj, key, value)=>$3fab3c301f36e350$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $3fab3c301f36e350$var$observerMap = /* @__PURE__ */ new Map();
var $3fab3c301f36e350$var$RootIds = /* @__PURE__ */ new WeakMap();
var $3fab3c301f36e350$var$rootId = 0;
var $3fab3c301f36e350$var$unsupportedValue = void 0;
function $3fab3c301f36e350$export$2ef3a60ee1f37bec(inView) {
    $3fab3c301f36e350$var$unsupportedValue = inView;
}
function $3fab3c301f36e350$var$getRootId(root) {
    if (!root) return "0";
    if ($3fab3c301f36e350$var$RootIds.has(root)) return $3fab3c301f36e350$var$RootIds.get(root);
    $3fab3c301f36e350$var$rootId += 1;
    $3fab3c301f36e350$var$RootIds.set(root, $3fab3c301f36e350$var$rootId.toString());
    return $3fab3c301f36e350$var$RootIds.get(root);
}
function $3fab3c301f36e350$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $3fab3c301f36e350$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $3fab3c301f36e350$var$createObserver(options) {
    const id = $3fab3c301f36e350$var$optionsToId(options);
    let instance = $3fab3c301f36e350$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $3fab3c301f36e350$var$observerMap.set(id, instance);
    }
    return instance;
}
function $3fab3c301f36e350$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $3fab3c301f36e350$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $3fab3c301f36e350$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $3fab3c301f36e350$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $3fab3c301f36e350$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $3fab3c301f36e350$export$a62107ca74432f44 = class extends $cozmU.Component {
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $3fab3c301f36e350$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $cozmU.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
    constructor(props){
        super(props);
        $3fab3c301f36e350$var$__publicField(this, "node", null);
        $3fab3c301f36e350$var$__publicField(this, "_unobserveCb", null);
        $3fab3c301f36e350$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $3fab3c301f36e350$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$3fab3c301f36e350$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
};
function $3fab3c301f36e350$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $cozmU.useState(null);
    const callback = $cozmU.useRef(onChange);
    const [state, setState] = $cozmU.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $cozmU.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $3fab3c301f36e350$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $cozmU.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map
module.exports["useInView"] = $3fab3c301f36e350$export$2f62ee6831462844;

});

parcelRegister("6Y7Xc", function(module, exports) {
const $ce7a17dc9ab6d41e$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $ce7a17dc9ab6d41e$var$result.mac = /Mac/.test(navigator.platform);
    $ce7a17dc9ab6d41e$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $ce7a17dc9ab6d41e$export$2e2bcd8739ae039 = $ce7a17dc9ab6d41e$var$result;
module.exports["default"] = $ce7a17dc9ab6d41e$export$2e2bcd8739ae039;

});

parcelRegister("kpf8v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4S9CC = parcelRequire("4S9CC");


var $1kRhf = parcelRequire("1kRhf");


var $47c2F = parcelRequire("47c2F");

const $62e6710b6e922942$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47c2F.ToolTipContentWithKeymap), {
        description: formatMessage((0, $1kRhf.messages).deleteEmojiTooltip),
        keymap: (0, $4S9CC.backspace)
    });
};
module.exports["DeletableEmojiTooltipContent"] = $62e6710b6e922942$export$4727956877b6f612;

});

parcelRegister("4S9CC", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $aokDQ = parcelRequire("aokDQ");

const $05c9bdca5f91550e$export$1ea584ca7009bcc1 = (0, $aokDQ.makeKeyMapWithCommon)('Backspace', 'Backspace');
const $05c9bdca5f91550e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
module.exports["backspace"] = $05c9bdca5f91550e$export$1ea584ca7009bcc1;
module.exports["arrowKeysMap"] = $05c9bdca5f91550e$export$8d734690d3a46118;

});

parcelRegister("aokDQ", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $3gg6O = parcelRequire("3gg6O");

function $f45a08709afce394$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $3gg6O.makeKeymap)(description, windows, mac, common);
}
module.exports["makeKeyMapWithCommon"] = $f45a08709afce394$export$7e6b588cc98b34f1;

});

parcelRegister("3gg6O", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $53c540ad50774e92$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
module.exports["makeKeymap"] = $53c540ad50774e92$export$d8a7f422d8d42038;

});

parcelRegister("47c2F", function(module, exports) {
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $eOYxO = parcelRequire("eOYxO");

const $99794ca75c05544d$var$tooltipShortcutStyle = null;
const $99794ca75c05544d$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $eOYxO.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0KLXruB4sa _0Of8r2dnbC _1wydGWdnbC _2Zuz6QFQfX _1ZnuxbFQfX _1iKH5nD0un"
        ])
    }, shortcut)) : null;
});
module.exports["ToolTipContentWithKeymap"] = $99794ca75c05544d$export$c7308f5f9ed494ac;

});

parcelRegister("eOYxO", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $6Y7Xc = parcelRequire("6Y7Xc");


var $4S9CC = parcelRequire("4S9CC");

function $eaa3cf1c1fac6b0b$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $6Y7Xc.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $4S9CC.arrowKeysMap)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $6Y7Xc.default).mac ? '' : '+');
}
module.exports["formatShortcut"] = $eaa3cf1c1fac6b0b$export$384a290f8c265cc5;

});

parcelRegister("9qxV9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9GVkD = parcelRequire("9GVkD");


var $1kRhf = parcelRequire("1kRhf");

const $1d251284bd364c50$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $1kRhf.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};
module.exports["DeletableEmojiTooltipContentForScreenReader"] = $1d251284bd364c50$export$d151e4941072147c;

});

parcelRegister("7Ya31", function(module, exports) {
/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $5avUB = parcelRequire("5avUB");


var $iMnC5 = parcelRequire("iMnC5");


var $l4yrE = parcelRequire("l4yrE");


var $7gAFi = parcelRequire("7gAFi");


var $a5rDX = parcelRequire("a5rDX");

const $beda65cbb4bf246c$var$styles = {
    boxWrapperStyle: "_39xV0270UD _0jFU0V70UD"
};
const $beda65cbb4bf246c$var$deleteButton = null;
const $beda65cbb4bf246c$var$refreshedDeleteButton = null; /**
                                     * Test id for wrapper Emoji delete button
                                     */ 
const $beda65cbb4bf246c$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $beda65cbb4bf246c$var$DeleteButton = (props)=>{
    const isRefreshEnabled = (0, $7gAFi.isRefreshEmojiPickerEnabled)();
    return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_0fKRyPnQyn _3iDTPbQ4SZ _1mT5xdWVPG _2IhTon4F84 _4ApkO24F84 _42Yu6B7dHp _2CTNV7dnbC",
            isRefreshEnabled && "_2IhTon5UaJ _4ApkO25UaJ",
            (0, $a5rDX.emojiDeleteButton)
        ]),
        "data-testid": $beda65cbb4bf246c$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $beda65cbb4bf246c$var$styles.boxWrapperStyle
        }, isRefreshEnabled ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: (0, $l4yrE.deleteEmojiLabel),
            color: "var(--ds-icon, #292A2E)",
            size: "medium"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: (0, $l4yrE.deleteEmojiLabel),
            color: "var(--ds-text-subtle, #505258)",
            size: "small"
        })),
        onClick: props.onClick,
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
};
var $beda65cbb4bf246c$export$2e2bcd8739ae039 = $beda65cbb4bf246c$var$DeleteButton;
module.exports["default"] = $beda65cbb4bf246c$export$2e2bcd8739ae039;

});

parcelRegister("7gAFi", function(module, exports) {

var $fhEsv = parcelRequire("fhEsv");

const $5261e6b835b6a009$export$6e2c41f8d3a0d428 = ()=>{
    return (0, $fhEsv.isTeamoji26RefreshEmojiPickerEnabled)();
};
module.exports["isRefreshEmojiPickerEnabled"] = $5261e6b835b6a009$export$6e2c41f8d3a0d428;

});

parcelRegister("1UHRU", function(module, exports) {
/* SpriteEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $1FzXO = parcelRequire("1FzXO");


var $a5rDX = parcelRequire("a5rDX");

const $1c04ac8f330413af$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ $cozmU.createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $a5rDX.emojiSprite),
        style: style
    })));
};
module.exports["SpriteEmoji"] = $1c04ac8f330413af$export$ef49ddbb198ce334;

});

parcelRegister("iKpb2", function(module, exports) {
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ieeJu = parcelRequire("ieeJu");


var $l4yrE = parcelRequire("l4yrE");


var $dprMh = parcelRequire("dprMh");


var $a5rDX = parcelRequire("a5rDX");

const $60c089d6c9d8e0bd$var$placeholderContainer = null;
const $60c089d6c9d8e0bd$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $l4yrE.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $l4yrE.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $l4yrE.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": (0, $dprMh.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbvbI6 _0KLXru9r67 _1RrJLit2nV _1ANEUSLRg7 _2fwxA5DIqT",
            [
                (0, $a5rDX.placeholder),
                xcss
            ].join(' ')
        ]),
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $60c089d6c9d8e0bd$export$2e2bcd8739ae039 /**
                                  * @deprecated Use `import { emojiPlaceholderTestId } from '@atlaskit/emoji/emoji-placeholder'` instead.
                                  */  = $60c089d6c9d8e0bd$var$EmojiPlaceholder;
module.exports["default"] = $60c089d6c9d8e0bd$export$2e2bcd8739ae039;

});

parcelRegister("dprMh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $79e8257d19df66c1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
module.exports["emojiPlaceholderTestId"] = $79e8257d19df66c1$export$73987987fac5266b;

});

parcelRegister("9Jo6P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $f68116e60c972a4f$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}
module.exports["UfoErrorBoundary"] = $f68116e60c972a4f$export$5ef1c2550074a375;

});

parcelRegister("6Gf6E", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cRhiT = parcelRequire("cRhiT");


var $ieeJu = parcelRequire("ieeJu");


var $haHjk = parcelRequire("haHjk");


var $ktiH5 = parcelRequire("ktiH5");


var $ft6gK = parcelRequire("ft6gK");


var $ipkS0 = parcelRequire("ipkS0");


const $b84cbf4837a1f547$var$LazyAkCodeBlock = /*#__PURE__*/ (0, $cozmU.lazy)(// eslint-disable-next-line require-await
(0, $ipkS0.trackReactLazy)("rl-HDTU_y", async ()=>(parcelRequire("lQxzK"))));
const $b84cbf4837a1f547$var$joinWithSpaces = (...strs)=>strs.join(' ');
const $b84cbf4837a1f547$var$MemoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $cozmU.memo)((0, $ft6gK.default));
const $b84cbf4837a1f547$var$WindowedCodeBlock = ({ text: text, language: language, allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, hideLineNumbers: hideLineNumbers = false, className: rootClassName, wrap: wrap })=>{
    const { isInViewport: isInViewport, trackingRef: trackingRef } = (0, $haHjk.useInViewport)();
    const className = $b84cbf4837a1f547$var$joinWithSpaces((0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, rootClassName);
    const memoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $lOiVq.jsx)($b84cbf4837a1f547$var$MemoizedLightWeightCodeBlock, {
        ref: trackingRef,
        text: text,
        hideLineNumbers: (0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: rootClassName
    });
    const [wrapLongLines, setWrapLongLines] = (0, $cozmU.useState)(()=>(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && Boolean(wrap));
    return isInViewport ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Suspense), {
        fallback: memoizedLightWeightCodeBlock
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ktiH5.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        language: language,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($b84cbf4837a1f547$var$LazyAkCodeBlock, {
        language: language,
        text: text,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        shouldShowLineNumbers: !((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers),
        hasBidiWarnings: false
    })))) : memoizedLightWeightCodeBlock;
};
var $b84cbf4837a1f547$export$2e2bcd8739ae039 = $b84cbf4837a1f547$var$WindowedCodeBlock;
module.exports["default"] = $b84cbf4837a1f547$export$2e2bcd8739ae039;

});

parcelRegister("haHjk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9e23c124dab9d57b$export$6215040b989f9b0f = ()=>{
    const trackingRef = (0, $cozmU.useRef)(null);
    const [isInViewport, setIsInViewport] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!trackingRef || !trackingRef?.current) return;
        const target = trackingRef.current;
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) setIsInViewport(true);
        });
        observer.observe(target);
        return ()=>observer.disconnect();
    }, [
        trackingRef
    ]);
    return {
        isInViewport: isInViewport,
        trackingRef: trackingRef
    };
};
module.exports["useInViewport"] = $9e23c124dab9d57b$export$6215040b989f9b0f;

});

parcelRegister("ktiH5", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $cRhiT = parcelRequire("cRhiT");


var $lWhNb = parcelRequire("lWhNb");

const $9f5f5a5e204d1173$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $lOiVq.css)({
    tabSize: 4,
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $cRhiT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $9f5f5a5e204d1173$var$denseModeOverrides = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $cRhiT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5em'
    }
});
const $9f5f5a5e204d1173$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, language: language, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-local-id": localId,
        css: [
            $9f5f5a5e204d1173$var$codeBlockStyleOverrides,
            $9f5f5a5e204d1173$var$denseModeOverrides
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lWhNb.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        allowWrapCodeBlock: allowWrapCodeBlock,
        language: language,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $9f5f5a5e204d1173$export$2e2bcd8739ae039 = $9f5f5a5e204d1173$var$CodeBlockContainer;
module.exports["default"] = $9f5f5a5e204d1173$export$2e2bcd8739ae039;

});

parcelRegister("lWhNb", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $l2vLQ = parcelRequire("l2vLQ");


var $ZsWjb = parcelRequire("ZsWjb");


var $c7hhP = parcelRequire("c7hhP");

const $52190c6d0ebde3fc$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'sticky',
    top: '0px',
    background: `${"var(--ds-surface, #FFFFFF)"}`
});
const $52190c6d0ebde3fc$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${"var(--ds-surface-overlay, #FFFFFF)"}`,
        color: `${"var(--ds-icon, #292A2E)"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${"var(--ds-surface-overlay-hovered, #F0F1F2)"}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${"var(--ds-background-neutral-bold-pressed, #505258)"}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon-inverse, #FFFFFF)"} !important`
        }
    }
});
const $52190c6d0ebde3fc$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowDownloadCodeBlock: allowDownloadCodeBlock, allowWrapCodeBlock: allowWrapCodeBlock, language: language, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $52190c6d0ebde3fc$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $52190c6d0ebde3fc$var$codeBlockButtonsStyle
    }, allowDownloadCodeBlock && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ZsWjb.default), {
        content: text,
        language: language ?? null
    }), allowWrapCodeBlock && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c7hhP.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l2vLQ.default), {
        content: text
    })));
};
var $52190c6d0ebde3fc$export$2e2bcd8739ae039 = $52190c6d0ebde3fc$var$CodeBlockButtonContainer;
module.exports["default"] = $52190c6d0ebde3fc$export$2e2bcd8739ae039;

});

parcelRegister("l2vLQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $go7uG = parcelRequire("go7uG");


var $fHs3z = parcelRequire("fHs3z");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");


var $jyFxy = parcelRequire("jyFxy");

const $4d50ddf7976fff0b$var$CopyButton = ({ content: content, intl: intl })=>{
    const copyCodeToClipboardMessage = (0, $4o0zT.isExperimentEnabled)('platform_editor_a11y_codeblock_copy_name') ? (0, $go7uG.codeBlockButtonMessages).copyCodeSnippetToClipboard : (0, $go7uG.codeBlockButtonMessages).copyCodeToClipboard;
    const [tooltip, setTooltip] = (0, $cozmU.useState)(intl.formatMessage(copyCodeToClipboardMessage));
    const [className, setClassName] = (0, $cozmU.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage(copyCodeToClipboardMessage));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top",
            hasNewContentOnTriggerClick: true
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            onMouseLeave: onMouseLeave,
            onBlur: onMouseLeave
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
            appearance: "subtle",
            "aria-haspopup": (0, $iDrrr.fg)('platform_editor_a11y_codeblock_haspopup') ? undefined : true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                label: tooltip
            }),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                (0, $jyFxy.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $go7uG.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
const $4d50ddf7976fff0b$var$_default_1 = (0, $kSwu1.injectIntl)($4d50ddf7976fff0b$var$CopyButton);
var $4d50ddf7976fff0b$export$2e2bcd8739ae039 = $4d50ddf7976fff0b$var$_default_1;
module.exports["default"] = $4d50ddf7976fff0b$export$2e2bcd8739ae039;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copyCodeSnippetToClipboard: {
        id: "editor-common.messages.codeBlockButton.copyCodeSnippetToClipboard",
        defaultMessage: "Copy code text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("ZsWjb", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $go7uG = parcelRequire("go7uG");


var $6Fmj3 = parcelRequire("6Fmj3");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2cfbdf1fa443b38$var$FILENAME_COMMENT_REGEX = /^(?:#|\/\/|<!--)\s*([\w.\-]+)\s*(?:-->)?$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a2cfbdf1fa443b38$var$FILE_EXTENSION_STRIP_REGEX = /\.[^.]+$/;
/**
 * NOTE: The language-to-extension mapping logic below is intentionally duplicated in
 * platform/packages/ai-mate/conversation-assistant-utils/src/downloadCodeBlock.ts.
 * This is because @atlaskit/renderer cannot import from @atlassian/conversation-assistant-utils
 * (cross-package dependency not allowed). If you update the logic here, update it there too.
 *
 * Maps ADF code block language names to file extensions.
 * Inlined here to avoid cross-package dependencies on ai-mate packages.
 */ const $a2cfbdf1fa443b38$var$languageToExtension = {
    bash: 'sh',
    c: 'c',
    cpp: 'cpp',
    css: 'css',
    csv: 'csv',
    go: 'go',
    htm: 'html',
    html: 'html',
    java: 'java',
    javascript: 'js',
    js: 'js',
    json: 'json',
    jsx: 'jsx',
    less: 'less',
    markdown: 'md',
    md: 'md',
    python: 'py',
    ruby: 'rb',
    rust: 'rs',
    scss: 'scss',
    sh: 'sh',
    shell: 'sh',
    sql: 'sql',
    ts: 'ts',
    tsx: 'tsx',
    typescript: 'ts',
    xml: 'xml',
    yaml: 'yaml',
    yml: 'yaml'
};
const $a2cfbdf1fa443b38$var$getFileExtension = (language)=>{
    if (!language) return 'txt';
    return $a2cfbdf1fa443b38$var$languageToExtension[language.toLowerCase()] ?? 'txt';
};
const $a2cfbdf1fa443b38$var$suggestBaseName = (content)=>{
    const firstMeaningfulLine = content.split('\n').find((l)=>l.trim()) ?? '';
    const filenameMatch = firstMeaningfulLine.trim().match($a2cfbdf1fa443b38$var$FILENAME_COMMENT_REGEX);
    if (filenameMatch) return filenameMatch[1].replace($a2cfbdf1fa443b38$var$FILE_EXTENSION_STRIP_REGEX, '') || 'rovo-snippet';
    const cleaned = firstMeaningfulLine// Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    .replace(/[^a-zA-Z0-9\s]/g, ' ').trim()// eslint-disable-next-line require-unicode-regexp
    .replace(/\s+/g, '-').toLowerCase().slice(0, 30);
    return cleaned || 'rovo-snippet';
};
const $a2cfbdf1fa443b38$var$triggerDownload = (content, language)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    if (typeof document === 'undefined') return;
    const extension = $a2cfbdf1fa443b38$var$getFileExtension(language);
    const resolvedFilename = `${$a2cfbdf1fa443b38$var$suggestBaseName(content)}.${extension}`;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const doc = document;
    const blob = new Blob([
        content
    ], {
        type: 'text/plain'
    });
    const url = URL.createObjectURL(blob);
    const anchor = doc.createElement('a');
    anchor.href = url;
    anchor.download = resolvedFilename;
    anchor.style.display = 'none';
    doc.body.appendChild(anchor);
    anchor.dispatchEvent(new MouseEvent('click', {
        bubbles: false,
        cancelable: true,
        view: window
    }));
    doc.body.removeChild(anchor);
    // Defer revocation to avoid race condition in Safari/Firefox
    setTimeout(()=>URL.revokeObjectURL(url), 0);
};
const $a2cfbdf1fa443b38$var$DownloadButton = ({ content: content, language: language, intl: intl })=>{
    const tooltip = intl.formatMessage((0, $go7uG.codeBlockButtonMessages).downloadCodeBlock);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            label: tooltip,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_DOWNLOAD,
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                $a2cfbdf1fa443b38$var$triggerDownload(content, language);
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
const $a2cfbdf1fa443b38$var$_default_1 = (0, $kSwu1.injectIntl)($a2cfbdf1fa443b38$var$DownloadButton);
var $a2cfbdf1fa443b38$export$2e2bcd8739ae039 = $a2cfbdf1fa443b38$var$_default_1;
module.exports["default"] = $a2cfbdf1fa443b38$export$2e2bcd8739ae039;

});

parcelRegister("c7hhP", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $go7uG = parcelRequire("go7uG");


var $dwAVI = parcelRequire("dwAVI");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $grAaA = parcelRequire("grAaA");


var $GTXrQ = parcelRequire("GTXrQ");

const $43a24c6a53301d6c$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $go7uG.codeBlockButtonMessages).unwrapCode : (0, $go7uG.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
            appearance: "subtle",
            "aria-haspopup": (0, $iDrrr.fg)('platform_editor_a11y_codeblock_haspopup') ? undefined : true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dwAVI))), {
                label: ""
            }),
            isSelected: wrapLongLines,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $GTXrQ.ACTION).CLICKED,
                    actionSubject: (0, $GTXrQ.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $GTXrQ.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $GTXrQ.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
const $43a24c6a53301d6c$var$_default_1 = (0, $kSwu1.injectIntl)($43a24c6a53301d6c$var$CodeBlockWrapButton);
var $43a24c6a53301d6c$export$2e2bcd8739ae039 = $43a24c6a53301d6c$var$_default_1;
module.exports["default"] = $43a24c6a53301d6c$export$2e2bcd8739ae039;

});

parcelRegister("lQxzK", function(module, exports) {

let $fe787fb01d254b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe787fb01d254b96$var$load("kMVpD"),
    $fe787fb01d254b96$var$load("fKQ9j"),
    $fe787fb01d254b96$var$load("b21kU")
]).then(()=>parcelRequire('8hQmz'));

});

parcelRegister("azTKI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $LQnOI = parcelRequire("LQnOI");


var $8Yf90 = parcelRequire("8Yf90");


var $dE1Ef = parcelRequire("dE1Ef");


var $aiIAm = parcelRequire("aiIAm");


var $8hFP3 = parcelRequire("8hFP3");

const $be4360ed45643068$var$getCodeBlockStyles = {
    root: "_2sNsIgNxAV _0bjKvD8fU6 _3hxITiYbGa _3iDTPbQ4SZ _26BoRwSPN1 _4bt5LAIZbP _1ANEUSZYee _3kIIylnHLs _0KLXruTnLi _1UtDYzy7kJ _41xRuTZqHV _0wsbMQZqHV _1Vv2BRZqHV _1MJTRw2ADO _1VRVtu2ADO _3Zw3U32ADO _1sW0GU2ADO _1cpJ0P2ADO _4uAYuq2ADO _3xurjO8OLE _24aN1k8OLE _24cw6O8OLE _2YUq7vT56g _4rwuIAT56g _4relqwT56g _4h2nXCLylE _2X8S4KVo9d _26OL3SA17z _3f1HWyUNDJ _3nEQ9lWVPG _45HGsTogpp _1NDUiPRk67 _2AZQRwRAKS _070NdTe513 _2mR1zoJ5bs _1JRCrsJ5bs _1MrCCcWfES _1fOBFsIZbP _07M2jG7dHp _3UzSvZwPeg _26723KAASz _2bS9wvnQyn _1pRU7ZnQyn _3PHYjSnQyn _1KFGm0nQyn _2xUcbno0UC _03sBWZo0UC _1vNOowdEFh _3KfFpTdEFh _2dLOxDHZdu _37Zs15HZdu _1xk3cBWVPG _2HVJpyWVPG _3moo9OLRg7 _3wNpSILRg7 _3RewtzHZdu _1y77T5HZdu _18Ay7cDMqu _1RZDyz7bNJ _1ez7v1JUHd _0gsOWsgpwa _1czuGQWfES _3uxU7hecOK _3OqUgdUS2K _25mvE1KG6X _2yiaa3KG6X _3OqUgdvLZJ _1PWdmGvLZJ _45Qk4AYbGa _3BIJL2YbGa _1jeJFj0dzo _1poUkx0dzo _1Ifefc2ADO _0OxqLg2ADO _35sviK2ADO _4FTb7w2ADO _2e6T0BWfES _0iupi1WfES _0YOcqP2Njc _0Oip2Y2Njc _2lek4NdnbC _34MfQ4dnbC _1tklhi1PzL _0MrNBj1PzL _2zMfI7WMvv _17laEUWMvv _4w3UV24WFv _2OfOg54WFv _0DagTWmb2E _0Pms1oquXj _0D6SsjGpkd _1y7ChDGpkd _2hw91PGpkd _0XohueNSuU _1VNVCDNSuU _1v3FcSquXj _0eivC9quXj _1cwHzQZqHV _0EyMX8DIkS _4zNlXb9qYF _4ilBRJy7kJ _2Aqhav9qYF _3HZJ4Jy7kJ _0BGVQj866Z _2yaqNYjgGB _3qO1JaY3Jz _1bWu9ZYfD7 _0cwANAy7kJ _2rPjlHKGUX _3UcXUV866Z _1WAgFnY3Jz _3HDkH0866Z _13xEgzy7kJ _2ikkxZKGUX _0uxFrp9qYF _4G3kv7YfD7 _4tUqIpYfD7 _4c3v8AYfD7 _4qeMtX9qYF _29yBp3Y3Jz _0t7QZoY3Jz _3R7oq7Y3Jz _3flWPdY3Jz _1ED3NYY3Jz _008WkAYfD7 _1nFDoWY3Jz _3WibeRY3Jz _1siGfsY3Jz _37rtJn866Z _4kXAQn866Z _4bhSaL866Z _42VNCi866Z _1kfycv866Z _04xRuFKGUX _0a0obTDIkS _1kLOyZYfD7 _0JDL4nKGUX _16PhfRKGUX _3mKtdo866Z _0CjFNWY3Jz _1JVEKb866Z _0sY6Cf866Z",
    showLineNumbers: "_2PYTHN2Knr _3zmZ6SQ4SZ _2OyLtHdnbC _184mfRdnbC _1Hail4dnbC _3rkWqZdnbC _2v76MbdnbC _3a6DiydnbC",
    dontShowLineNumbers: "_3zmZ6SvLZJ _2OyLtH2ADO _184mfR2ADO _1Hail42ADO _3rkWqZ2ADO _2v76Mb2ADO _3a6Diy2ADO",
    shouldWrapLongLines: "_2B7tyz7dHp",
    dontWrapLongLines: "_2B7tyz7dHp"
}; /**
    * __Code block__
    *
    * A code block highlights an entire block of code and keeps the formatting.
    *
    * - [Examples](https://atlassian.design/components/code/code-block/examples)
    * - [Code](https://atlassian.design/components/code/code-block/code)
    * - [Usage](https://atlassian.design/components/code/code-block/usage)
    */ 
const $be4360ed45643068$var$CodeBlock = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { showLineNumbers: t1, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: t2, language: t3, highlight: t4, highlightedStartText: t5, highlightedEndText: t6, testId: testId, text: text, codeBidiWarnings: t7, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: t8, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: t9, label: t10 } = t0;
    const showLineNumbers = t1 === undefined ? true : t1;
    const firstLineNumber = t2 === undefined ? 1 : t2;
    const providedLanguage = t3 === undefined ? "text" : t3;
    const highlight = t4 === undefined ? "" : t4;
    const highlightedStartText = t5 === undefined ? "Highlight start" : t5;
    const highlightedEndText = t6 === undefined ? "Highlight end" : t6;
    const codeBidiWarnings = t7 === undefined ? true : t7;
    const codeBidiWarningTooltipEnabled = t8 === undefined ? true : t8;
    const shouldWrapLongLines = t9 === undefined ? false : t9;
    const label = t10 === undefined ? "Scrollable content" : t10;
    const scrollableRef = (0, $cozmU.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $cozmU.useState)(false);
    const t11 = text || "";
    let t12;
    if ($[0] !== t11) {
        t12 = t11.split("\n");
        $[0] = t11;
        $[1] = t12;
    } else t12 = $[1];
    const numLines = t12.length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    let t13;
    if ($[2] !== numLines) {
        t13 = numLines ? (0, $dE1Ef.getLineNumWidth)(numLines) : 0;
        $[2] = numLines;
        $[3] = t13;
    } else t13 = $[3];
    const lineNumberWidth = t13;
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    let t14;
    let t15;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            const schedule = (0, $LQnOI.default)(()=>{
                const target = scrollableRef.current;
                target && setShowContentFocus(target.scrollWidth > target.clientWidth);
            });
            schedule();
            const unbindWindowEvent = (0, $cbY7C.bind)(window, {
                type: "resize",
                listener: schedule
            });
            return unbindWindowEvent;
        };
        t15 = [
            scrollableRef
        ];
        $[4] = t14;
        $[5] = t15;
    } else {
        t14 = $[4];
        t15 = $[5];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[6] !== highlight || $[7] !== testId) {
        t16 = {
            highlight: highlight,
            testId: testId
        };
        $[6] = highlight;
        $[7] = testId;
        $[8] = t16;
    } else t16 = $[8];
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $8Yf90.useHighlightLines)(t16);
    let t17;
    if ($[9] !== getHighlightStyles || $[10] !== highlightedLines) {
        t17 = (line)=>getHighlightStyles(line, highlightedLines);
        $[9] = getHighlightStyles;
        $[10] = highlightedLines;
        $[11] = t17;
    } else t17 = $[11];
    const getLineProps = t17;
    let t18;
    if ($[12] !== providedLanguage) {
        t18 = (0, $aiIAm.normalizeLanguage)(providedLanguage);
        $[12] = providedLanguage;
        $[13] = t18;
    } else t18 = $[13];
    const language = t18;
    const languageToUse = text ? language : "text";
    const t19 = `calc(${lineNumberWidth} + 16px)`;
    let t20;
    if ($[14] !== highlightedEndText || $[15] !== highlightedStartText || $[16] !== t19) {
        t20 = {
            "--ads-code-line-number-width": t19,
            "--ads-highlighted-start-text": highlightedStartText,
            "--ads-highlighted-end-text": highlightedEndText
        };
        $[14] = highlightedEndText;
        $[15] = highlightedStartText;
        $[16] = t19;
        $[17] = t20;
    } else t20 = $[17];
    const t21 = highlight.length > 0 || !!testId;
    const t22 = showContentFocus ? "0" : undefined;
    const t23 = showContentFocus ? label : undefined;
    const t24 = showContentFocus ? "region" : undefined;
    const t25 = shouldWrapLongLines ? $be4360ed45643068$var$getCodeBlockStyles.shouldWrapLongLines : $be4360ed45643068$var$getCodeBlockStyles.dontWrapLongLines;
    const t26 = shouldShowLineNumbersValue ? $be4360ed45643068$var$getCodeBlockStyles.showLineNumbers : $be4360ed45643068$var$getCodeBlockStyles.dontShowLineNumbers;
    let t27;
    if ($[18] !== t25 || $[19] !== t26) {
        t27 = (0, $hekY6.default)([
            $be4360ed45643068$var$getCodeBlockStyles.root,
            t25,
            t26
        ]);
        $[18] = t25;
        $[19] = t26;
        $[20] = t27;
    } else t27 = $[20];
    let t28;
    if ($[21] !== codeBidiWarningLabel || $[22] !== firstLineNumber || $[23] !== getLineProps || $[24] !== language || $[25] !== languageToUse || $[26] !== shouldEnableTooltip || $[27] !== shouldShowBidiWarnings || $[28] !== shouldShowLineNumbersValue || $[29] !== shouldWrapLongLines || $[30] !== t20 || $[31] !== t21 || $[32] !== t22 || $[33] !== t23 || $[34] !== t24 || $[35] !== t27 || $[36] !== testId || $[37] !== text) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hFP3.default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            style: t20,
            showLineNumbers: shouldShowLineNumbersValue,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: t21,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: shouldShowBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: shouldEnableTooltip,
            text: text,
            tabIndex: t22,
            "aria-label": t23,
            role: t24,
            scrollRef: scrollableRef,
            className: t27
        });
        $[21] = codeBidiWarningLabel;
        $[22] = firstLineNumber;
        $[23] = getLineProps;
        $[24] = language;
        $[25] = languageToUse;
        $[26] = shouldEnableTooltip;
        $[27] = shouldShowBidiWarnings;
        $[28] = shouldShowLineNumbersValue;
        $[29] = shouldWrapLongLines;
        $[30] = t20;
        $[31] = t21;
        $[32] = t22;
        $[33] = t23;
        $[34] = t24;
        $[35] = t27;
        $[36] = testId;
        $[37] = text;
        $[38] = t28;
    } else t28 = $[38];
    return t28;
} : ({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' })=>{
    const scrollableRef = (0, $cozmU.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $cozmU.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $dE1Ef.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $cozmU.useEffect)(()=>{
        const schedule = (0, $LQnOI.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $8Yf90.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $cozmU.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $cozmU.useMemo)(()=>(0, $aiIAm.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hFP3.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hekY6.default)([
            $be4360ed45643068$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $be4360ed45643068$var$getCodeBlockStyles.shouldWrapLongLines : $be4360ed45643068$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $be4360ed45643068$var$getCodeBlockStyles.showLineNumbers : $be4360ed45643068$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $be4360ed45643068$export$2e2bcd8739ae039 = $be4360ed45643068$var$CodeBlock;
module.exports["default"] = $be4360ed45643068$export$2e2bcd8739ae039;

});

parcelRegister("8Yf90", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $b6616760b57d61ef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $b6616760b57d61ef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $b6616760b57d61ef$export$84415a200bdf33ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { highlight: t1, testId: testId } = t0;
    const highlight = t1 === undefined ? "" : t1;
    let t2;
    bb0: {
        if (!highlight) {
            let t3;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = [];
                $[0] = t3;
            } else t3 = $[0];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[1] !== highlight) {
            t3 = highlight.split(",").map($b6616760b57d61ef$var$_temp3).reduce($b6616760b57d61ef$var$_temp4, []) || [];
            $[1] = highlight;
            $[2] = t3;
        } else t3 = $[2];
        t2 = t3;
    }
    const highlightedLines = t2;
    let t3;
    if ($[3] !== highlight || $[4] !== testId) {
        t3 = (lineNumber, highlightedLines_0)=>{
            if (!highlight || highlightedLines_0.length === 0) return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines_0.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    "data-ds--code--row--highlight": ""
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
        };
        $[3] = highlight;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    const getHighlightStyles = t3;
    let t4;
    if ($[6] !== getHighlightStyles || $[7] !== highlightedLines) {
        t4 = {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
        $[6] = getHighlightStyles;
        $[7] = highlightedLines;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $cozmU.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $cozmU.useCallback)((lineNumber, highlightedLines_0)=>{
        if (!highlight || highlightedLines_0.length === 0) return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines_0.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $b6616760b57d61ef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
function $b6616760b57d61ef$var$_temp(a, b) {
    return a - b;
}
function $b6616760b57d61ef$var$_temp2(_, index) {
    return index;
}
function $b6616760b57d61ef$var$_temp3(num) {
    if (num.indexOf("-") > 0) {
        const [from, to] = num.split("-").map(Number).sort($b6616760b57d61ef$var$_temp);
        return Array(to + 1).fill(undefined).map($b6616760b57d61ef$var$_temp2).slice(from, to + 1);
    }
    return Number(num);
}
function $b6616760b57d61ef$var$_temp4(acc, val) {
    return acc.concat(val);
}
module.exports["useHighlightLines"] = $b6616760b57d61ef$export$84415a200bdf33ed;

});

parcelRegister("dE1Ef", function(module, exports) {
const $ddf77cb4ea5c6975$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $ddf77cb4ea5c6975$export$cb7aec0206b595d2;

});

parcelRegister("aiIAm", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $8Xus6 = parcelRequire("8Xus6");

const $fd1f127bb5d9a2d7$export$f38728011c178796 = (0, $dOBRD.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Xus6.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $fd1f127bb5d9a2d7$export$f38728011c178796;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("8hFP3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $dy0x0 = parcelRequire("dy0x0");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $3e52128a57221d8f$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $8aG6j.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $dy0x0.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $3e52128a57221d8f$var$asyncGenerator = $3e52128a57221d8f$var$generator({
    loader: ()=>(parcelRequire("fVAUw")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $3e52128a57221d8f$export$2e2bcd8739ae039 = $3e52128a57221d8f$var$asyncGenerator;
module.exports["default"] = $3e52128a57221d8f$export$2e2bcd8739ae039;

});

parcelRegister("dy0x0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $guTSu = parcelRequire("guTSu");


var $9kQvF = parcelRequire("9kQvF");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $5653218f26b4434f$var$Highlight = /*#__PURE__*/ (0, $cozmU.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $guTSu.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $9kQvF.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $5653218f26b4434f$export$2e2bcd8739ae039 = $5653218f26b4434f$var$Highlight;
module.exports["default"] = $5653218f26b4434f$export$2e2bcd8739ae039;

});

parcelRegister("guTSu", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ca4c69dbd48716$export$2e2bcd8739ae039);

var $felT0 = parcelRequire("felT0");


var $h4laV = parcelRequire("h4laV");


var $bGjaO = parcelRequire("bGjaO");


var $8vsoX = parcelRequire("8vsoX");

const $65ca4c69dbd48716$var$newLineRegex = /\n/g;
function $65ca4c69dbd48716$var$getNewLines(str) {
    return str.match($65ca4c69dbd48716$var$newLineRegex);
}
function $65ca4c69dbd48716$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $8vsoX.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $felT0.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $bGjaO.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $65ca4c69dbd48716$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $h4laV.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $h4laV.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("felT0", function(module, exports) {

var $h4laV = parcelRequire("h4laV");


var $8SWaI = parcelRequire("8SWaI");

function $072d30781f36cca2$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $h4laV.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $8SWaI.default)(lineNumber));
            return children;
        }
    };
}
var $072d30781f36cca2$export$2e2bcd8739ae039 = $072d30781f36cca2$var$createLineGenerator;
module.exports["default"] = $072d30781f36cca2$export$2e2bcd8739ae039;

});

parcelRegister("h4laV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f661f77f5eb16d1$export$2e2bcd8739ae039);

var $8SWaI = parcelRequire("8SWaI");

function $4f661f77f5eb16d1$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $8SWaI.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $8SWaI.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("8SWaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e34657173dc8a32$export$2e2bcd8739ae039);
function $1e34657173dc8a32$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("bGjaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2b14fb4112a1d0b$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");


var $h4laV = parcelRequire("h4laV");

function $f2b14fb4112a1d0b$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $h4laV.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            // If this node is a re-highlighted fenced code-block wrapper (added by
            // rehighlightFencedBlocks in get-code-tree.tsx), reset the accumulated
            // class list instead of concatenating onto ancestors.  Without this,
            // every token inside the fenced block inherits all ancestor classes
            // (e.g. "token code token code-block language-jsx token plain-text").
            const nodeClasses = node.properties.className || [];
            const isCodeBlock = (0, $iDrrr.fg)('platform-code-highlight-markdown-safe') && nodeClasses.includes('code-block');
            // When entering a re-highlighted fenced code-block wrapper, reset the
            // accumulated ancestor classes to empty so children only carry their
            // own token classes (not the full ancestor chain).
            const classNames = isCodeBlock ? [] : className.concat(nodeClasses);
            $f2b14fb4112a1d0b$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("8vsoX", function(module, exports) {
$parcel$export(module.exports, "default", () => $50be1c6a1c382338$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

/**
 * Extract the plain text content from a list of RefractorNodes.
 */ function $50be1c6a1c382338$var$extractText(nodes) {
    return nodes.map((n)=>{
        if (n.type === 'text') return n.value;
        return n.children ? $50be1c6a1c382338$var$extractText(n.children) : '';
    }).join('');
}
/**
 * Walk the safe-highlighted AST and, for every fenced code block (a `token code`
 * span), replace the raw text child with a properly highlighted `token code-block
 * language-{lang}` span so that inner tokens carry the correct classes.
 */ function $50be1c6a1c382338$var$rehighlightFencedBlocks(nodes, astGenerator) {
    const refractorLike = astGenerator;
    return nodes.map((node)=>{
        if (node.type !== 'element') return node;
        const classes = node.properties?.className ?? [];
        const isCodeToken = classes.includes('token') && classes.includes('code');
        if (!isCodeToken || !node.children) return {
            ...node,
            children: $50be1c6a1c382338$var$rehighlightFencedBlocks(node.children ?? [], astGenerator)
        };
        // Find the code-language child to determine which sub-language to use.
        const langNode = node.children.find((c)=>c.type === 'element' && c.properties?.className?.includes('code-language'));
        const subLang = langNode && langNode.type === 'element' ? $50be1c6a1c382338$var$extractText(langNode.children ?? []).trim() : null;
        // Find the raw text child that holds the fenced block content (after the
        // opening ``` line and before the closing ```).
        const children = node.children.map((child)=>{
            // This is the raw code content
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            const rawContent = 'value' in child ? child.value : undefined;
            if (!subLang || !rawContent) return child;
            // Only re-highlight when the sub-language is registered with refractor to
            // avoid an uncaught exception.
            const isRegistered = typeof refractorLike.registered === 'function' ? refractorLike.registered(subLang) : Boolean(refractorLike.languages?.[subLang]);
            if (!isRegistered) return child;
            let highlighted;
            try {
                highlighted = astGenerator.highlight(rawContent, subLang);
            } catch  {
                return child;
            }
            // Wrap in a `token code-block language-{lang}` span to match what the
            // normal (non-safe) markdown highlight would produce.
            const codeBlockNode = {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: [
                        'token',
                        'code-block',
                        `language-${subLang}`
                    ]
                },
                children: highlighted
            };
            return codeBlockNode;
        });
        return {
            ...node,
            children: children
        };
    });
}
function $50be1c6a1c382338$var$highlightMarkdownSafely(code, astGenerator) {
    const refractorLike = astGenerator;
    const markdownCodeToken = refractorLike.languages?.markdown?.code;
    const fencedToken = Array.isArray(markdownCodeToken) ? markdownCodeToken[1] : undefined;
    const originalInside = fencedToken?.inside;
    const canDisableEmbeddedCodeBlock = originalInside && 'code-block' in originalInside;
    if (canDisableEmbeddedCodeBlock) {
        const patchedInside = {
            ...originalInside
        };
        delete patchedInside['code-block'];
        fencedToken.inside = patchedInside;
    }
    let result;
    try {
        result = astGenerator.highlight(code, 'markdown');
    } finally{
        if (canDisableEmbeddedCodeBlock) fencedToken.inside = originalInside;
    }
    // Re-highlight inner fenced code blocks so tokens carry proper classes.
    return $50be1c6a1c382338$var$rehighlightFencedBlocks(result, astGenerator);
}
function $50be1c6a1c382338$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        if (language === 'markdown' && (0, $iDrrr.fg)('platform-code-highlight-markdown-safe')) return $50be1c6a1c382338$var$highlightMarkdownSafely(code, astGenerator);
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("9kQvF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $809xX = parcelRequire("809xX");

/**
 * __React Renderer__
 *
 * A component that receives processed code lines and renders them into the code
 * rows inside the wrapping span and nested code tag, applying passed props and
 * code bidi warning config settings.
 */ const $92dee5d6cf819d4e$var$ReactRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ReactRenderer(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig } = t0;
    let t1;
    if ($[0] !== codeBidiWarningConfig || $[1] !== rows) {
        let t2;
        if ($[3] !== codeBidiWarningConfig) {
            t2 = (node, i)=>(0, $809xX.default)({
                    node: node,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment${i}`
                });
            $[3] = codeBidiWarningConfig;
            $[4] = t2;
        } else t2 = $[4];
        t1 = rows.map(t2);
        $[0] = codeBidiWarningConfig;
        $[1] = rows;
        $[2] = t1;
    } else t1 = $[2];
    const renderedRows = t1;
    let t2;
    if ($[5] !== codeTagProps || $[6] !== renderedRows) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        });
        $[5] = codeTagProps;
        $[6] = renderedRows;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== containerProps || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...containerProps,
            children: t2
        });
        $[8] = containerProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function ReactRenderer({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $809xX.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
};
var $92dee5d6cf819d4e$export$2e2bcd8739ae039 = $92dee5d6cf819d4e$var$ReactRenderer;
module.exports["default"] = $92dee5d6cf819d4e$export$2e2bcd8739ae039;

});

parcelRegister("809xX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4471c7360c10a82$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cOjjv = parcelRequire("cOjjv");


var $fYRS9 = parcelRequire("fYRS9");


var $6tTKn = parcelRequire("6tTKn");

function $b4471c7360c10a82$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $b4471c7360c10a82$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $cOjjv.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $6tTKn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $b4471c7360c10a82$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("6tTKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc6767443d5ef390$export$2e2bcd8739ae039);

var $809xX = parcelRequire("809xX");

function $dc6767443d5ef390$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $809xX.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("fVAUw", function(module, exports) {

let $b988cf96a4df261f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b988cf96a4df261f$var$load("6BcKU"),
    $b988cf96a4df261f$var$load("jLzUq"),
    $b988cf96a4df261f$var$load("aHPkU"),
    $b988cf96a4df261f$var$load("eFN6F"),
    $b988cf96a4df261f$var$load("6y28K"),
    $b988cf96a4df261f$var$load("70T6q"),
    $b988cf96a4df261f$var$load("3Q1al"),
    $b988cf96a4df261f$var$load("kZNtA"),
    $b988cf96a4df261f$var$load("dJz5X"),
    $b988cf96a4df261f$var$load("cYM9J"),
    $b988cf96a4df261f$var$load("1lMYe"),
    $b988cf96a4df261f$var$load("hGWdL"),
    $b988cf96a4df261f$var$load("8mXuQ"),
    $b988cf96a4df261f$var$load("iweX1"),
    $b988cf96a4df261f$var$load("dJHgt"),
    $b988cf96a4df261f$var$load("ilPgZ"),
    $b988cf96a4df261f$var$load("18ynq"),
    $b988cf96a4df261f$var$load("91r0n"),
    $b988cf96a4df261f$var$load("krBs8"),
    $b988cf96a4df261f$var$load("i2zNU"),
    $b988cf96a4df261f$var$load("1djfG"),
    $b988cf96a4df261f$var$load("5eCbj"),
    $b988cf96a4df261f$var$load("b6K6H"),
    $b988cf96a4df261f$var$load("d5Kce"),
    $b988cf96a4df261f$var$load("eRRvI"),
    $b988cf96a4df261f$var$load("lpmt6"),
    $b988cf96a4df261f$var$load("cEygf"),
    $b988cf96a4df261f$var$load("hOZqL"),
    $b988cf96a4df261f$var$load("5wICh"),
    $b988cf96a4df261f$var$load("arxq8"),
    $b988cf96a4df261f$var$load("jlfAK"),
    $b988cf96a4df261f$var$load("flGYk"),
    $b988cf96a4df261f$var$load("9SnQD"),
    $b988cf96a4df261f$var$load("da56Y"),
    $b988cf96a4df261f$var$load("g6dof"),
    $b988cf96a4df261f$var$load("bAPA5"),
    $b988cf96a4df261f$var$load("4aYRs"),
    $b988cf96a4df261f$var$load("dtWTG"),
    $b988cf96a4df261f$var$load("eG8G4"),
    $b988cf96a4df261f$var$load("htCkI"),
    $b988cf96a4df261f$var$load("g28Sl"),
    $b988cf96a4df261f$var$load("6gMuM"),
    $b988cf96a4df261f$var$load("juHD5"),
    $b988cf96a4df261f$var$load("ivuvF"),
    $b988cf96a4df261f$var$load("fDDPF"),
    $b988cf96a4df261f$var$load("lBGAC"),
    $b988cf96a4df261f$var$load("1i9T4"),
    $b988cf96a4df261f$var$load("6M79T"),
    $b988cf96a4df261f$var$load("6gFO0"),
    $b988cf96a4df261f$var$load("20IMn")
]).then(()=>parcelRequire('lRcwr'));

});

parcelRegister("6KU95", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $azTKI = parcelRequire("azTKI");


var $cRhiT = parcelRequire("cRhiT");


var $ieeJu = parcelRequire("ieeJu");


var $ktiH5 = parcelRequire("ktiH5");

function $70357f4ec334e6c0$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, allowDownloadCodeBlock: allowDownloadCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, hideLineNumbers: hideLineNumbers = false, localId: localId, wrap: wrap } = props;
    const className = [
        (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $cozmU.useState)(()=>(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && Boolean(wrap));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ktiH5.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        allowDownloadCodeBlock: allowDownloadCodeBlock,
        language: language,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        localId: localId,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $azTKI.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        shouldShowLineNumbers: !((0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && hideLineNumbers),
        hasBidiWarnings: false
    }));
}
const $70357f4ec334e6c0$var$_default_1 = (0, $kSwu1.injectIntl)($70357f4ec334e6c0$var$CodeBlock);
var $70357f4ec334e6c0$export$2e2bcd8739ae039 = $70357f4ec334e6c0$var$_default_1;
module.exports["default"] = $70357f4ec334e6c0$export$2e2bcd8739ae039;

});

parcelRegister("gvXEn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $8kNOP = parcelRequire("8kNOP");

class $732d2f7205e6fea4$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $cozmU.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8kNOP.default), {
            listId: localId,
            children: children
        });
    }
}
module.exports["default"] = $732d2f7205e6fea4$export$2e2bcd8739ae039;

});

parcelRegister("8kNOP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $g8WS7 = parcelRequire("g8WS7");


var $52VjW = parcelRequire("52VjW");

const $7aade51ade799bff$var$listStyles = null;
const $7aade51ade799bff$var$TaskList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { listId: listId, children: children } = t0;
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!children) return null;
    const t1 = "group";
    const t2 = "";
    let t3;
    if ($[0] !== formatMessage) {
        t3 = formatMessage((0, $52VjW.messages).fieldsetLabel);
        $[0] = formatMessage;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_0aNu0LYbGa _2Zuz6QdnbC _1gva8q1Y8M"
        ]);
        $[2] = t4;
    } else t4 = $[2];
    const t5 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                listLocalId: listId,
                listSize: listSize,
                position: idx
            }
        }, child));
    let t6;
    if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: t1,
            "data-task-list-local-id": t2,
            "aria-label": t3,
            className: t4
        }, t5);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!children) return null;
     // Data attributes are required for copy and paste from rendered content
    // to the editor to preserve the task.
    // This allows the editor to differentiate between numbered and ordered lists,
    // and action items, which all share the common '‹li›' element.
    // The value of 'data-task-local-id' should be discarded upon paste, with a
    // a new uuid generated by the editor for the cloned content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $52VjW.messages).fieldsetLabel),
        className: (0, $hekY6.default)([
            "_0aNu0LYbGa _2Zuz6QdnbC _1gva8q1Y8M"
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                listLocalId: listId,
                listSize: listSize,
                position: idx
            }
        }, child);
    }));
};
var $7aade51ade799bff$export$2e2bcd8739ae039 = $7aade51ade799bff$var$TaskList;
module.exports["default"] = $7aade51ade799bff$export$2e2bcd8739ae039;

});

parcelRegister("52VjW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c512c8181206eb99$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    },
    markTaskAsCompleted: {
        id: "platform.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "platform.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    decisionAriaLabel: {
        id: "platform.taskDecision.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "platform.taskDecision.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["messages"] = $c512c8181206eb99$export$defe85febe8b728c;

});

parcelRegister("ckvpk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $eNbr2 = parcelRequire("eNbr2");


var $794I6 = parcelRequire("794I6");


var $mEDVg = parcelRequire("mEDVg");


var $4pA5x = parcelRequire("4pA5x");

class $572f389b36152ea8$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes, disableOnChange: disableOnChange } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $mEDVg.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $mEDVg.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4pA5x.default), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                disableOnChange: disableOnChange,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
module.exports["default"] = $572f389b36152ea8$export$2e2bcd8739ae039;

});

parcelRegister("mEDVg", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $54e06962532c21fc$var$defaultValue = [
    undefined,
    ()=>{}
];
const $54e06962532c21fc$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($54e06962532c21fc$var$defaultValue);
const $54e06962532c21fc$var$reducer = (_state, action)=>{
    return action;
};
function $54e06962532c21fc$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useReducer($54e06962532c21fc$var$reducer, undefined);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($54e06962532c21fc$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $54e06962532c21fc$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($54e06962532c21fc$var$TaskItemsFormatContext);
}
function $54e06962532c21fc$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($54e06962532c21fc$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}
module.exports["TaskItemsFormatProvider"] = $54e06962532c21fc$export$1ca88acfa8fef6b0;
module.exports["useTaskItemsFormatContext"] = $54e06962532c21fc$export$617439880b48c653;
module.exports["TaskItemsFormatConsumer"] = $54e06962532c21fc$export$be32c078f3ebeea0;

});

parcelRegister("4pA5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $89c9a44fb89052c5$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $1uod6 = parcelRequire("1uod6");

function $89c9a44fb89052c5$export$2e2bcd8739ae039(props) {
    const { objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch  {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-task-local-id": props.taskId || '',
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1uod6.default), {
            ...otherProps,
            objectAri: resolvedObjectId,
            isRenderer: isRenderer
        })
    });
}

});

parcelRegister("1uod6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $83cfL = parcelRequire("83cfL");

class $cf79afba58b531c3$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83cfL.default), {
            isDone: isDone,
            isRenderer: isRenderer,
            isFocused: isFocused,
            taskId: taskId,
            onChange: this.handleOnChange,
            onClick: this.handleOnClick,
            appearance: appearance,
            contentRef: contentRef,
            showPlaceholder: showPlaceholder,
            placeholder: placeholder,
            disabled: disabled,
            dataAttributes: dataAttributes,
            inputRef: inputRef
        }, children));
    }
    constructor(props){
        super(props);
        this.mounted = false;
        this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        };
        this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        };
        this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
}
$cf79afba58b531c3$export$2e2bcd8739ae039.defaultProps = {
    appearance: 'inline'
};
module.exports["default"] = $cf79afba58b531c3$export$2e2bcd8739ae039;

});

parcelRegister("83cfL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2VwyL = parcelRequire("2VwyL");


var $lzgC6 = parcelRequire("lzgC6");


var $QJ7O4 = parcelRequire("QJ7O4");


var $d0CGr = parcelRequire("d0CGr");


var $80me9 = parcelRequire("80me9");


var $52VjW = parcelRequire("52VjW");


var $18ZNy = parcelRequire("18ZNy");

const $212e5f1922e9252a$var$CheckboxUncheckedIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.Icon), {
            dangerouslySetGlyph: "<rect width=\"12.5\" height=\"12.5\" x=\"1.75\" y=\"1.75\" stroke=\"currentcolor\" stroke-width=\"1.5\" rx=\"1.25\"/>",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        ...props
    }); /**
                                                                                                                                                                                       * References packages/design-system/checkbox/src/checkbox.tsx
                                                                                                                                                                                       * To be used until mobile editor does not require legacy themed() API anymore,
                                                                                                                                                                                       * which will allow migration to use @atlaskit/checkbox instead
                                                                                                                                                                                       */ 
const $212e5f1922e9252a$var$checkboxStyles = null;
let $212e5f1922e9252a$var$taskCount = 0;
const $212e5f1922e9252a$var$getCheckBoxId = (localId)=>`${localId}-${$212e5f1922e9252a$var$taskCount++}`;
const $212e5f1922e9252a$var$TaskItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(42);
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== taskId) {
        t0 = $212e5f1922e9252a$var$getCheckBoxId(taskId);
        $[0] = taskId;
        $[1] = t0;
    } else t0 = $[1];
    const checkBoxId = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isDone || $[4] !== onChange || $[5] !== taskId) {
        t1 = (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? "checked" : "unchecked";
            if (createAnalyticsEvent) (0, $80me9.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: "action",
                eventType: "ui",
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
        $[2] = createAnalyticsEvent;
        $[3] = isDone;
        $[4] = onChange;
        $[5] = taskId;
        $[6] = t1;
    } else t1 = $[6];
    const handleOnChange = t1;
    let t2;
    if ($[7] !== handleOnChange) {
        t2 = (event)=>{
            if (event.key === "Enter") handleOnChange(event);
        };
        $[7] = handleOnChange;
        $[8] = t2;
    } else t2 = $[8];
    const handleOnKeyPress = t2;
    const localInputRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[9] !== inputRefFromProps) {
        t3 = inputRefFromProps === undefined ? [
            localInputRef
        ] : [
            inputRefFromProps,
            localInputRef
        ];
        $[9] = inputRefFromProps;
        $[10] = t3;
    } else t3 = $[10];
    const inputRef = (0, $2VwyL.useMergeRefs)(t3);
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEoWWg _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _4xdlr07p2s _4gCaOw98eZ _2QqU2pYbGa _0UXt9rT6kp _3vymXgdnbC _1TAPrFdnbC _12zra7dnbC _4gqQundnbC _1BUG4AnQyn _3LgLJknQyn _33xYQJXVX0 _2VdevGFqy6 _2OyTeTHKt7 _0FaG1X7dHp _1IOx4J2Njc _1KpxtsS8kF _2oLtZl715P _2kXGEF715P _1sRR9kiDnZ _1p22ofZqHV _3kmXW6ZqHV _4mmBgUWVPG _0cADMf7Cj1 _4wSwwnnQyn _0SRqqtHtSk _0422iw1Y8M _148SudWVPG _28VVKd5zaO _4he1wK5zaO _2XqjrQogpp _35XZgYvLZJ _18KwGv715P _1NE3IH715P _0QccnXiDnZ _46HRDHey7F _0DdVJjey7F _3Ripac7dHp _1R10kl7zJH _3fKmf0dnbC _0y3WMLWVPG _1HyEhi715P _0iEAnG715P _4dqkZ8iDnZ _2DbpRZ18ZR _4iMPL4oWWg _3WXbLgoWWg _0QiM2WWVPG _0CZMVz715P _3T2ukd715P _30y4AniDnZ _2ztmbdqWX3 _3RuPdLHKt7 _4oEGCYXLOx _1XCDAh6BYM _02icfTXLOx _47hyyTYvD1 _1JlW2UkLmD _07Zf9z6BYM _223H6tkLmD _15y4m1utHW _077SfA9r67 _03K5EYutHW _29Gh4D6BYM _0O3zXs9r67 _0RsWd7VrZW _3m56efVrZW _37It6EVrZW _2NDTdNVrZW _0L0HniVrZW _0R8c3PVrZW _3uACMjVrZW _31MEBPVrZW _4yzLD8oM2E"
        ]);
        $[11] = t4;
    } else t4 = $[11];
    const t5 = isDone ? (0, $52VjW.messages).markTaskAsNotCompleted : (0, $52VjW.messages).markTaskAsCompleted;
    let t6;
    if ($[12] !== formatMessage || $[13] !== t5) {
        t6 = formatMessage(t5);
        $[12] = formatMessage;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    const t7 = !!isDone;
    const t8 = !!disabled;
    let t9;
    if ($[15] !== checkBoxId || $[16] !== handleOnChange || $[17] !== handleOnKeyPress || $[18] !== inputRef || $[19] !== onClick || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            id: checkBoxId,
            "aria-label": t6,
            name: checkBoxId,
            type: "checkbox",
            onChange: handleOnChange,
            onClick: onClick,
            checked: t7,
            disabled: t8,
            suppressHydrationWarning: true,
            onKeyPress: handleOnKeyPress,
            ref: inputRef
        });
        $[15] = checkBoxId;
        $[16] = handleOnChange;
        $[17] = handleOnKeyPress;
        $[18] = inputRef;
        $[19] = onClick;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== isDone) {
        t10 = isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($212e5f1922e9252a$var$CheckboxUncheckedIcon, {
            label: ""
        });
        $[24] = isDone;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            contentEditable: false,
            className: t4
        }, t9, t10);
        $[26] = t10;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    const icon = t11;
    let t12;
    let t13;
    if ($[29] !== inputRef || $[30] !== isFocused) {
        t12 = ()=>{
            if (isFocused && inputRef.current) {
                inputRef.current?.focus();
                inputRef.current?.blur();
                setTimeout(()=>{
                    inputRef.current?.focus();
                }, 100);
            }
        };
        t13 = [
            isFocused,
            inputRef
        ];
        $[29] = inputRef;
        $[30] = isFocused;
        $[31] = t12;
        $[32] = t13;
    } else {
        t12 = $[31];
        t13 = $[32];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t12, t13);
    let t14;
    if ($[33] !== appearance || $[34] !== checkBoxId || $[35] !== children || $[36] !== contentRef || $[37] !== dataAttributes || $[38] !== icon || $[39] !== placeholder || $[40] !== showPlaceholder) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18ZNy.default), {
            appearance: appearance,
            contentRef: contentRef,
            icon: icon,
            placeholder: placeholder,
            showPlaceholder: showPlaceholder,
            itemType: "TASK",
            dataAttributes: dataAttributes,
            checkBoxId: checkBoxId
        }, children);
        $[33] = appearance;
        $[34] = checkBoxId;
        $[35] = children;
        $[36] = contentRef;
        $[37] = dataAttributes;
        $[38] = icon;
        $[39] = placeholder;
        $[40] = showPlaceholder;
        $[41] = t14;
    } else t14 = $[41];
    return t14;
} : (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const checkBoxId = (0, $cozmU.useMemo)(()=>$212e5f1922e9252a$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $cozmU.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $80me9.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $cozmU.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $cozmU.useRef)(null);
    const inputRef = (0, $2VwyL.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        contentEditable: false,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEoWWg _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _4xdlr07p2s _4gCaOw98eZ _2QqU2pYbGa _0UXt9rT6kp _3vymXgdnbC _1TAPrFdnbC _12zra7dnbC _4gqQundnbC _1BUG4AnQyn _3LgLJknQyn _33xYQJXVX0 _2VdevGFqy6 _2OyTeTHKt7 _0FaG1X7dHp _1IOx4J2Njc _1KpxtsS8kF _2oLtZl715P _2kXGEF715P _1sRR9kiDnZ _1p22ofZqHV _3kmXW6ZqHV _4mmBgUWVPG _0cADMf7Cj1 _4wSwwnnQyn _0SRqqtHtSk _0422iw1Y8M _148SudWVPG _28VVKd5zaO _4he1wK5zaO _2XqjrQogpp _35XZgYvLZJ _18KwGv715P _1NE3IH715P _0QccnXiDnZ _46HRDHey7F _0DdVJjey7F _3Ripac7dHp _1R10kl7zJH _3fKmf0dnbC _0y3WMLWVPG _1HyEhi715P _0iEAnG715P _4dqkZ8iDnZ _2DbpRZ18ZR _4iMPL4oWWg _3WXbLgoWWg _0QiM2WWVPG _0CZMVz715P _3T2ukd715P _30y4AniDnZ _2ztmbdqWX3 _3RuPdLHKt7 _4oEGCYXLOx _1XCDAh6BYM _02icfTXLOx _47hyyTYvD1 _1JlW2UkLmD _07Zf9z6BYM _223H6tkLmD _15y4m1utHW _077SfA9r67 _03K5EYutHW _29Gh4D6BYM _0O3zXs9r67 _0RsWd7VrZW _3m56efVrZW _37It6EVrZW _2NDTdNVrZW _0L0HniVrZW _0R8c3PVrZW _3uACMjVrZW _31MEBPVrZW _4yzLD8oM2E"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        id: checkBoxId,
        "aria-label": formatMessage(isDone ? (0, $52VjW.messages).markTaskAsNotCompleted : (0, $52VjW.messages).markTaskAsCompleted),
        name: checkBoxId,
        type: "checkbox",
        onChange: handleOnChange,
        onClick: onClick,
        checked: !!isDone,
        disabled: !!disabled,
        suppressHydrationWarning: true,
        onKeyPress: handleOnKeyPress,
        ref: inputRef
    }), isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($212e5f1922e9252a$var$CheckboxUncheckedIcon, {
        label: ""
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18ZNy.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId
    }, children);
};
const $212e5f1922e9252a$var$_default_1 = (0, $lzgC6.default)()($212e5f1922e9252a$var$TaskItem);
var $212e5f1922e9252a$export$2e2bcd8739ae039 = $212e5f1922e9252a$var$_default_1;
module.exports["default"] = $212e5f1922e9252a$export$2e2bcd8739ae039;

});

parcelRegister("80me9", function(module, exports) {

var $2iGHk = parcelRequire("2iGHk");

const $d64a1f68a077e776$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $d64a1f68a077e776$export$53eef0dcd9611650 = (0, $2iGHk.default)($d64a1f68a077e776$export$7ba5d2eed2cf9f14);
module.exports["createAndFireEventInElementsChannel"] = $d64a1f68a077e776$export$53eef0dcd9611650;

});

parcelRegister("18ZNy", function(module, exports) {
/* Item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

function $a7c5bff37900dca6$var$_defineProperty(e, r, t) {
    return (r = $a7c5bff37900dca6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a7c5bff37900dca6$var$_toPropertyKey(t) {
    var i = $a7c5bff37900dca6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a7c5bff37900dca6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a7c5bff37900dca6$var$placeholderStyles = null;
const $a7c5bff37900dca6$var$placeholderTaskStyles = null;
const $a7c5bff37900dca6$var$decisionStyles = null;
const $a7c5bff37900dca6$var$contentStyles = null;
const $a7c5bff37900dca6$var$taskStyles = null;
class $a7c5bff37900dca6$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFM6F1I _4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _1UtDYzKGUX _1pp6NdYbGa _39HuIbz8Lp _1ANEUSLRg7 _1EqgXlwwuR",
                itemType === 'TASK' && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMhxRX"
            ])
        }, placeholder);
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ $cozmU.createElement("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5v1qpb _1mT5xdRAKS"
            ])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ $cozmU.createElement("div", {
            "data-component": "content",
            ref: contentRef,
            ...dataAttributes,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1T2N03wPeg _4ouGXIdnbC"
            ])
        }, children));
        else if (itemType === 'DECISION') return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _3iDTPbQ4SZ _0aFT5v1qpb _3138422ADO _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q8HPE _0KLXruDMqu _1mT5xdRAKS _2FEOdCIZbP"
            ])
        }, icon, this.renderPlaceholder(), /*#__PURE__*/ $cozmU.createElement("div", {
            "data-component": "content",
            ref: contentRef,
            ...dataAttributes,
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1T2N03wPeg _4ouGXIdnbC"
            ])
        }, children));
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}
$a7c5bff37900dca6$var$_defineProperty($a7c5bff37900dca6$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'inline'
});
module.exports["default"] = $a7c5bff37900dca6$export$2e2bcd8739ae039;

});

parcelRegister("jx4WZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $97Gqa = parcelRequire("97Gqa");

class $ecd9cedc867d893f$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $cozmU.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $97Gqa.default), {
            children: children
        });
    }
}
module.exports["default"] = $ecd9cedc867d893f$export$2e2bcd8739ae039;

});

parcelRegister("97Gqa", function(module, exports) {
/* DecisionList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $2f5ba59e41a91b69$var$listStyles = null;
class $2f5ba59e41a91b69$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
         // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $hekY6.default)([
                "_39qHGVYbGa _4GiLnvdnbC"
            ])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                key: idx,
                "data-decision-local-id": localId || '',
                "data-decision-state": "DECIDED"
            }, child);
        }));
    }
}
module.exports["default"] = $2f5ba59e41a91b69$export$2e2bcd8739ae039;

});

parcelRegister("jOsRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2125db14c4604735$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $53Uph = parcelRequire("53Uph");

function $2125db14c4604735$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $53Uph.default), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});

parcelRegister("53Uph", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $dimUV = parcelRequire("dimUV");


var $52VjW = parcelRequire("52VjW");


var $18ZNy = parcelRequire("18ZNy");

const $eda2047cc34f4c7b$var$iconStyles = null;
const $eda2047cc34f4c7b$var$iconStylesWithPlaceholder = null;
const $eda2047cc34f4c7b$var$DecisionItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = showPlaceholder && "_1UtDYz4YkS";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqE50T1 _0jFU0Vey7F _39xV02ey7F _3138421Y8M _0adFHs8HPE _1DCdHidnbC _2XsHFMdnbC _1UtDYzfyEX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== showPlaceholder) {
        t3 = showPlaceholder && children === undefined ? formatMessage((0, $52VjW.messages).undefinedDecisionAriaLabel) : formatMessage((0, $52VjW.messages).decisionAriaLabel);
        $[2] = children;
        $[3] = formatMessage;
        $[4] = showPlaceholder;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            label: t3,
            spacing: "spacious",
            color: "currentColor"
        });
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("span", {
            contentEditable: false,
            className: t2
        }, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const icon = t5;
    let t6;
    if ($[11] !== appearance || $[12] !== children || $[13] !== contentRef || $[14] !== dataAttributes || $[15] !== icon || $[16] !== placeholder || $[17] !== showPlaceholder) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $18ZNy.default), {
            appearance: appearance,
            contentRef: contentRef,
            icon: icon,
            placeholder: placeholder,
            showPlaceholder: showPlaceholder,
            itemType: "DECISION",
            dataAttributes: dataAttributes
        }, children);
        $[11] = appearance;
        $[12] = children;
        $[13] = contentRef;
        $[14] = dataAttributes;
        $[15] = icon;
        $[16] = placeholder;
        $[17] = showPlaceholder;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const icon = /*#__PURE__*/ $cozmU.createElement("span", {
        contentEditable: false,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqE50T1 _0jFU0Vey7F _39xV02ey7F _3138421Y8M _0adFHs8HPE _1DCdHidnbC _2XsHFMdnbC _1UtDYzfyEX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            showPlaceholder && "_1UtDYz4YkS"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
        label: showPlaceholder && children === undefined ? formatMessage((0, $52VjW.messages).undefinedDecisionAriaLabel) : formatMessage((0, $52VjW.messages).decisionAriaLabel),
        spacing: "spacious",
        color: "currentColor"
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $18ZNy.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes
    }, children);
};
var $eda2047cc34f4c7b$export$2e2bcd8739ae039 = $eda2047cc34f4c7b$var$DecisionItem;
module.exports["default"] = $eda2047cc34f4c7b$export$2e2bcd8739ae039;

});

parcelRegister("7BiiX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $e4nz6 = parcelRequire("e4nz6");


var $efgwK = parcelRequire("efgwK");


var $kS1Yv = parcelRequire("kS1Yv");


var $31fUM = parcelRequire("31fUM");


var $mEDVg = parcelRequire("mEDVg");

const $ec9720bbe5f648ce$var$Date = /*#__PURE__*/ (0, $cozmU.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const { timeZone: timeZone } = (0, $kS1Yv.useRendererContext)();
    const className = !!parentIsIncompleteTask && (0, $efgwK.isPastDate)(timestamp, timeZone) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $e4nz6.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $efgwK.timestampToTaskContext)(timestamp, intl, timeZone) : (0, $efgwK.timestampToString)(timestamp, intl)
        })
    });
});
const $ec9720bbe5f648ce$export$19285a5b05c4ea7c = (0, $kSwu1.injectIntl)($ec9720bbe5f648ce$var$Date);
function $ec9720bbe5f648ce$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $mEDVg.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ec9720bbe5f648ce$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $ec9720bbe5f648ce$export$2e2bcd8739ae039 = $ec9720bbe5f648ce$var$DateWithFormatContext;
module.exports["default"] = $ec9720bbe5f648ce$export$2e2bcd8739ae039;

});

parcelRegister("efgwK", function(module, exports) {

var $1Ujre = parcelRequire("1Ujre");


var $mr7nI = parcelRequire("mr7nI");

var $c57af174cd21b1e3$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c57af174cd21b1e3$var$FORMATS || {});
const $c57af174cd21b1e3$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c57af174cd21b1e3$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number(parts.find((p)=>p.type === 'year')?.value);
        const month = Number(parts.find((p)=>p.type === 'month')?.value) - 1;
        const day = Number(parts.find((p)=>p.type === 'day')?.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c57af174cd21b1e3$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c57af174cd21b1e3$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c57af174cd21b1e3$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c57af174cd21b1e3$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c57af174cd21b1e3$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCDate())}`;
};
const $c57af174cd21b1e3$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $mr7nI.default)(new Date(Number(timestamp)), new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone))));
};
const $c57af174cd21b1e3$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $1Ujre.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c57af174cd21b1e3$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c57af174cd21b1e3$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $c57af174cd21b1e3$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $c57af174cd21b1e3$export$6297728405c48562;
module.exports["timestampToString"] = $c57af174cd21b1e3$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $c57af174cd21b1e3$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $c57af174cd21b1e3$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $c57af174cd21b1e3$export$fbc04a9e57b04a80;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("31fUM", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $iDrrr = parcelRequire("iDrrr");


var $hZmcT = parcelRequire("hZmcT");

function $1e80a135c5761dad$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $1e80a135c5761dad$export$11564cda945bb3c9;

});

parcelRegister("fBB7S", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g8WS7 = parcelRequire("g8WS7");


var $iDrrr = parcelRequire("iDrrr");


var $fhdGv = parcelRequire("fhdGv");


var $31fUM = parcelRequire("31fUM");

const $642760c453ea34c8$var$ANALYTICS_DATA = {
    userContext: 'document'
};
const $642760c453ea34c8$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)(function Status(props) {
    const { text: text, color: color, style: style, localId: localId } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...inlineAnnotationProps,
            role: 'emphasis',
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
                data: $642760c453ea34c8$var$ANALYTICS_DATA,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                    text: style === 'mixedCase' ? text : text.toUpperCase(),
                    color: color,
                    localId: localId,
                    role: undefined
                })
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
            data: $642760c453ea34c8$var$ANALYTICS_DATA,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: style === 'mixedCase' ? text : text.toUpperCase(),
                color: color,
                localId: localId,
                role: undefined
            })
        });
    }
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...inlineAnnotationProps,
        role: 'emphasis',
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: text,
                color: color,
                localId: localId,
                role: undefined,
                isBold: true
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g8WS7.FabricElementsAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            userContext: 'document'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fhdGv.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: true
            })
        })
    });
});
var $642760c453ea34c8$export$2e2bcd8739ae039 = $642760c453ea34c8$var$_default_1;
module.exports["default"] = $642760c453ea34c8$export$2e2bcd8739ae039;

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lzgC6 = parcelRequire("lzgC6");


var $aCJyI = parcelRequire("aCJyI");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");


var $fB42n = parcelRequire("fB42n");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // Bound the Lozenge to its parent while keeping short statuses content-sized.
const $ba35a2a9fe36df5b$var$constrainedToParentStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $fB42n.getLozengeAppearance)(color); // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                isConstrainedToParent && "_3iDTPbvbI6 _1EqgXlN91d",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $fB42n.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("fB42n", function(module, exports) {

var $2pQiO = parcelRequire("2pQiO");

const $7f74d498381e9123$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $7f74d498381e9123$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $7f74d498381e9123$export$acfdfc8c64e6747 = 'neutral';
const $7f74d498381e9123$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $7f74d498381e9123$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $7f74d498381e9123$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $7f74d498381e9123$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $7f74d498381e9123$export$ee5a21461d1db57c = (color)=>$7f74d498381e9123$export$c6adb6b4e776f0d5.includes(color);
const $7f74d498381e9123$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $7f74d498381e9123$var$specFor = (color)=>$7f74d498381e9123$export$56d196d2844d1ca1[$7f74d498381e9123$export$4cde5df63f53f473(color)];
const $7f74d498381e9123$export$4bc90a066e1dabc3 = (color)=>$7f74d498381e9123$var$specFor(color)?.labelKey ?? 'neutralColor';
const $7f74d498381e9123$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    if (!selectedColor) return false;
    if ($7f74d498381e9123$export$4cde5df63f53f473(swatchValue) === $7f74d498381e9123$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = $7f74d498381e9123$var$specFor(swatchValue)?.appearance;
    return swatchAppearance !== undefined && swatchAppearance === $7f74d498381e9123$var$specFor(selectedColor)?.appearance;
};
const $7f74d498381e9123$export$4d9e331cafeacb9d = (color)=>{
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($7f74d498381e9123$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $7f74d498381e9123$export$56d196d2844d1ca1[color].appearance : $7f74d498381e9123$export$645e10b5a408e986[color];
    return $7f74d498381e9123$var$specFor(color)?.appearance ?? $7f74d498381e9123$export$acfdfc8c64e6747;
};
module.exports["SWATCH_ICON_COLOR"] = $7f74d498381e9123$export$692279d423b4caab;
module.exports["COLORS"] = $7f74d498381e9123$export$56d196d2844d1ca1;
module.exports["PICKER_SWATCHES"] = $7f74d498381e9123$export$d42d7c94d7629c23;
module.exports["normalizeColor"] = $7f74d498381e9123$export$4cde5df63f53f473;
module.exports["getColorLabelKey"] = $7f74d498381e9123$export$4bc90a066e1dabc3;
module.exports["isSwatchSelected"] = $7f74d498381e9123$export$13752f03fbf881b8;
module.exports["getLozengeAppearance"] = $7f74d498381e9123$export$4d9e331cafeacb9d;

});

parcelRegister("hMAfQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $2buHA = parcelRequire("2buHA");


var $2O2Zk = parcelRequire("2O2Zk");


var $eNbr2 = parcelRequire("eNbr2");


var $794I6 = parcelRequire("794I6");


var $6OpMl = parcelRequire("6OpMl");


var $iDrrr = parcelRequire("iDrrr");


var $31fUM = parcelRequire("31fUM");

// eslint-disable-next-line @repo/internal/react/no-class-components -- class kept for WithProviders compatibility
class $1979132c998595a6$var$EmojiNode extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, emojiProviderLookupOrder: emojiProviderLookupOrder, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) {
                // When the gate is enabled and the fallback text is not a single
                // standard Unicode emoji (i.e. this is a custom emoji whose fallback
                // is a `:shortname:`-style string), render the Unicode Replacement
                // Character (U+FFFD) instead of the shortName text. Standard emojis
                // continue to fall back to their Unicode text representation.
                const fallbackText = fallback || shortName;
                const customFallback = (0, $2buHA.getEmojiCustomFallback)(fallbackText);
                const useReplacementChar = customFallback !== undefined;
                const renderedFallbackText = customFallback ?? fallbackText;
                const accessibleLabel = `${(0, $2O2Zk.messages).emojiNodeLabel.defaultMessage} ${shortName}`;
                return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    "aria-label": useReplacementChar ? accessibleLabel : undefined,
                    "data-emoji-id": id,
                    "data-emoji-short-name": shortName,
                    "data-emoji-text": renderedFallbackText,
                    role: useReplacementChar ? 'img' : undefined,
                    title: useReplacementChar ? shortName : undefined
                }, renderedFallbackText);
            }
            if (!providers.emojiProvider) return null;
            const customFallback = (0, $2buHA.getEmojiCustomFallback)(fallback || shortName);
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6OpMl.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProviderLookupOrder: emojiProviderLookupOrder,
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                customFallback: customFallback,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true,
                onEmojiLoadSuccess: resourceConfig?.onEmojiLoadSuccess,
                onEmojiLoadFail: resourceConfig?.onEmojiLoadFail
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
$1979132c998595a6$var$EmojiNode.displayName = 'EmojiNode';
$1979132c998595a6$var$EmojiNode.defaultProps = {
    showTooltip: true
};
const $1979132c998595a6$export$843daf88d968cb48 = (props)=>{
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, emojiProviderLookupOrder: emojiProviderLookupOrder, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $lOiVq.jsx)($1979132c998595a6$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        emojiProviderLookupOrder: emojiProviderLookupOrder,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $lOiVq.jsx)($1979132c998595a6$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        emojiProviderLookupOrder: emojiProviderLookupOrder,
        resourceConfig: resourceConfig
    });
};
const $1979132c998595a6$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)($1979132c998595a6$export$843daf88d968cb48);
var $1979132c998595a6$export$2e2bcd8739ae039 = $1979132c998595a6$var$_default_1;
module.exports["default"] = $1979132c998595a6$export$2e2bcd8739ae039;

});

parcelRegister("2buHA", function(module, exports) {

var $2DBsV = parcelRequire("2DBsV");

function $004d94a28e8e7a45$export$e6e9c38db7e6b0b1(fallbackText) {
    return (0, $2DBsV.isSingleEmoji)(fallbackText) ? undefined : '\uFFFD';
}
module.exports["getEmojiCustomFallback"] = $004d94a28e8e7a45$export$e6e9c38db7e6b0b1;

});

parcelRegister("2DBsV", function(module, exports) {
const $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $cdd07b0bc87acc5f$export$1d677781db73ff20(fallbackText) {
    return $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}
module.exports["isSingleEmoji"] = $cdd07b0bc87acc5f$export$1d677781db73ff20;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("eE4tp", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $jVdlG = parcelRequire("jVdlG");


var $dDpOM = parcelRequire("dDpOM");


var $jA0E3 = parcelRequire("jA0E3");


var $564fr = parcelRequire("564fr");


var $30pGv = parcelRequire("30pGv");


var $6MmtN = parcelRequire("6MmtN");


var $45O09 = parcelRequire("45O09");


var $6m2p9 = parcelRequire("6m2p9");


var $dVbiN = parcelRequire("dVbiN");


var $4o0zT = parcelRequire("4o0zT");


var $8m50u = parcelRequire("8m50u");


var $hMAfQ = parcelRequire("hMAfQ");


var $3GTxY = parcelRequire("3GTxY");


var $bF691 = parcelRequire("bF691");

const $74bb1629404fd5f5$var$panelIcons = {
    info: (0, $jA0E3.PanelInfoIcon),
    success: (0, $30pGv.PanelSuccessIcon),
    note: (0, $564fr.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))),
    warning: (0, $6MmtN.PanelWarningIcon),
    error: (0, $dDpOM.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($6m2p9)))
};
const $74bb1629404fd5f5$var$PanelStyledMigration = (0, $8m50u.componentWithCondition)(()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_renderer_static_css'), (0, $3GTxY.PanelStyledCompiled), (0, $bF691.PanelStyledEmotion));
const $74bb1629404fd5f5$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children, localId: localId } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $jVdlG.PanelType).CUSTOM ? (0, $jVdlG.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $jVdlG.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hMAfQ.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $74bb1629404fd5f5$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $45O09.PanelSharedCssClassName).icon,
            children: icon
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($74bb1629404fd5f5$var$PanelStyledMigration, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $45O09.PanelSharedCssClassName).prefix,
        "data-local-id": localId,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon),
        children: [
            renderIcon(),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $45O09.PanelSharedCssClassName).content,
                children: children
            })
        ]
    });
};
var $74bb1629404fd5f5$export$2e2bcd8739ae039 = $74bb1629404fd5f5$var$Panel;
module.exports["default"] = $74bb1629404fd5f5$export$2e2bcd8739ae039;

});

parcelRegister("dDpOM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1aedaca47fa21d78$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $1aedaca47fa21d78$var$PanelErrorGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $1aedaca47fa21d78$export$76fa6c311f4e2871 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelErrorIcon"] = $1aedaca47fa21d78$export$76fa6c311f4e2871;

});

parcelRegister("jA0E3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a579bb9ddad96162$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $a579bb9ddad96162$var$PanelInfoGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $a579bb9ddad96162$export$2187dc2d495c3efc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelInfoIcon"] = $a579bb9ddad96162$export$2187dc2d495c3efc;

});

parcelRegister("564fr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $276a71e22fa0e942$var$iconStyles = null;
const $276a71e22fa0e942$var$PanelNoteGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $276a71e22fa0e942$export$d4f894f0c3f0db6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = props.label ? "img" : undefined;
    const t1 = props.label ? props.label : undefined;
    const t2 = props.label ? undefined : true;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t0,
            "aria-label": t1,
            "aria-hidden": t2,
            className: t3,
            children: t4
        });
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelNoteIcon"] = $276a71e22fa0e942$export$d4f894f0c3f0db6;

});

parcelRegister("30pGv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5ac0d457a06bc975$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $5ac0d457a06bc975$var$PanelSuccessGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $5ac0d457a06bc975$export$a5a5162e21242c3c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelSuccessIcon"] = $5ac0d457a06bc975$export$a5a5162e21242c3c;

});

parcelRegister("6MmtN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $532129d0e2b29baf$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $532129d0e2b29baf$var$PanelWarningGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $532129d0e2b29baf$export$246c5468186717b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelWarningIcon"] = $532129d0e2b29baf$export$246c5468186717b7;

});

parcelRegister("45O09", function(module, exports) {

var $jVdlG = parcelRequire("jVdlG");


var $lqPdm = parcelRequire("lqPdm");

const $dca98429b91f0137$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $dca98429b91f0137$var$prefix = 'ak-editor-panel';
const $dca98429b91f0137$export$6dd740b6c888e050 = {
    prefix: $dca98429b91f0137$var$prefix,
    content: `${$dca98429b91f0137$var$prefix}__content`,
    icon: `${$dca98429b91f0137$var$prefix}__icon`,
    noIcon: `${$dca98429b91f0137$var$prefix}__no-icon`
};
const $dca98429b91f0137$export$b0ee08fae091706a = {
    infoPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).INFO}]`,
    notePanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).NOTE}]`,
    warningPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).WARNING}]`,
    errorPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).ERROR}]`,
    successPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[data-testid="popup-wrapper"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $dca98429b91f0137$export$8099afddf1b1be78 = (panelType)=>$dca98429b91f0137$var$lightPanelColors[panelType] || 'none';
const $dca98429b91f0137$export$dd3f0fd482ae7ccc = (panelType)=>(0, $lqPdm.hexToEditorBackgroundPaletteColor)($dca98429b91f0137$var$lightPanelColors[panelType]) || 'none';
module.exports["PanelSharedCssClassName"] = $dca98429b91f0137$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $dca98429b91f0137$export$8099afddf1b1be78;
module.exports["getPanelTypeBackground"] = $dca98429b91f0137$export$dd3f0fd482ae7ccc;

});

parcelRegister("3GTxY", function(module, exports) {
/* panel-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Compiled branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `panel.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");


var $jVdlG = parcelRequire("jVdlG");


var $lqPdm = parcelRequire("lqPdm");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");

// To fix alignment issues with custom icons, vertical alignment is updated.
const $4d609318393ff70c$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7Y8M5.akEditorCustomIconSize)) / 2;
const $4d609318393ff70c$var$panelEmojiImageVerticalAlignment = $4d609318393ff70c$var$panelEmojiSpriteVerticalAlignment - 1;
const $4d609318393ff70c$var$blockNodesVerticalMargin = '0.75rem';
const $4d609318393ff70c$var$akEditorTableCellMinWidth = 48;
const $4d609318393ff70c$var$panelBaseStyles = null;
const $4d609318393ff70c$var$panelBackgroundColorVariableStyles = null;
const $4d609318393ff70c$var$panelHasNoIconStyles = null;
const $4d609318393ff70c$var$panelInfoIconStyles = null;
const $4d609318393ff70c$var$panelNestedIconStyles = null;
const $4d609318393ff70c$var$nestedPanelStyles = null;
const $4d609318393ff70c$var$panelCustomBackground = null;
const $4d609318393ff70c$export$94e2a9c6f6399451 = ({ backgroundColor: backgroundColor, children: children, className: className, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // Ignored via go/ees005
    , {
        ...props,
        className: (0, $hekY6.default)([
            "_1qha04zXzM _34JGkheUER _2dCaV6dnbC _1ZyHZRdnbC _3Pw1A6dnbC _0kyFW47dHp _2ZkKe8dnbC _46uUjbAEMG _1hgRbCFQfX _38nGYsFQfX _14J9EBdnbC _04gIdHdnbC _10M5brdnbC _2ImbiZ2ADO _3kJdBd5zaO _4uuVdp2ADO _0pjkQE2ADO _3ChsxZpJKa _31lJCMQ4SZ _2XGNQoRAKS _2CevyrzUZr _0rBUdFwPeg _20YGymVva3 _1eI8i4OLYo _3MlmhNdnbC _4qk8MDNHnM _2v4YBTNHnM _3YIzDnPvdi _432vAn2ADO _3ciRU3DIqT _0owctlYbGa _2aXapiYbGa _2mqsnHYbGa _3TSj5JYbGa _4G5wq2OTqR _3ven9A6bAP _32CRbNt2nV _4pE20TccYA _3w76BVpgTj _0u1QYY7vQP _20ks1FvbI6 _1yybm3B8KG _2XWqwITNil _0VW2VRV6wL _14pIdGfyEX _3rvVc156u3 _4nE2ywspgB _2L2l7zsDFP _3ojpvb7j8z _1R6fDRV6wL _16NhUyfyEX",
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && "_1yd3ZsVva3 _0FZiz2B8KG _15CkpaV6wL _26KnYOV6wL _0WzquN56u3 _2W64BksDFP _0Bdrgc1OkO",
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && "_30Gy176bAP",
            !hasIcon && "_4wiAFv8HPE _36o8sY8HPE",
            props['data-panel-type'] === (0, $jVdlG.PanelType).CUSTOM && backgroundColor && "_2vNvUo1OkO",
            "_0Cp0lv8HPE _1IjCxx8HPE",
            "_4xRkeHOeNX",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- intentional: custom panel background is dynamic via CSS variable
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        children: children
    });
};
$4d609318393ff70c$export$94e2a9c6f6399451.displayName = 'PanelStyledCompiled';
module.exports["PanelStyledCompiled"] = $4d609318393ff70c$export$94e2a9c6f6399451;

});

parcelRegister("bF691", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_renderer_static_css` experiment.
 * Used via `componentWithCondition` in `panel.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $jVdlG = parcelRequire("jVdlG");


var $lqPdm = parcelRequire("lqPdm");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");

function $2d7c1d50ae8acd88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7Y8M5.akEditorCustomIconSize)) / 2;
const $2d7c1d50ae8acd88$var$panelEmojiImageVerticalAlignment = $2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment - 1;
const $2d7c1d50ae8acd88$var$blockNodesVerticalMargin = '0.75rem';
const $2d7c1d50ae8acd88$var$akEditorTableCellMinWidth = 48;
const $2d7c1d50ae8acd88$var$panelBaseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${$2d7c1d50ae8acd88$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$2d7c1d50ae8acd88$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #357DE8)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$2d7c1d50ae8acd88$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #AF59E1)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #6A9A23)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E06C00)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #6A9A23)"
            }
        }
    }
});
const $2d7c1d50ae8acd88$var$panelBackgroundColorVariableStyles = {
    name: "bekyt0",
    styles: "&.ak-editor-panel{--ak-renderer-panel-bg-color:var(--ds-background-accent-blue-subtlest, #E9F2FE);&[data-panel-type=\"note\"]{--ak-renderer-panel-bg-color:var(--ds-background-accent-purple-subtlest, #F8EEFE);}&[data-panel-type=\"tip\"], &[data-panel-type=\"success\"]{--ak-renderer-panel-bg-color:var(--ds-background-accent-green-subtlest, #DCFFF1);}&[data-panel-type=\"warning\"]{--ak-renderer-panel-bg-color:var(--ds-background-accent-yellow-subtlest, #FEF7C8);}&[data-panel-type=\"error\"]{--ak-renderer-panel-bg-color:var(--ds-background-accent-red-subtlest, #FFECEB);}&[data-panel-type=\"custom\"]{--ak-renderer-panel-bg-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $2d7c1d50ae8acd88$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $2d7c1d50ae8acd88$var$panelInfoIconStyles = {
    name: "dvo37z",
    styles: "&.ak-editor-panel[data-panel-type=\"info\"]{.ak-editor-panel__icon{color:var(--ds-icon-information, #357DE8);}}"
};
const $2d7c1d50ae8acd88$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $2d7c1d50ae8acd88$var$nestedPanelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content .ak-editor-panel': {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $2d7c1d50ae8acd88$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $2d7c1d50ae8acd88$export$368e668f620b51a7 = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $2d7c1d50ae8acd88$var$panelBaseStyles,
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && $2d7c1d50ae8acd88$var$panelBackgroundColorVariableStyles,
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && $2d7c1d50ae8acd88$var$panelInfoIconStyles,
            !hasIcon && $2d7c1d50ae8acd88$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $jVdlG.PanelType).CUSTOM && backgroundColor && $2d7c1d50ae8acd88$var$panelCustomBackground,
            $2d7c1d50ae8acd88$var$panelNestedIconStyles,
            $2d7c1d50ae8acd88$var$nestedPanelStyles
        ],
        ...props
    }, props.children);
};
$2d7c1d50ae8acd88$export$368e668f620b51a7.displayName = 'PanelStyledEmotion';
module.exports["PanelStyledEmotion"] = $2d7c1d50ae8acd88$export$368e668f620b51a7;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100)) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("5X6fy", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4G6PK", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $4e6f18d969fc9276$export$5937600f4cc784f0 = 24;
const $4e6f18d969fc9276$export$71d660e8ca5b8f73 = 320;
const $4e6f18d969fc9276$export$cd11d7d46412c89b = 3;
const $4e6f18d969fc9276$export$71482734bb54ac3 = 10;
const $4e6f18d969fc9276$export$fd2b09475ada41cc = 12;
const $4e6f18d969fc9276$export$8c5ac0b0c62a3d21 = 8;
const $4e6f18d969fc9276$export$68d0abe4f03863fb = $4e6f18d969fc9276$export$fd2b09475ada41cc * 2;
const $4e6f18d969fc9276$export$d722b7527b1834a8 = 250;
const $4e6f18d969fc9276$export$da894f7669b4e67c = 200;
const $4e6f18d969fc9276$export$e13825c38da2ce1 = 100;
var $4e6f18d969fc9276$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $4e6f18d969fc9276$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $4e6f18d969fc9276$export$4d41d008e9cd4f34 = 0.5;
const $4e6f18d969fc9276$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $4e6f18d969fc9276$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $4e6f18d969fc9276$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $4e6f18d969fc9276$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $4e6f18d969fc9276$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $4e6f18d969fc9276$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $4e6f18d969fc9276$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $4e6f18d969fc9276$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $4e6f18d969fc9276$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $4e6f18d969fc9276$export$b4b560efd3c61856;

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("ihn0W", function(module, exports) {

var $34CLe = parcelRequire("34CLe");

const $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $34CLe.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
module.exports["shouldAddDefaultWrappedWidth"] = $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e;

});

parcelRegister("34CLe", function(module, exports) {
const $df10a01237b702c1$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
module.exports["wrappedLayouts"] = $df10a01237b702c1$export$405baca3d8bc263d;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("8qft0", function(module, exports) {
const $5b70b8fd3b65ebb8$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
module.exports["nonWrappedLayouts"] = $5b70b8fd3b65ebb8$export$607795ead6e50626;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $ebRBT = parcelRequire("ebRBT");

// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $c358709489b4576e$var$FileIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $ebRBT = parcelRequire("ebRBT");

// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $3736b97729106be6$var$ChartBarIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $ebRBT = parcelRequire("ebRBT");

// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("9TA3F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73453881445d309b$var$_react = $73453881445d309b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $73453881445d309b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73453881445d309b$var$Archive24Icon = (props)=>/*#__PURE__*/ $73453881445d309b$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$73453881445d309b$var$Archive24Icon.displayName = 'Archive24Icon';
var $73453881445d309b$var$_default = module.exports.default = $73453881445d309b$var$Archive24Icon;

});

parcelRegister("jTyNF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e7be25f42053d936$var$_react = $e7be25f42053d936$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e7be25f42053d936$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e7be25f42053d936$var$Executable24Icon = (props)=>/*#__PURE__*/ $e7be25f42053d936$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e7be25f42053d936$var$Executable24Icon.displayName = 'Executable24Icon';
var $e7be25f42053d936$var$_default = module.exports.default = $e7be25f42053d936$var$Executable24Icon;

});

parcelRegister("gCL8n", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1a4c1cb74e7fe66$var$_react = $c1a4c1cb74e7fe66$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c1a4c1cb74e7fe66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1a4c1cb74e7fe66$var$Gif24Icon = (props)=>/*#__PURE__*/ $c1a4c1cb74e7fe66$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1a4c1cb74e7fe66$var$Gif24Icon.displayName = 'Gif24Icon';
var $c1a4c1cb74e7fe66$var$_default = module.exports.default = $c1a4c1cb74e7fe66$var$Gif24Icon;

});

parcelRegister("l8FBD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f63a9e6c3f95b37c$var$_react = $f63a9e6c3f95b37c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f63a9e6c3f95b37c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f63a9e6c3f95b37c$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $f63a9e6c3f95b37c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f63a9e6c3f95b37c$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $f63a9e6c3f95b37c$var$_default = module.exports.default = $f63a9e6c3f95b37c$var$GoogleDoc24Icon;

});

parcelRegister("cSPDT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9612964eb3dd5544$var$_react = $9612964eb3dd5544$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $9612964eb3dd5544$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9612964eb3dd5544$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $9612964eb3dd5544$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9612964eb3dd5544$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $9612964eb3dd5544$var$_default = module.exports.default = $9612964eb3dd5544$var$GoogleForm24Icon;

});

parcelRegister("lhYzt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f7fa2ba87c6278a2$var$_react = $f7fa2ba87c6278a2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $f7fa2ba87c6278a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7fa2ba87c6278a2$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $f7fa2ba87c6278a2$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f7fa2ba87c6278a2$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $f7fa2ba87c6278a2$var$_default = module.exports.default = $f7fa2ba87c6278a2$var$GoogleSheet24Icon;

});

parcelRegister("3Ll8s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd627f5b12c5946$var$_react = $2bd627f5b12c5946$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2bd627f5b12c5946$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd627f5b12c5946$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $2bd627f5b12c5946$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd627f5b12c5946$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $2bd627f5b12c5946$var$_default = module.exports.default = $2bd627f5b12c5946$var$GoogleSlide24Icon;

});

parcelRegister("67SYT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $475e0ba3e7829a3a$var$_react = $475e0ba3e7829a3a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $475e0ba3e7829a3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $475e0ba3e7829a3a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $475e0ba3e7829a3a$var$_default = module.exports.default = $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon;

});

parcelRegister("6lknI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $49e483933a21e023$var$_react = $49e483933a21e023$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $49e483933a21e023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $49e483933a21e023$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $49e483933a21e023$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$49e483933a21e023$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $49e483933a21e023$var$_default = module.exports.default = $49e483933a21e023$var$PowerpointPresentation24Icon;

});

parcelRegister("fGSwx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b6c5128728f95629$var$_react = $b6c5128728f95629$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $b6c5128728f95629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6c5128728f95629$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $b6c5128728f95629$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b6c5128728f95629$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $b6c5128728f95629$var$_default = module.exports.default = $b6c5128728f95629$var$WordDocument24Icon;

});

parcelRegister("90EXt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $01b15a5d4b81fd5c$var$_react = $01b15a5d4b81fd5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $01b15a5d4b81fd5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01b15a5d4b81fd5c$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $01b15a5d4b81fd5c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$01b15a5d4b81fd5c$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $01b15a5d4b81fd5c$var$_default = module.exports.default = $01b15a5d4b81fd5c$var$PdfDocument24Icon;

});

parcelRegister("8BODT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64490ff67d091387$var$_react = $64490ff67d091387$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $64490ff67d091387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64490ff67d091387$var$Sketch24Icon = (props)=>/*#__PURE__*/ $64490ff67d091387$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$64490ff67d091387$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $64490ff67d091387$var$_default = module.exports.default = $64490ff67d091387$var$Sketch24Icon;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("g0fSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $iDrrr = parcelRequire("iDrrr");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");

const $e5bbb38f64c6a3e7$export$9f7977d4a2561bee = (Component)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaClient = (0, $cozmU.useMemo)(()=>existingMediaClient ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));
module.exports["withMediaClient"] = $e5bbb38f64c6a3e7$export$9f7977d4a2561bee;

});

parcelRegister("jmmTp", function(module, exports) {
const $ad0c18c377a101ba$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
module.exports["isFileIdentifier"] = $ad0c18c377a101ba$export$7695387cd66cf5b5;

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    line_count: {
        id: "fabric.media.line_count",
        defaultMessage: "{count, plural, one {# line} other {# lines}}"
    },
    plain_text: {
        id: "fabric.media.plain_text",
        defaultMessage: "Plain text"
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    file_too_large_to_preview: {
        id: "fabric.media.file_too_large_to_preview",
        defaultMessage: "File is too large to preview"
    },
    file_too_large_description: {
        id: "fabric.media.file_too_large_description",
        defaultMessage: "Preview isn't available for files of this size."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    zoom_to_fit: {
        id: "fabric.media.zoom_to_fit",
        defaultMessage: "Fit to screen"
    },
    zoom_to_fit_with_level: {
        id: "fabric.media.zoom_to_fit_with_level",
        defaultMessage: "{zoomLevel} zoom, fit to screen"
    },
    hide_sidebar: {
        id: "fabric.media.viewer.hide_sidebar",
        defaultMessage: "Hide sidebar"
    },
    show_sidebar: {
        id: "fabric.media.viewer.show_sidebar",
        defaultMessage: "Show sidebar"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    playbackSpeedValue: {
        id: "fabric.media.playback_speed_value",
        defaultMessage: "Playback speed {speed}x"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("42Fpa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2f17777bbdd9049a$var$_react = $2f17777bbdd9049a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2f17777bbdd9049a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f17777bbdd9049a$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2f17777bbdd9049a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2f17777bbdd9049a$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2f17777bbdd9049a$var$_default = module.exports.default = $2f17777bbdd9049a$var$SourceCode24Icon;

});

parcelRegister("jZpwZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e8d784bfa3b30ee1$var$_react = $e8d784bfa3b30ee1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $e8d784bfa3b30ee1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8d784bfa3b30ee1$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $e8d784bfa3b30ee1$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e8d784bfa3b30ee1$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $e8d784bfa3b30ee1$var$_default = module.exports.default = $e8d784bfa3b30ee1$var$Spreadsheet24Icon;

});

parcelRegister("9Jnyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $715a9653e306c98f$var$_react = $715a9653e306c98f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $715a9653e306c98f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $715a9653e306c98f$var$Audio16Icon = (props)=>/*#__PURE__*/ $715a9653e306c98f$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$715a9653e306c98f$var$Audio16Icon.displayName = 'Audio16Icon';
var $715a9653e306c98f$var$_default = module.exports.default = $715a9653e306c98f$var$Audio16Icon;

});

parcelRegister("gCdaE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c18a696825273ec6$var$_react = $c18a696825273ec6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c18a696825273ec6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c18a696825273ec6$var$Audio24Icon = (props)=>/*#__PURE__*/ $c18a696825273ec6$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c18a696825273ec6$var$Audio24Icon.displayName = 'Audio24Icon';
var $c18a696825273ec6$var$_default = module.exports.default = $c18a696825273ec6$var$Audio24Icon;

});

parcelRegister("5m8Xe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e65f3f767377aa6$var$_react = $3e65f3f767377aa6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3e65f3f767377aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e65f3f767377aa6$var$Document16Icon = (props)=>/*#__PURE__*/ $3e65f3f767377aa6$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e65f3f767377aa6$var$Document16Icon.displayName = 'Document16Icon';
var $3e65f3f767377aa6$var$_default = module.exports.default = $3e65f3f767377aa6$var$Document16Icon;

});

parcelRegister("dj32l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9aff67bd6f8a5bd3$var$_react = $9aff67bd6f8a5bd3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $9aff67bd6f8a5bd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9aff67bd6f8a5bd3$var$Document24Icon = (props)=>/*#__PURE__*/ $9aff67bd6f8a5bd3$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9aff67bd6f8a5bd3$var$Document24Icon.displayName = 'Document24Icon';
var $9aff67bd6f8a5bd3$var$_default = module.exports.default = $9aff67bd6f8a5bd3$var$Document24Icon;

});

parcelRegister("5t27u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3fb14e1bddde3789$var$_react = $3fb14e1bddde3789$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3fb14e1bddde3789$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fb14e1bddde3789$var$Generic16Icon = (props)=>/*#__PURE__*/ $3fb14e1bddde3789$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3fb14e1bddde3789$var$Generic16Icon.displayName = 'Generic16Icon';
var $3fb14e1bddde3789$var$_default = module.exports.default = $3fb14e1bddde3789$var$Generic16Icon;

});

parcelRegister("cAa12", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $92909dc17280e83d$var$_react = $92909dc17280e83d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $92909dc17280e83d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $92909dc17280e83d$var$Generic24Icon = (props)=>/*#__PURE__*/ $92909dc17280e83d$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$92909dc17280e83d$var$Generic24Icon.displayName = 'Generic24Icon';
var $92909dc17280e83d$var$_default = module.exports.default = $92909dc17280e83d$var$Generic24Icon;

});

parcelRegister("1rDre", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $10d6e7acdde4b7aa$var$_react = $10d6e7acdde4b7aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $10d6e7acdde4b7aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10d6e7acdde4b7aa$var$Image16Icon = (props)=>/*#__PURE__*/ $10d6e7acdde4b7aa$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$10d6e7acdde4b7aa$var$Image16Icon.displayName = 'Image16Icon';
var $10d6e7acdde4b7aa$var$_default = module.exports.default = $10d6e7acdde4b7aa$var$Image16Icon;

});

parcelRegister("4C7IM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $35c0b35464adb49e$var$_react = $35c0b35464adb49e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $35c0b35464adb49e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $35c0b35464adb49e$var$Image24Icon = (props)=>/*#__PURE__*/ $35c0b35464adb49e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$35c0b35464adb49e$var$Image24Icon.displayName = 'Image24Icon';
var $35c0b35464adb49e$var$_default = module.exports.default = $35c0b35464adb49e$var$Image24Icon;

});

parcelRegister("eziPO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a9b2f1c15109a71a$var$_react = $a9b2f1c15109a71a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $a9b2f1c15109a71a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9b2f1c15109a71a$var$Video16Icon = (props)=>/*#__PURE__*/ $a9b2f1c15109a71a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$a9b2f1c15109a71a$var$Video16Icon.displayName = 'Video16Icon';
var $a9b2f1c15109a71a$var$_default = module.exports.default = $a9b2f1c15109a71a$var$Video16Icon;

});

parcelRegister("5Dz6O", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $41abd4227f5a613a$var$_react = $41abd4227f5a613a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $41abd4227f5a613a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $41abd4227f5a613a$var$Video24Icon = (props)=>/*#__PURE__*/ $41abd4227f5a613a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$41abd4227f5a613a$var$Video24Icon.displayName = 'Video24Icon';
var $41abd4227f5a613a$var$_default = module.exports.default = $41abd4227f5a613a$var$Video24Icon;

});

parcelRegister("c2smn", function(module, exports) {

var $iC5Q5 = parcelRequire("iC5Q5");


var $hsnIS = parcelRequire("hsnIS");


var $adEwt = parcelRequire("adEwt");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("6wYuL", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



const $d6a90985447658eb$export$dbe437e0902936cc = 'media-blob-url';
module.exports["mediaBlobUrlIdentifier"] = $d6a90985447658eb$export$dbe437e0902936cc;

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("8BNw5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gjPL4 = parcelRequire("gjPL4");


var $8TTbR = parcelRequire("8TTbR");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");

class $d868351120faa6d0$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(this.props.children);
        let content;
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: "MediaGroup",
                ...(0, $5o4s6.VcMediaWrapperProps),
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            // the media group component renders in crop mode in editor thus this enables consistency
            // also crop is much easier to make consistent across SSR and hydration
            resizeMode: (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? 'crop' : 'stretchy-fit',
            cardDimensions: (0, $gjPL4.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8TTbR.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
        this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}
module.exports["default"] = $d868351120faa6d0$export$2e2bcd8739ae039;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $8TTbR = parcelRequire("8TTbR");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperMotionStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("lWEf5", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");


var $aHoC6 = parcelRequire("aHoC6");


var $dUm2W = parcelRequire("dUm2W");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $4PCaV = parcelRequire("4PCaV");


var $hZmcT = parcelRequire("hZmcT");


var $2bxao = parcelRequire("2bxao");

function $c0c05cdaad03161d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c0c05cdaad03161d$var$DEFAULT_WIDTH = 250;
const $c0c05cdaad03161d$var$DEFAULT_HEIGHT = 200;
const $c0c05cdaad03161d$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $c0c05cdaad03161d$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $c0c05cdaad03161d$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $c0c05cdaad03161d$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$c0c05cdaad03161d$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $c0c05cdaad03161d$var$checkForMediaElement(media.props.children);
    return media;
};
const $c0c05cdaad03161d$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7Y8M5.akEditorWideLayoutWidth;
        default:
            return 0, $7Y8M5.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $c0c05cdaad03161d$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $c0c05cdaad03161d$var$DEFAULT_WIDTH, height: height = $c0c05cdaad03161d$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $c0c05cdaad03161d$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $c0c05cdaad03161d$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $c0c05cdaad03161d$var$DEFAULT_WIDTH;
        height = $c0c05cdaad03161d$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $2bxao.FullPagePadding) * 2 : 0;
    const calcDimensions = (0, $cozmU.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $c0c05cdaad03161d$export$507465eaf3c57f05(mediaContainerWidth, layout);
        let cardDimensions = {};
        if ((0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
            const maxWidth = widthAttr && typeof widthAttr === 'number' && widthType === 'pixel' ? widthAttr : containerWidth;
            cardDimensions = {
                width: `${maxWidth}px`,
                height: `100%`
            };
        } else {
            const maxWidth = (0, $4iudd.isSSR)() && widthAttr && typeof widthAttr === 'number' ? Math.max(widthAttr, containerWidth) : containerWidth;
            const maxHeight = height / width * maxWidth;
            cardDimensions = {
                width: `${maxWidth}px`,
                height: `${maxHeight}px`
            };
        }
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7Y8M5.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7Y8M5.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr,
        widthType
    ]);
    const originalDimensions = (0, $cozmU.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $4PCaV.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $cozmU.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $cozmU.useContext)((0, $dUm2W.WidthContext));
    const containerWidth = $c0c05cdaad03161d$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $cozmU.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $c0c05cdaad03161d$var$uiMediaSingleBaseStyles,
            $c0c05cdaad03161d$var$uiMediaSingleLayoutStyles
        ] : [
            $c0c05cdaad03161d$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aHoC6.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance,
            isInRenderer: true
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $c0c05cdaad03161d$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    if (!$c0c05cdaad03161d$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $c0c05cdaad03161d$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($c0c05cdaad03161d$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $c0c05cdaad03161d$var$_default_1 = (0, $kSwu1.injectIntl)($c0c05cdaad03161d$var$MediaSingle);
var $c0c05cdaad03161d$export$2e2bcd8739ae039 = $c0c05cdaad03161d$var$_default_1;
module.exports["default"] = $c0c05cdaad03161d$export$2e2bcd8739ae039;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
const $577b7b0c5e75a3c1$export$af8124aa496797f2 = '_|unknown|_';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;
module.exports["UNKNOWN_USER_ID"] = $577b7b0c5e75a3c1$export$af8124aa496797f2;

});

parcelRegister("caelp", function(module, exports) {
const $c573a2458006a7eb$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
module.exports["AGENT_MENTION_LOAD_ERROR_ID"] = $c573a2458006a7eb$export$43bc8ec87115a7b3;
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $etoPX = parcelRequire("etoPX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ipkS0 = parcelRequire("ipkS0");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-7xjQ31", ()=>(parcelRequire("lLAOq"))));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("lLAOq", function(module, exports) {

let $fd8a8ae5e55b02b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd8a8ae5e55b02b3$var$load("7J1PC"),
    $fd8a8ae5e55b02b3$var$load("446Ip"),
    $fd8a8ae5e55b02b3$var$load("6wr18"),
    $fd8a8ae5e55b02b3$var$load("iYJZz"),
    $fd8a8ae5e55b02b3$var$load("jqoep"),
    $fd8a8ae5e55b02b3$var$load("ea3NB"),
    $fd8a8ae5e55b02b3$var$load("ffEVr"),
    $fd8a8ae5e55b02b3$var$load("7EorR"),
    $fd8a8ae5e55b02b3$var$load("hhss7"),
    $fd8a8ae5e55b02b3$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("eilSC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $9wMFw = parcelRequire("9wMFw");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $krYZG = parcelRequire("krYZG");


var $cSuwJ = parcelRequire("cSuwJ");


var $dUm2W = parcelRequire("dUm2W");


var $7Y8M5 = parcelRequire("7Y8M5");


var $aDSIl = parcelRequire("aDSIl");


var $4o0zT = parcelRequire("4o0zT");


var $lpNn5 = parcelRequire("lpNn5");


var $cY9xy = parcelRequire("cY9xy");


var $lEb7o = parcelRequire("lEb7o");


var $h10Mg = parcelRequire("h10Mg");

function $bf5e8c9c7e771773$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf5e8c9c7e771773$var$titleStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $7Y8M5.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $bf5e8c9c7e771773$var$titleStylesDense = {
    name: "13vs5qp",
    styles: "font-size:var(--ak-renderer-base-font-size)"
};
const $bf5e8c9c7e771773$var$containerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-radius-small, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 4px)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $bf5e8c9c7e771773$var$containerStylesExpanded = {
    name: "mpp6x6",
    styles: "background:var(--ds-surface, #FFFFFF);padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #0B120E24)"
};
const $bf5e8c9c7e771773$var$containerStylesFocused = {
    name: "pkf2kr",
    styles: "border-color:var(--ds-border-focused, #4688EC)"
};
const $bf5e8c9c7e771773$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $7Y8M5.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $7Y8M5.akLayoutGutterOffset)}px`
});
const $bf5e8c9c7e771773$var$titleContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #505258)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $bf5e8c9c7e771773$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
// Base styles for the content container. visibility:hidden hides collapsed content.
// When browser find is supported, the useEffect clears visibility:hidden after setting
// hidden="until-found" on the DOM element, which applies content-visibility:hidden natively —
// this hides the content while allowing browser Ctrl+F to index the text.
// The visibility:hidden in CSS serves as an SSR fallback (useEffect doesn't run server-side).
const $bf5e8c9c7e771773$var$contentContainerStyles = {
    name: "br2f98",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
// display:flow-root is applied only when browser find is not supported.
// It must NOT be set when browser find is supported — it overrides the
// content-visibility:hidden applied by hidden="until-found" and makes content visible.
const $bf5e8c9c7e771773$var$contentContainerStylesFlowRoot = {
    name: "12r8j1i",
    styles: "display:flow-root"
};
const $bf5e8c9c7e771773$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $bf5e8c9c7e771773$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
// When browser find is supported and expand is collapsed, we rely on the
// hidden="until-found" attribute on the outer container to hide content.
// We remove height:0/overflow:hidden/clip from the inner wrapper so the
// browser can actually search through the content.
//
// `user-select: none` must NOT be set here, unlike the variant above. WebKit scrolls to a
// find-in-page match by selecting it, so unselectable text is matched but never revealed: the
// reader is told there is a hit, the `hidden` attribute stays put, and the expand never opens.
// Chrome does not need a selection, so it hid the problem. Nothing is lost by leaving it out —
// content-visibility:hidden already makes a skipped subtree unselectable. It is only needed in the
// other variant, where the content is merely clipped and would otherwise be selectable.
const $bf5e8c9c7e771773$var$contentContainerStylesNotExpandedBrowserFind = {
    name: "d8pelj",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;}"
};
const $bf5e8c9c7e771773$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $bf5e8c9c7e771773$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $bf5e8c9c7e771773$var$containerStyles,
            props['data-node-type'] === 'expand' && $bf5e8c9c7e771773$var$containerStylesDataNodeTypeExpand,
            props.expanded && $bf5e8c9c7e771773$var$containerStylesExpanded,
            props.focused && $bf5e8c9c7e771773$var$containerStylesFocused
        ],
        "data-testid": props['data-testid'],
        "data-node-type": props['data-node-type'],
        "data-title": props['data-title'],
        "data-expanded": props['data-expanded'],
        "data-local-id": props['data-local-id']
    }, props.children);
};
const $bf5e8c9c7e771773$var$TitleContainer = (props)=>{
    const { expanded: expanded } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        css: [
            $bf5e8c9c7e771773$var$titleContainerStyles,
            expanded && $bf5e8c9c7e771773$var$titleContainerStylesExpanded
        ],
        onClick: props.onClick,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        "aria-labelledby": props['aria-labelledby'],
        "aria-expanded": props['aria-expanded'],
        contentEditable: props.contentEditable
    }, props.children));
};
$bf5e8c9c7e771773$var$TitleContainer.displayName = 'TitleContainerButton';
const $bf5e8c9c7e771773$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: props.contentRef,
        css: [
            $bf5e8c9c7e771773$var$contentContainerStyles,
            !props.enableBrowserFind && $bf5e8c9c7e771773$var$contentContainerStylesFlowRoot,
            props.expanded && $bf5e8c9c7e771773$var$contentContainerStylesExpanded,
            !props.expanded && (props.enableBrowserFind ? $bf5e8c9c7e771773$var$contentContainerStylesNotExpandedBrowserFind : $bf5e8c9c7e771773$var$contentContainerStylesNotExpanded)
        ]
    }, props.children);
};
function $bf5e8c9c7e771773$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $cY9xy.PLATFORM).WEB,
            mode: (0, $cY9xy.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
}
function $bf5e8c9c7e771773$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, localId: localId, nestedHeaderIds: nestedHeaderIds, rendererContentMode: rendererContentMode, node: node }) {
    const ancestorBody = (0, $h10Mg.useExpandBody)();
    // Shared with every expand in the chain: the element that stood in for this expand and caught the
    // find sits under an expand further out, and by the time this one mounts that element is gone.
    //
    // Built on first render rather than passed to `useRef`, which would evaluate and discard a new set
    // on every render for the life of the expand.
    const ownRevealedByFind = (0, $cozmU.useRef)(null);
    if (!ownRevealedByFind.current) ownRevealedByFind.current = new WeakSet();
    const revealedByFind = ancestorBody?.revealedByFind ?? ownRevealedByFind.current;
    /**
   * Browser find matched inside this expand while the expand above it was still collapsed, so it
   * opens as soon as it mounts — otherwise the reader would watch the outer expand open onto a
   * closed one, with the match nowhere to be seen. Empty on the server and on the first client
   * render, so hydration cannot disagree; only a find on the client ever puts anything in it.
   */ const revealedByFindOnMount = node !== undefined && revealedByFind.has(node);
    const [expanded, setExpanded] = (0, $cozmU.useState)(revealedByFindOnMount);
    const [focused, setFocused] = (0, $cozmU.useState)(false);
    /**
   * PGXT-9021: once opened, the body stays rendered even if the reader closes the expand again.
   * Throwing it away would re-run every macro and Forge fetch inside it on the next open, which is
   * slower and visibly reloads content the reader has already seen. We only wanted to save work on
   * the first page load, and by now that has happened. Starts false on both the server and the
   * first client render, so hydration cannot disagree.
   */ const [hasBeenExpanded, setHasBeenExpanded] = (0, $cozmU.useState)(revealedByFindOnMount);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode);
    const { current: id } = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9wMFw)))('expand-title-'));
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const contentWrapperRef = (0, $cozmU.useRef)(null);
    const handleFocus = (0, $cozmU.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $cozmU.useCallback)(()=>setFocused(false), []);
    // Both state updates happen in the same handler so they land in one render, rather than the
    // latch reacting to `expanded` from an effect.
    const openBody = (0, $cozmU.useCallback)(()=>{
        setExpanded(true);
        setHasBeenExpanded(true);
    }, []);
    // The browser found the text inside this expand. Opening this one is not enough: if it sits
    // inside other expands, those have to open too or the reader still cannot see it. Each expand
    // asks the one above it, so a single match opens the whole chain and nothing else.
    const openWithAncestors = (0, $cozmU.useCallback)(()=>{
        // Remembered before anything opens: a block above this expand may have been standing in for
        // itself, and rendering it rebuilds this expand. Without this it would come back closed over
        // the match the reader was just taken to.
        if (node) revealedByFind.add(node);
        openBody();
        ancestorBody?.openWithAncestors();
    }, [
        ancestorBody,
        node,
        openBody,
        revealedByFind
    ]);
    // Feature-detect hidden="until-found" support via the beforematch event. Chrome 102+,
    // Firefox 139+ and Safari 26.2+ all have it; in a browser without it, hidden="until-found" is
    // treated as plain boolean hidden (display:none), which would break the expand entirely.
    // Starts as `undefined`, meaning "we do not know yet", and is only answered in an effect. We
    // cannot check during render: the server has no browser to check, so it would say no there and
    // yes on the client, and hydration would disagree.
    const [supportsHiddenUntilFound, setSupportsHiddenUntilFound] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $1hQ0e.getDocument)();
        setSupportsHiddenUntilFound(doc?.body ? 'onbeforematch' in doc.body : false);
    }, []);
    // React 18 treats `hidden` as a boolean attribute and strips the "until-found" value,
    // rendering it as just `hidden` (which applies display:none and blocks find-in-page).
    // We bypass React by setting the attribute directly on the DOM element around the text.
    //
    // We also remove the CSS visibility:hidden (SSR fallback) once hidden="until-found" is set,
    // because visibility:hidden blocks browser find. On expanded, we restore visibility to visible.
    //
    // Only applied when the browser supports hidden="until-found" (detected via onbeforematch).
    // Without it we skip this entirely and fall back to the normal CSS hiding
    // (visibility:hidden + height:0), which doesn't support find-in-page but still works
    // correctly for expand/collapse.
    (0, $cozmU.useEffect)(()=>{
        const contentContainer = contentContainerRef.current;
        const contentWrapper = contentWrapperRef.current;
        if (!contentWrapper) return;
        if (supportsHiddenUntilFound && !expanded) {
            contentWrapper.setAttribute('hidden', 'until-found');
            // Products ship a CSS reset with `[hidden] { display: none }` — Confluence does. That is an
            // author rule, so it beats the UA stylesheet's
            // `[hidden="until-found"] { content-visibility: hidden }` and takes the content out of the
            // page altogether, where find cannot reach it. Setting display next to the attribute keeps
            // the two together, rather than relying on a class selector elsewhere out-weighing a reset
            // we do not own.
            contentWrapper.style.display = 'block';
            // Override the CSS visibility:hidden from contentContainerStyles — hidden="until-found"
            // now handles hiding via content-visibility:hidden, which allows browser find to index
            // the content. We use 'visible' (not '') because '' only clears the inline style but
            // the Emotion CSS class rule still applies visibility:hidden, blocking find-in-page.
            contentContainer?.style.setProperty('visibility', 'visible');
            contentWrapper.style.visibility = 'visible';
        } else {
            contentWrapper.removeAttribute('hidden');
            contentWrapper.style.display = '';
            contentContainer?.style.removeProperty('visibility');
            contentWrapper.style.visibility = '';
        }
    }, [
        expanded,
        supportsHiddenUntilFound
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (expanded) return;
        const contentWrapper = contentWrapperRef.current;
        const unbindWrapperBeforeMatch = contentWrapper && supportsHiddenUntilFound ? (0, $cbY7C.bind)(contentWrapper, {
            type: 'beforematch',
            listener: openWithAncestors
        }) : undefined;
        return ()=>{
            unbindWrapperBeforeMatch?.();
        };
    }, [
        expanded,
        openWithAncestors,
        supportsHiddenUntilFound
    ]);
    // While this is false, the blocks of the body show their text instead of rendering. It is true
    // when:
    // - the expand is open, or has been opened before, so the reader wants to see the content;
    // - no node was given, so this expand never opted into lazy loading;
    // - the browser has no hidden="until-found", so the text would not be findable and standing it in
    //   would gain nothing. While we still do not know, we assume the browser has it — assuming the
    //   opposite would render the whole body on the first paint and lose the saving entirely.
    const revealed = expanded || hasBeenExpanded || !node || supportsHiddenUntilFound === false;
    const expandBody = (0, $cozmU.useMemo)(()=>({
            revealed: revealed,
            openWithAncestors: openWithAncestors,
            revealedByFind: revealedByFind
        }), [
        revealed,
        openWithAncestors,
        revealedByFind
    ]);
    const body = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $h10Mg.ExpandBodyProvider), {
        value: expandBody
    }, children);
    return /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        "data-local-id": localId,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lEb7o.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: openBody
    }) : null, /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$TitleContainer, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $bf5e8c9c7e771773$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            // Recorded so a product remounting this expand under its own body gets it back as the
            // reader left it.
            const recordsToggle = node !== undefined && (0, $4o0zT.isExperimentEnabled)('cc_light_mode_table_virtualization');
            if (expanded) {
                setExpanded(false);
                if (recordsToggle) revealedByFind.delete(node);
            } else {
                openBody();
                if (recordsToggle) revealedByFind.add(node);
            }
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cSuwJ.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: label,
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cSuwJ.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: label,
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $bf5e8c9c7e771773$var$titleStyles,
            rendererContentMode === 'compact' && $bf5e8c9c7e771773$var$titleStylesDense
        ],
        id: id
    }, title || intl.formatMessage((0, $cSuwJ.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $lOiVq.jsx)($bf5e8c9c7e771773$var$ContentContainer, {
        expanded: expanded,
        enableBrowserFind: supportsHiddenUntilFound,
        contentRef: contentContainerRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: `${nodeType}-content-wrapper`,
        ref: contentWrapperRef
    }, revealed ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $bf5e8c9c7e771773$var$clearNextSiblingMarginTopStyle
    }), body) : body)));
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $bf5e8c9c7e771773$var$_default_1 = (0, $kSwu1.injectIntl)($bf5e8c9c7e771773$var$Expand);
var $bf5e8c9c7e771773$export$2e2bcd8739ae039 = $bf5e8c9c7e771773$var$_default_1;
module.exports["default"] = $bf5e8c9c7e771773$export$2e2bcd8739ae039;

});

parcelRegister("9wMFw", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/** Used to generate unique IDs. */ var $6efcdace0fb66c85$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6efcdace0fb66c85$var$uniqueId(prefix) {
    var id = ++$6efcdace0fb66c85$var$idCounter;
    return $dojlP(prefix) + id;
}
module.exports = $6efcdace0fb66c85$var$uniqueId;

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    },
    expandBodyAriaLabel: {
        id: "editor-common.Expand.expandBodyAriaLabel",
        defaultMessage: "Body content for {title}"
    },
    expandBodyAriaLabelUntitled: {
        id: "editor-common.Expand.expandBodyAriaLabelUntitled",
        defaultMessage: "untitled expand"
    },
    expandBodyAriaDescription: {
        id: "fabric.editor.expandBodyAriaDescription",
        defaultMessage: "Enter the content that will be revealed when this expand is opened."
    },
    expandBodyRoleDescription: {
        id: "fabric.editor.expandBodyRoleDescription",
        defaultMessage: "macro"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("gWbtJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $de127ad6a6b1acf7$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

function $de127ad6a6b1acf7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-sync-block": true,
        "data-local-id": props.localId,
        "data-resource-id": props.resourceId
    });
}

});

parcelRegister("30QUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $99af99aba878edda$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $95bQO = parcelRequire("95bQO");

function $99af99aba878edda$export$2e2bcd8739ae039(props) {
    const { children: children, localId: localId, resourceId: resourceId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-bodied-sync-block": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $95bQO.BodiedSyncBlockSharedCssClassName).renderer,
        "data-local-id": localId,
        "data-resource-id": resourceId,
        children: children
    });
}

});

parcelRegister("69Kfj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eJXnW = parcelRequire("eJXnW");

const $c29efbee18d37f33$export$679584c8d36ab911 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (configs)=>{
    const $ = (0, $bDgLe.c)(5);
    const [atlassianPlugins] = (0, $cozmU.useState)($c29efbee18d37f33$var$_temp);
    let t0;
    if ($[0] !== atlassianPlugins || $[1] !== configs) {
        let t1;
        if ($[3] !== atlassianPlugins) {
            t1 = (config)=>{
                const existingPlugin = atlassianPlugins.get(config);
                if (existingPlugin) return existingPlugin;
                const newPlugin = new (0, $eJXnW.default)(config);
                atlassianPlugins.set(config, newPlugin);
                return newPlugin;
            };
            $[3] = atlassianPlugins;
            $[4] = t1;
        } else t1 = $[4];
        t0 = configs.map(t1);
        $[0] = atlassianPlugins;
        $[1] = configs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (configs)=>{
    const [atlassianPlugins] = (0, $cozmU.useState)(()=>new WeakMap());
    return (0, $cozmU.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $eJXnW.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};
function $c29efbee18d37f33$var$_temp() {
    return new WeakMap();
}
module.exports["useAtlassianPlugins"] = $c29efbee18d37f33$export$679584c8d36ab911;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("i8tPN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $24dy7 = parcelRequire("24dy7");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8940fb02b7c06f89$var$ErrorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$PrimaryText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$SecondaryText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzKGUX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzKGUX",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$RedText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzAyGJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$errorIconStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $8940fb02b7c06f89$export$500ff750b69ba110 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $8940fb02b7c06f89$var$errorIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            spacing: "none"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== isSpaceSelectionError || $[2] !== primaryText) {
        t2 = isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), primaryText));
        $[1] = isSpaceSelectionError;
        $[2] = primaryText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isTagDisplayError || $[5] !== primaryText || $[6] !== secondaryText) {
        t3 = isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryText)));
        $[4] = isTagDisplayError;
        $[5] = primaryText;
        $[6] = secondaryText;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
            "data-testid": "classification-level-error"
        }, t1, t2, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
        "data-testid": "classification-level-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $8940fb02b7c06f89$var$errorIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        spacing: "none"
    })), isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), primaryText)), isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryText))));
module.exports["ClassificationLevelError"] = $8940fb02b7c06f89$export$500ff750b69ba110;

});

parcelRegister("2O7oS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b3j2Y = parcelRequire("b3j2Y");


var $i8tPN = parcelRequire("i8tPN");


var $earLp = parcelRequire("earLp");


var $93WhG = parcelRequire("93WhG");

const $0a7aa4ef87c7240f$export$91f86b39c4eb641 = ({ contentLevelError: contentLevelError, spaceLevelError: spaceLevelError, primaryText: primaryText, secondaryText: secondaryText })=>{
    const { trackRenderTagError: trackRenderTagError } = (0, $earLp.useTrackClassificationAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        const errorMessage = [
            contentLevelError?.message,
            spaceLevelError?.message
        ].filter(Boolean).join(' | ') || 'Unknown error';
        trackRenderTagError(errorMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, contentLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentLevelError
    }) : null, spaceLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: spaceLevelError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i8tPN.ClassificationLevelError), {
        primaryText: primaryText || (0, $93WhG.sharedMessages).fetchErrorTextPrimary,
        secondaryText: secondaryText || (0, $93WhG.sharedMessages).fetchErrorTextSecondary,
        isTagDisplayError: true
    }));
};
module.exports["ClassificationTagButtonError"] = $0a7aa4ef87c7240f$export$91f86b39c4eb641;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("fgMWo"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("fgMWo", function(module, exports) {

let $b1de50428cab9222$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b1de50428cab9222$var$load("6wr18"),
    $b1de50428cab9222$var$load("dlm6q"),
    $b1de50428cab9222$var$load("ffEVr"),
    $b1de50428cab9222$var$load("7EorR"),
    $b1de50428cab9222$var$load("ea3NB"),
    $b1de50428cab9222$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("jPcvk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("kHxMe"));
        return EditorContentModeButton;
    }
});
module.exports["EditorContentModeButton"] = $7e7400ce50234362$export$a8e3305d336ef5aa;

});

parcelRegister("kHxMe", function(module, exports) {

let $f122062b8fd24914$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f122062b8fd24914$var$load("cC68k").then(()=>parcelRequire('iI06X'));

});

parcelRegister("5e34M", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("9nTTP"))).EmojiTitleButton
});
module.exports["EmojiTitleButtonLoader"] = $0c67d43e155b2cd3$export$8ce5c583c1fa5a96;

});

parcelRegister("9nTTP", function(module, exports) {

let $6d519f7cdc4b0a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d519f7cdc4b0a03$var$load("9LDVS"),
    $6d519f7cdc4b0a03$var$load("kiMHu"),
    $6d519f7cdc4b0a03$var$load("6wr18"),
    $6d519f7cdc4b0a03$var$load("dlm6q"),
    $6d519f7cdc4b0a03$var$load("el56J"),
    $6d519f7cdc4b0a03$var$load("ffEVr"),
    $6d519f7cdc4b0a03$var$load("20wSi"),
    $6d519f7cdc4b0a03$var$load("8OeKT"),
    $6d519f7cdc4b0a03$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});


//# sourceMappingURL=SpaceOverviewSwitcher.6af43725.js.map
